(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [];


// symbols:
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.RubberDuckieBeak = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DB6F02").s().p("Ag7AMQgdgNgLgMQCFAABCgVQgEAOgLARQgaAmgvAAQgZAAgugXg");
	this.shape.setTransform(19.1,13.8);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF9933").s().p("AhbA+IgNgBIgMgBQghgDgQgHQgRgIAAgNQAAgNAPgHQAKgEAmgLQAwgSAfgdQANgLAjAFQATADAbAHQAnAIBBAJQARACAHATQAHAPg0AYIgOAHIgPAGQhBAViAAAIgGAAg");
	this.shape_1.setTransform(18.3,6.2);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#F47B02").s().p("AhPAMIglgeIgKgJIAMABIANAAQALAMAdAOQAuAXAZAAQAvAAAagmQALgSAEgOIAPgGIAOgGQgCAQghAsQgrA7grAAQgZAAg8gwg");
	this.shape_2.setTransform(19.3,15);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.RubberDuckieBeak, new cjs.Rectangle(0,0,36.6,21.1), null);


(lib.Wall = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer 2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	mask.graphics.p("Eht2gvcIcrNDIAxARIANAFMCgZAAAIA/AAIa5s4MABzBdXI703EIhIAAIAAAGIgvAAMidAAAPIi7ABIgrAcIgxAgI8jWzg");
	mask.setTransform(604.5,49.7);

	// Layer 342
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFAEE").ss(2,1,1).p("EAF/AjOMgA5hKjEgFDArxMgA7hW6EACvAlPMgA5hQ/EgAqAoeMgA8hQq");
	this.shape.setTransform(-19.6,35.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f().s("#FFFAEE").ss(1.5,1,1).p("EhRUAiTMgAwhElEhOiAf5MgAwhA1EhBMAbNMgAog4sEhFaAbNMgAog4sEgtXAbNMgAng4sEgysAclMgApg6EEg3pAclMgApg6EEg8XAclMgApg6EEgohAclMgApg6EEgj0AclMgAog6EA6BbNMgAog4sA+3clMgAog6EA1zbNMgAog4sAw+clMgApg6EAsQclMgApg6EAnTclMgApg6EAMhclMgAog6EAHkclMgAog6EAC3clMgApg6EAh+bNMgAng4sEAu/AclMgAog6EEApqAbNMgAog4sEAkUAclMgAog6EAfXclMgApg6EAaqclMgApg6EAV0bNMgAog4sARmbNMgAog4sEAz9AclMgApg6EEA+PAclMgAog6EEA46AclMgApg6EEBC9AclMgApg6EEBH6AclMgApg6EEBSFAclMgApg6EEBNPAbNMgAng4s");
	this.shape_1.setTransform(559.3,26.1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f().s("#FFFAEE").ss(1,1,1).p("EgAiAgAMgArg//ABOd9MgApg75");
	this.shape_2.setTransform(71.4,16.7);

	var maskedShapeInstanceList = [this.shape,this.shape_1,this.shape_2];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer 345
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FFFAEE").ss(2,1,1).p("ANwM5IgEACI7fLJEgNvgnOIa8KRAtv8PIbIHPANL5MI66ouANdocI7ThSANZsoI7PjVANSwyI7BlMANhj4I7NAfANwIyI7fIMAN3U9I7qSSANhAVI7QDWANlEiI7UFp");
	this.shape_3.setTransform(1.8,43.6);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f().s("#FFFAEE").ss(1.5,1,1).p("EhDAgaOIAmAAMCeKgADICHAAEhDEgd8MCe0gADICHAAEhC2gV8IAcAAMCeKgADICHAAEhC2gRxIAcAAMCeKgADICHAAEhC4gNmIAXAAMCeKgADICGAAEhChgJUIAHAAMCeKgADICHAAEhChgEzIAHAAMCeKgADICWAAEhChgAoIAHAAMCeKgADICWAAEhChADiIAHAAMCeKgADICWAAEhChAH0IAHAAMCeKgADICWAAEhClAL9IAIACMCeKgADICVAAEBeCAPxIiVAAMieKAADI7oOMEhCaAT/MCeHgADICVAA");
	this.shape_4.setTransform(515.6,49.9);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f().s("#FFFFFF").ss(1.5,1,1).p("AgTsZIAqAAAgToNIAqAAAgTkCIAqAAAgTAPIAqAAAgWEaIAqAAAgWMaIAqAAAgWIPIAqAA");
	this.shape_5.setTransform(1119.7,98.1);

	var maskedShapeInstanceList = [this.shape_3,this.shape_4,this.shape_5];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4},{t:this.shape_3}]}).wait(1));

	// Layer 340
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#F5DFC7").s().p("EgNyApkMAAChXHIMmFtIAAAFIANAAILkFQICaBFIAAANMAAyA4zI2jSAIlCEAg");
	this.shape_6.setTransform(2.2,49.3);

	var maskedShapeInstanceList = [this.shape_6];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(1));

	// Layer 339
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f().s("#FFFFFF").ss(1,1,1).p("AgicYIgDjxIgDkVIgCj5IgDkMIgDkSIgCkRIgDkcIgDkbIgDkPIgCkNIgDkNIgDkXIgCj7IgDjZABJeSIgBgnIgCj+IgDkkIgDkFIgDkXIgDkdIgCkZIgDknIgDkiIgDkXIgDkUIgDkWIgDkdIgCkAIgCjh");
	this.shape_7.setTransform(1133.3,22.8);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f().s("#FFFFFF").ss(1.5,1,1).p("Ahx/8IACDqIADEGIADEjIACEfIADEcIADEfIADEqIADEzIADEjIADEnIADEjIADERIADE1IACENIABAiEAByAhRIAAgxIgDkkIgElPIgDkmIgDk4IgDk4IgDkyIgDlHIgDk1IgDkuIgDkoIgDkvIgDksIgDkQIgDj4");
	this.shape_8.setTransform(1159.5,28.3);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f().s("#FFFFFF").ss(2,1,1).p("EAHjgk4IgDk9IAAgHAuF43IBGgWIBqgjIBygkIC6g8IDQhEIgDkbIjQBPIi5BGIhzArIhqAoIhEAZIgEACAjW3eIjQA5Ii6AzIhyAfIhrAdIhGATAuBwbIBHgNIBrgVIBygVIC6gkIDPgnIDQgoIgDlRAjOoqIjPAKIi7AJIhyAFIhqAFIg6ADAjRtnIjPAaIi6AWIhzAOIhqANIhIAJEAHjgk4IAEFBIFAhoADP+dIgDkyIEXhpIE9h3AMv73IlFBZIAEF6IADFnADS5SIEYhMIgDlZIkYBagEgDegk3IACEIIDQhOIACEmIDZhGAjW3eIDPg4IgDlBIjPBDgAABo0IgClMIjQAZIADE9IDPgKIDbgKIgDldIEYgiIAEFxIFTgQAjRtnIgDk2IgClBAgBuAIgDlFIDagqIgEljIjZA8AHu0kIFJg/IAJF9IlPApADWzvIADFUIjaAbAHu0kIkYA1AH1pMIkZAOIAEFfIEZAFIFYAGEADMgjPIjYBSIgDkXEADJgn3IADEoAIJVvIFtCTIgKnCIlnhqIkbhUIAEF7IEbByIAEGLIAFHTIkci6IADF0IABAlADnIQIgElnIjbgbIADFVgANaD1IldgqIAEF+IAEGNIAEGZADgjfIADGIIEaAiIgEmlIgElyAAEjjIjPgEIADFcIDQAZIgElxIDcAEAt5AhIBKAJIBrANIByAOIC7AXIDPAZIACFDIDRArIADFeIDcBBIgDlyAt7jzIBJABIBrACIByACIC7ADIDPAEAt3EsIBLAPIBrAWIByAXIC8AmIDNAqIADFLIADFNIDRBVIgDlkIjRg+At1I3IBMAXIBrAfIByAiIC8A4IDNA8AtzM7IBMAfIBsArIByAuIC8BLIDNBSIADE9IDRBrIgDlTAtwU0IBPAzIBrBGIBzBLIC8B7IDNCGIADE9IAAAqAi9WNIjNhpIi8hgIhzg7Ihrg3IhNgnADuT9IjdhYAIBJJIkag5AINb6IkbiRIAEGqAAYeCIjSiJIgDlsAAYeCIADFZIAAAEEAIWAp9IAAgZIgEmXIF5D2AAYeCIDeCRAAUX4IDeBxIgElsAAUX4IAEGKANjKRIlihIAOAe3Ilzi9AABo0IADFRAjOoqIADFD");
	this.shape_9.setTransform(1209.8,42);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#F5DFC7").s().p("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");
	this.shape_10.setTransform(1210.4,48.9);

	var maskedShapeInstanceList = [this.shape_7,this.shape_8,this.shape_9,this.shape_10];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7}]}).wait(1));

	// Layer 189
	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#F5DFC7").s().p("EhQDALAIgHuNIge5NIAiAAMCeRAAAIAKAAIB7AAMAAZA4TIiUABIgKAAMid5AAhg");
	this.shape_11.setTransform(602.5,18.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_11).wait(1));

	// White
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFAEE").s().p("Eht2gvcIcrNDIAxARIANAFMCgZAAAIA/AAIa5s4MABzBdXI703EIhIAAIAAAGIgvAAMidAAAPIi7ABIgrAcIgxAgI8jWzg");
	this.shape_12.setTransform(604.5,49.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_12).wait(1));

}).prototype = getMCSymbolPrototype(lib.Wall, new cjs.Rectangle(-98.6,-254,1406.3,607.4), null);


(lib.towelrack_background = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DEDEDE").s().p("AgwAnQgEgPAFgVQAFgXALgKQAZgWAggLQAOgEAHAaQAEATAAASQAAAhgCAFQgJAegrAAQggAAgNgZg");
	this.shape.setTransform(126.7,6.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 3
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#CCCCCC").s().p("AhFAzIgDgeQAAglAXgWIASgSQALgJAPgFQASgHARACQARACAKALQAJAJACAQIADAgQADASgBAMQgCAPgKALQgNANgMAFQgOAGgZABIgJAAQguAAgLgZg");
	this.shape_1.setTransform(124.2,5.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 2
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#999999").s().p("ApMAVQgHgMAAgJQAAgeAlgGIRdAAQAXAGAIALQAGAIAAAMQAAALgIAKQgKAMgTADIxdAAIgEAAQgQAAgKgQg");
	this.shape_2.setTransform(65.6,6.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 1
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#CCCCCC").s().p("AhLAvIgCgeQAAgmAWgVQAUgTApgJQAqgJASAVQATAWgKAhQgKAhgOASQgVAagrAAQgyAAgMgbg");
	this.shape_3.setTransform(7.8,6.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

}).prototype = getMCSymbolPrototype(lib.towelrack_background, new cjs.Rectangle(0,-1.9,131.8,15.5), null);


(lib.towel_background = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0099FF").s().p("AkiGJQgFgCAAgEQAAgEAIgVQALgeARgaQA1hTBZgSQAggGA6gcQA3gbAUgSQA9g0gGg/QgDgSgIgUIgJgRQAAgjAyg6QAtg1AogXQA8giAiguQAUgaAYg2QAIAEgCAIQgOA3gjAmQgWAXg0AjQg2AlgZAZQgqArgXA8QATASAGAZQAEAOAAAbQAAAtg8AyQhAA2hbAUQhdAUgxBEQgQAWgPAgIgVAqQAAAAAAAAQgBABAAAAQAAAAgBAAQAAAAgBAAIgCAAgAllFbQgEgBAAgEQAAgFAIgUQALgdASgZQA2hQBbgRQAhgGA8gbQA5gaAVgSQA9gygGg8QgDgSgJgTIgIgQQAAgjAzg4QAtgyAqgXQA9ghAjgsQAUgZAag0QAHADgCAIQgOA1gkAlQgXAWg1AjQg4AjgZAYQgrAqgXA6QATAQAGAZQAEAOAAAaQAAArg+AwQhBA0hdATQhfATgzBDQgQAUgQAgIgVAoIgCABIgEAAg");
	this.shape.setTransform(293.4,54.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFCC").s().p("AAyKUIhZg4Qgvghheg2Qheg1hzhLQhzhKiIhxIhBg1QgfgegNgcQgghHBAh6QBVijDqkBQDpkABACUQBACVFFCSQFHCSCJB2QAlAah4CCQhHBOgOARQgmAvAJAPIATAQQATAOAIAPQAcAvhCA9QhPBKhZAeQhlAYg4ASQhcBMgCAuQgBAWgWAAQgXAAgwgZg");
	this.shape_1.setTransform(256.9,26.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.towel_background, new cjs.Rectangle(180.9,-41.7,152.1,137.1), null);


(lib.SoapName = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDB4FE").s().p("AAACfIgNgSIAAgZIgjAKQgIAAAAgGQAAgIAtgMIAsgKQAHAAAEAGQAEAFAEAPIAAAYQgGAOgNAFQgHACgNAAQgLAAgCgCgAAOBrQgMAEAAAKIAAAQQAFAEACAFQADACACAAQAQAAAGgJIAAgWQgBgNgGAAQgIAAgHADgAgxBZQgHgBgBgFQAAgCAagGIAAguIgDABQgJAEgEAAQgJAAAAgHQABgGARgEIATgEQAOAAASAPQAYATgSAVQgSAOgMAEQgKADgTAAIgJAAgAgPAfIAAAoQAagHAAgOQAAgGgOgJIgOgIIACAEgAgmADQgRgEAAgTQABghASgJQAIgEATAAQAaAAAOALQAMAKgCAPQgEAjg3AAQgPAAgFgCgAgbgyQgMAFAAARIAAAPQAEAEAHABIAKAAQAlAAAEgTIAAgHQgNgQgEgCQgBgBgOAAQgNAAgFADgAgqhXQgPgGAAgXQABgLAGgJQAGgHAEAAQAIAAAAAHIgFAJQgEAHAAAEQAAANAJAEIAKAAIAIAAQAFgDAAgNQAAgMgDgDQgBgEAAgGQAAgOAMgEQAEgCAKAAQAjAAAKAXIAAAcQgDAHgFAAQgIAAAAgHIgBgbQgIgLgUAAQgKAAgBAEQAEAUAAAHQABAXgNAGQgEACgMAAQgQAAgEgCg");
	this.shape.setTransform(5.8,16.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SoapName, new cjs.Rectangle(0,0,11.5,32.3), null);


(lib.SoapDish = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F5DFC7").s().p("AlBAvQgGgNAAgQIACgOQAAhTBIgIQAUgCAvADQAtADAVgDIGVAAQAlALAFAXQADAOgFAjQAAAngQANQghAbh5AIIk7ACIg+ADQhPAAgUgqg");
	this.shape.setTransform(32.8,8.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.SoapDish, new cjs.Rectangle(0,0,65.6,17.8), null);


(lib.safeguide = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Notes
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FF0000").s().p("EAT2A1NQgGgEgEgJQgEgIgBgMIgBgZIAAgZQABgNAEgQIAgADQgDAiAAANQAAATABAIQABAHADADQADAEAEAAQAHAAAHgFQAHgFAEgIQAAgWgCgwIAhgCIAEBuIgdADQgCgGAAgIQgGAHgKAFQgPAFgJAAQgLAAgIgFgEAP8A1OQgLgDgIgHQgKgHgFgLIgEgMQgBgGAAgIQAAgNAEgLQAFgKAIgIQAIgIALgFQALgEAMAAQALAAAKADQAJAEAHAGQAHAHAEAIQADAJAAALQgFAEgJAEQgIAEgLACQgcAFgNABQABAGACAFQADAEAEADQAHAFALAAQAKAAAHgFQAGgFAFgKIAWANQgDAIgFAFQgFAGgHAFQgHAEgIACQgJACgJAAQgLAAgLgDgEAQAAz7QgEADgCAFQgCAFgBAGQARgBAagDQgBgKgGgFQgFgFgIAAQgJAAgFAFgEAJbA1OQgLgDgKgFQgJgGgHgHQgGgIgDgKIAegQQACAHADAGQAEAGAGADQAFAEAIACQAHACAJAAQALAAAGgFQAEgDACgEQACgEAAgFQAAgIgHgGQgFgEgIgDQgigKgOgHQgLgFgGgIQgDgFgCgFQgCgGAAgHQAAgKAFgJQAEgJAIgGQAJgHAMgEQAMgDAPAAQAKAAAIABQAKACAIADQAJAEAGAGQAIAHADAJIgfAOQgBgFgDgDQgDgEgEgDQgFgCgGgBQgFgCgHAAQgNAAgIAEQgHAEAAAHQAAAFAEAFQADADAHADIAgAKIARAHQAJAEAFAFQAHAFAEAIQAEAIAAALQAAAMgFAKQgFALgIAHQgJAIgLAEQgNAEgOAAQgLAAgLgDgEAG0A1QIgOgEQgHgDgGgEIgLgJQgFgFgEgGIgHgNQgDgIgBgIQgBgIAAgKIABgSIAEgRQACgIAEgIQAEgHAFgHIALgMQAHgFAHgDQAIgEAJgCQAJgCAKAAQAJAAAJACQAIABAHADQAHADAHAEQAGAEAFAGQAFAGAEAHIAGAPQADAIABAKIABAUQAAAJgBAJQgCAIgDAIQgCAHgFAHQgEAGgFAGIgMAKQgHAEgIADQgHADgJABQgJACgKAAgEAG2AzGQgHAEgGAIQgFAIgDAKQgDAKAAAMQAAAPADAMQADAKAFAIQAGAHAHADQAHAEAKAAQALAAAJgEQAIgEAGgGQAFgHACgJQADgJAAgLQAAgRgDgMQgCgMgGgJQgFgIgIgEQgIgEgKAAQgKAAgJAFgEAOVAzvIgnBeIgcACIgihXIAABWIgfAAIAAilIAlgBQAaA/AUA3QAQglAghRIAlAAIAAAjQABBVACAuIgkABQgDg6AAgmgEASmA0EQgBgHgCgDQgCgEgEAAQgIAAgIAHQgIAGgFAMIAAA+IgiABIgBhtIAdgCQAEAGAAAJQAIgHAIgFQAKgFAJAAQAMAAAJAEQAHAFAFAIQAEAIACAMIABAaIACAxIgiABIgDhKgEAE9AzfIAhgBIAABtIghADgEAFAAzNQgHgGAAgIQAAgIAGgFQAGgFAJAAQAJAAAGAGQAGAGAAAHQAAAIgGAFQgGAGgIAAQgIAAgHgGgEBTygd/QgKgEgIgHQgHgHgFgLQgEgKAAgOQAAgNAEgMQAEgLAIgIQAIgJAMgEQAIgDAUgCQAMAAAKADQALAEAHAHQAIAHAEALQAEALAAAPQAAANgEAMQgFALgJAIQgIAIgMAFQgLAEgOAAQgMAAgLgEgEBUCgfWQgFADgEAEQgDAEgCAFQgCAGAAAGQAAAKACAHQABAHAEAFQADAEAFACQAFADAGAAQAGAAAFgDQAFgCAEgFQADgEACgGQABgGAAgIQAAgJgBgGQgCgHgDgEQgEgEgEgCQgFgCgGAAQgGAAgFACgEBYHgd/QgLgDgJgHQgJgHgFgLIgEgMQgCgGAAgIQAAgNAFgLQAEgKAIgIQAIgIALgFQALgEANAAQALAAAJADQAKAEAHAGQAGAHAEAIQAEAJAAALQgFAEgJAEQgJAEgKACQgdAFgNABQABAGADAFQADAEAEADQAHAFAKAAQAKAAAHgFQAHgFAEgKIAXANQgEAIgFAFQgFAGgHAFQgGAEgJACQgIACgKAAQgLAAgKgDgEBYKgfSQgDADgCAFQgDAFgBAGQASgBAZgDQAAgKgGgFQgGgFgIAAQgIAAgGAFgEBV2geBQgKgDgGgEQgHgGgCgIIAdgLQACAHAJADQAHAEAKAAQAHAAAFgDQAFgDAAgEQAAgEgFgDQgFgCgJgCQgagHgKgFQgHgEgEgFQgEgGAAgIQAAgJAEgIQAFgHAIgFQAHgFAKgCQAKgDALAAQAOAAALAEQAGADAFAEQAFAEADAGIgaAPQgDgFgGgDQgGgCgHAAIgMABQgFACAAADQAAAEAJAEQAHAEAMADIANADIAOAGQAHAEADAGQAFAGAAAHQAAAKgEAHQgEAHgIAFQgHAFgJACQgKADgLAAQgTgBgLgEgEBQcgd+QgIgCgHgDIgOgIIgLgKIgJgMQgEgHgCgHIgEgQIgCgQQAAgKACgJIAEgQIAHgPIAJgNQAGgGAGgEQAGgFAIgDIAPgFQAJgBAJAAQAOAAALADQAMADAJAHQAKAHAGAKQAGALACAPIgfADIgEgNQgDgGgEgEQgEgEgGgDQgFgCgHAAQgNAAgKAEQgKAFgGAIQgFAIgDALQgDAJAAAMQAAAMADAKQADALAGAIQAGAIAIAFQAJAFALAAQAIAAAHgDQAGgCAGgFQAFgFAFgHQAEgHAEgKIAYAPQgEAKgGAJQgHAJgIAHQgKAIgLADQgNAFgOAAQgJAAgJgCgEBSUggoIAiAAQAABugCA5IghACQABhGAAhjgEAT2gorQgGgFgEgIQgEgIgBgMIgBgaIAAgYQABgNAEgQIAgACQgDAiAAANQAAATABAJQABAGADAEQADAEAEAAQAHAAAHgFQAHgFAEgJQAAgVgCgwIAhgDIAEBvIgdACQgCgGAAgHQgGAHgKAEQgPAFgJAAQgLAAgIgEgEAP8goqQgLgEgIgGQgKgIgFgKIgEgMQgBgHAAgHQAAgNAEgLQAFgLAIgIQAIgIALgEQALgFAMAAQALAAAKAEQAJADAHAHQAHAGAEAJQADAIAAALQgFAFgJAEQgIADgLADQgcAFgNAAQABAHACAEQADAFAEACQAHAGALAAQAKAAAHgGQAGgFAFgKIAWAOQgDAHgFAGQgFAGgHAEQgHAEgIADQgJACgJAAQgLAAgLgDgEAQAgp9QgEADgCAEQgCAFgBAGQARAAAagEQgBgJgGgFQgFgFgIAAQgJAAgFAFgEAJbgorQgLgCgKgGQgJgFgHgIQgGgIgDgKIAegPQACAHADAFQAEAGAGAEQAFAEAIABQAHACAJAAQALAAAGgFQAEgCACgEQACgEAAgGQAAgIgHgFQgFgEgIgEQgigJgOgHQgLgGgGgIQgDgEgCgGQgCgFAAgHQAAgLAFgJQAEgIAIgHQAJgHAMgDQAMgEAPAAQAKAAAIACQAKABAIAEQAJAEAGAFQAIAHADAJIgfAPQgBgFgDgEQgDgEgEgCQgFgDgGgBQgFgBgHAAQgNAAgIAEQgHADAAAHQAAAGAEAEQADAEAHADIAgAKIARAGQAJAEAFAFQAHAGAEAHQAEAJAAAKQAAANgFAKQgFAKgIAIQgJAHgLAEQgNAEgOAAQgLAAgLgDgEAG0gopIgOgEQgHgCgGgEIgLgJQgFgFgEgHIgHgNQgDgHgBgIQgBgJAAgJIABgSIAEgSQACgIAEgHQAEgIAFgGIALgMQAHgFAHgEQAIgEAJgBQAJgCAKAAQAJAAAJABQAIABAHADQAHADAHAFQAGAEAFAGQAFAFAEAHIAGAQQADAIABAJIABAVQAAAJgBAIQgCAJgDAHQgCAIgFAGQgEAHgFAFIgMAKQgHAEgIADQgHADgJACQgJABgKAAgEAG2gqzQgHAEgGAJQgFAHgDALQgDAKAAALQAAAQADALQADALAFAHQAGAHAHAEQAHADAKAAQALAAAJgEQAIgDAGgHQAFgGACgKQADgIAAgMQAAgQgDgNQgCgMgGgIQgFgIgIgEQgIgEgKAAQgKAAgJAEgEAOVgqJIgnBeIgcABIgihWIAABWIgfAAIAAilIAlgCQAaA/AUA4QAQgmAghRIAlABIAAAiQABBVACAuIgkABQgDg5AAgmgEASmgp1QgBgGgCgEQgCgDgEAAQgIAAgIAGQgIAHgFALIAAA/IgiABIgBhtIAdgCQAEAFAAAKQAIgIAIgEQAKgGAJAAQAMAAAJAFQAHAEAFAJQAEAIACAMIABAZIACAxIgiACIgDhLgEAE9gqZIAhgBIAABtIghADgEAFAgqrQgHgHAAgIQAAgHAGgGQAGgFAJAAQAJAAAGAHQAGAGAAAGQAAAIgGAGQgGAGgIAAQgIAAgHgGgEhWVgxhQgNgDgLgHQgLgHgHgKQgHgJgCgKIAkgVQAJAQAKAJQAMAIAQAAQAKAAAIgCQAKgCAGgFQAHgEAEgHQAEgHAAgJQAAgMgGgIQgEgHgKgEQgJgEgPgBIgegBIgCgcIAfgFQANgDAIgEQAJgEAEgGQAEgHAAgJQAAgLgMgHQgKgGgSAAQgOAAgLAIQgLAJgGAQIgggaQAFgJAHgIQAIgIAJgGQALgHANgEQAOgEAQAAQARAAAPAEQAPADAMAIQALAHAHALQAGALAAAOQAAAJgDAIQgDAJgGAHQgHAHgJAFQgJAFgMADQANADAKAGQALAGAHAHQAIAIADAKQAEAKAAALQAAAQgIANQgIAMgPAJQgOAJgTAFQgTAEgVAAQgPAAgOgEgEhJ9gyXQgkApgLARIgmgOQAGgRA3g6QgJgNg2g7IAtgOQAFACASATQAQASAMAPIAZgfQARgTAJgGIAlAQQg1A1gMAPQALAQA4A9IgwAQQgngqgMgQgEg+7gxgQgKgCgJgEQgJgEgHgGIgMgOQgHgKgJgbQgFgVAAgcQAAgRAHggIAIgVQAFgJAHgIQAGgJAIgGQAJgHAJgEQAJgFALgCQALgCAMAAQAMAAAKACQAKACAJAEQAIAEAHAGQAHAFAGAIQALAOAGAUQAFAVAAAYQgCAlgDAPIgIAWQgEALgGAJQgHAIgHAHQgIAHgKAFQgKAEgMADQgMACgNAAQgMAAgLgCgEg+0g0fQgJAIgFAOQgFANgCARIgCAgQAAAPADANQACANAFAKQAFAJAIAFQAIAGALAAQANAAAKgHQAIgGAGgLQAFgLADgQQACgOAAgTQAAgQgCgNQgDgPgFgKQgFgMgIgGQgIgHgMAAQgOAAgJAIgEhPVgxgQgKgCgJgEQgJgEgHgGIgMgOQgHgKgJgbQgFgVAAgcQAAgRAHggIAIgVQAFgJAHgIQAGgJAIgGQAJgHAJgEQAJgFALgCQALgCAMAAQAMAAAKACQAKACAJAEQAIAEAHAGQAHAFAGAIQALAOAGAUQAFAVAAAYQgCAlgDAPIgIAWQgEALgGAJQgHAIgHAHQgIAHgKAFQgKAEgMADQgMACgNAAQgMAAgLgCgEhPOg0fQgJAIgFAOQgFANgCARIgCAgQAAAPADANQACANAFAKQAFAJAIAFQAIAGALAAQANAAAKgHQAIgGAGgLQAFgLADgQQACgOAAgTQAAgQgCgNQgDgPgFgKQgFgMgIgGQgIgHgMAAQgOAAgJAIgEhTwgyLIArgeQAXgQAQgPQASgSAKgQIAIgRQACgJAAgIQAAgPgJgHQgJgGgQAAQgIAAgGAEQgGAEgFAIQgIALgEAVIgqgFQAAgPAFgOQAGgPALgLQALgNAPgGQAQgIAUAAQARAAAPAEQAPAEAMAIQALAJAHAMQAGANAAARQAAALgCAKQgDAKgFAKQgQAYgLALQgPAPgVAOQgQAMgWANIAhAAQAcAAA7AFIgJAnQgogDghAAIheADgEhCvgxjQgQgDgLgIQgLgIgGgMQgGgMAAgPQAAgKADgJQAEgJAGgJQAGgIAIgGQAIgHAKgEQgSgFgJgMQgFgFgDgHQgCgHAAgHQAAgJACgIQACgHAFgHQAIgMAOgJQANgIARgEQAPgEAQAAQAOAAANACQAQACAMAGQAOAHAHAKQAFAGACAHQACAIAAAIQAAAHgDAIQgDAHgFAHQgFAGgHAFQgHAGgIADQAJADAIAGQAIAFAGAIQAGAHADAIQAEAIAAAJQAAAKgDAJQgCAIgFAHQgIAOgQAKQgOAJgTAFQgTAEgTAAQgUAAgQgEgEhCjgy5QgEAFgDAHQgDAHAAAIQAAALAJAHQAKAHASAAIASgCQAJgCAHgEQAHgEAEgGQAFgGAAgIQAAgIgGgHQgEgFgJgFQgKgFgWgFQgQAEgKALgEhCQg0iQgHABgEAEQgIAHAAAKQAAAJALAIQALAIARACQAOgCAIgGQAJgIAAgMQAAgLgJgGQgKgHgQAAQgJAAgHADgEhF4gx6QAAgUAFgXQAGgXAJgXQAKgXANgVQANgUAPgPIgaAAQg5gCgggEIAJgmQAgADApAAQAdAAAugEIAOAiQgJAHgNAPQgNAPgHAOQgTAmgFAUQgDAPgCAQIgBA+Ig1ADgEhYmgzBQAAgzABgdIgfAMIgNgiIAmgUQATgLAMgLIAhALQgEAUgDAgQgCAdAAAkQAAArADBEIg0ABg");
	this.shape.setTransform(-73,-32.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// ReservedInteractive
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FF0000").s().p("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");
	this.shape_1.setTransform(0,1.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// GameSafe
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FF0000").s().p("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");

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// MaxSize
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f().s("#FF0000").ss(4,1,1).p("Ehmzg8oMDNnAAAMAAAB5RMjNnAAAg");
	this.shape_3.setTransform(0.8,-0.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-659.1,-390.8,1319.9,780.2);


(lib.RoundBrushHandleDetail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#BA7001").s().p("AkDAlQgQgKgGgOQgDgGAAgGQAAgkBOgSQBCgQBuAAQBPgEBQAGQCfANgDAzQgCAqg+APQhKASjbAAQiIAAgzgjg");
	this.shape.setTransform(28.5,7.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.RoundBrushHandleDetail, new cjs.Rectangle(0,0,57.1,14.4), null);


(lib.RoundBrushBristlesTop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("ABhBFIgFgGQgNAKgXAAQgkAAgPgTQgJADgLAAQg+AAghgXQgJgGgGgHQgLAIgRAAQghAAgNgTIgDgHQgKAKgNAAQgTAAgIgOQgFgIAAgIQAAggAggBIAAAAQAGgHALgHQAVgMAagDQATgCAPADQARgJAXgBQAdgBATAOIADADQAMgDAPAAQAaACARANQALgFANgBQAagCAOALQALgFALgBQAwgHALAgIANABQAbAGAOANQAZgBAAAnQAAATgPAOQgRAQgcAAQgQAUggAAQgjAAgSgUg");
	this.shape.setTransform(25.8,8.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.RoundBrushBristlesTop, new cjs.Rectangle(0,0,51.6,17.9), null);


(lib.RoundBrushBristles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#F7F7F7").s().p("AAPBxIgBgKQgTAagOAAQgTAAgIgPQgFgIAAgIIACgFQgPAggHAAQgXAAgHgTIAAgIQgMAPgMAAQgUAAgJgPIgBgCQgFAFgHAAQgTAAgIgOQgIAKgRAAQgeAAgMhLQgGglAAgmQAAgOAKgUQAKgUAMgJQAggZAABLQAAAQAIAtIACAKIAGg7QAKhPAeAFQAKACAJANQAJANAAANQgBAugGAqIAMgfQARg7AcAAQAUABAFAXQAQgTANAAQAPAAAAAlQAAANgdBNIgRAqIAPgeQAYgtATgfQA8hbAEBKQAMgTAUgDQAbgFAHAWQALgJAPgBQAkgDAAAjIAAACIAGgIQA6hNAABXQAAARgcA0QgfA9gZAAQgWAAgHgQIgDgSIABgGQgdAogSAAQgSAAgJgMQgVAcgMAAQgXAAgIgQg");
	this.shape.setTransform(26.8,12.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.RoundBrushBristles, new cjs.Rectangle(0,0,53.6,25.9), null);


(lib.Puddle4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#66CCFF").s().p("AjJCoQi/gThKg9QisAPgyg0QgPgQgCgXIACgUQAAgJAUgVQAegfA0gaQCjhPE7AAIGtAAQBjAdCvApQB+AmAAA+QAAAWgjAbQgpAhhKAbQjCBGlQAAQiYAAhLgHg");
	this.shape.setTransform(70.6,17.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Puddle4, new cjs.Rectangle(0,0,141.2,35), null);


(lib.Puddle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#66CCFF").s().p("Ag1CQIg0gHIj+ABIgEABIilAAQh6gLgUgOQgVgPAAgoQAAgqAggNQAPgGBRgRQhDgNgogOQgVgIAAgUQAAgTAxgWIATgIQAHgEAhgIQAggJArABQAqAAArAFQAtgBAmAGIDWAAQCqgLCaAIQD0ANByA6QAtAXA4AVQAjARAAAgQAAAMgHAMQgKATgVAAQgQAHghAMQg+AUhEATIhAAAQgygEgLgDIiWAAIiNAWg");
	this.shape.setTransform(69.2,15.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.Puddle1, new cjs.Rectangle(0,1.2,138.4,28.9), null);


(lib.FloorGroutb = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("EhG/gWyMChXgAUMBRVArRMlXZAC8g");
	this.shape.setTransform(668.7,148.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.FloorGroutb, new cjs.Rectangle(-430.2,0.3,2197.8,295.8), null);


(lib.DrainRim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DCE7E2").s().p("AkCBJQhsgeAAgrQAAgqBsgeQBrgeCXAAQCYAABrAeQBsAeAAAqQAAArhsAeQhrAeiYAAQiXAAhrgeg");
	this.shape.setTransform(36.7,10.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.DrainRim, new cjs.Rectangle(0,0,73.4,20.6), null);


(lib.DrainMiddle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#AEC8BF").s().p("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");
	this.shape.setTransform(32.3,9.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.DrainMiddle, new cjs.Rectangle(0,0,64.6,18.1), null);


(lib.BucketShine = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#C6E1EC").s().p("AjVCBQiHgMg4gnQgbgUAAgTQDcjSFbApQBzANBlAmQBYAhgIAKQhvCCjJAhQhDALhYAAQhQAAhigJg");
	this.shape.setTransform(43.2,13.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BucketShine, new cjs.Rectangle(0,0,86.5,27.6), null);


(lib.BucketScrew = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E1E1E1").s().p("AgPALQgEgGAAgEQAAgTATgBQAUgBAAAVQAAAFgFAGQgFAIgKAAQgLAAgEgJg");
	this.shape.setTransform(2,2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BucketScrew, new cjs.Rectangle(0,0,4,4), null);


(lib.BucketInside = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#66CCFF").s().p("AkWAdQC8hbDLAPQBmAHA/AaQhqArhzAPIhdAHIgKAAQhyAAh2gWg");
	this.shape.setTransform(35.9,16.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#3996AC").s().p("AkrBbQhFgPAAgQQAAgyBqgxQBwg0CigSIBtAEQCEAQBvA1QAOAHgYAXQgZAYg0AZQiNBDi8AAQidAAhagTg");
	this.shape_1.setTransform(36.9,11);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.BucketInside, new cjs.Rectangle(0,0,73.8,22.1), null);


(lib.BucketHandle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#C6E1EC").s().p("ABhB7Qh7hPgfgRIhrhHQhqhGgCACQgOALgQgEIgMgFQgMgIgFgPQgDgHAAgGQAAgvAmAAQAkAAABAsQAcALAvAeQA6AlA/AuQBuBGBCAkQBuA9AxACQgLgKiIhLQiFhKgMgMQgBgCAHgfQAHgGCqBnQCsBpAAAVQAAAOgCAFQgHAMgYAAQhPAAh+hHg");
	this.shape.setTransform(33.5,19.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BucketHandle, new cjs.Rectangle(0,0,67,38.8), null);


(lib.BucketBody = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#99C3DE").s().p("AiJF0QhigWABgEQgSgThVj8QhTj0AAgOIgKggQAAgdBRgtQBYgwB3gdQFDhND5CHQAAAAAAAAQABAAAAAAQAAABAAAAQAAABgBAAIgBADQhCINgSAuQgCArhpAqQhqAqhuAAQg1AAhqgXg");
	this.shape.setTransform(43.1,39.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BucketBody, new cjs.Rectangle(0,0,86.2,79), null);


(lib.Bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("ABQFKIACgKQAAgEgFgGQgFgGAAgCQAAgPAQAGQAQAHAAATQAAATgOAAQgKAAAAgIgACnDzQAFgLAAgFQAAgPANAEQANAEAAAPQAAAKgEAFQgEAFgLAAQgMAAAAgMgAA7DiIAAgJQAAgaARgBQARAAAAAVQAAAIgDAGQgFAKgMAAQgMAAgCgJgADzDEIAAgHQAAgOAQgKQAPgKAAAWQAAAHgDAHQgFALgKAAQgKAAgDgGgAEgCwIgBgHQAAgQALACQAKADAAALQAAAOgKAAQgIAAgCgHgAlvClQgFgKAAgCQAAgOANAFQAMAEAAAOQAAAOgKAAQgFAAgFgLgAGdCkIAAgJQAAgPAUgMQATgNAAAdQAAAMgDAGQgGAKgPAAQgMAAgDgIgAnBCdQgIgLAAgBQAAgOAPAEQAOAEAAAQQAAANgLAAQgCAAgIgLgAkBCVQgKgHAAgEQAAgLASADQASACAAAOQAAAEgDADQgDAEgFAAQgFAAgKgIgAAUCNIAAgIQAAgRAOADQAOACAAAOQAAAHgBADQgDAFgKAAQgMAAgCgJgAi7CIQgIgJAAgDQAAgSAXAFQAWAFAAAQQAAAIgCADQgEAEgLAAQgKAAgKgLgAhWB+IgBgMQAAgTAYACQAXADAAAWIAAAKQgDAHgPAAQgWAAgGgNgAoNBwQAAgRAUALQAUAMAAAKQAAALgMAAQgFAAgXgbgAH6CDIgBgGQAAgJAKAAQALAAAAAJQAAAEgDADQgDAEgFAAQgGAAgDgFgAFyB6IgBgHQAAgPARAAQAOAAAAANQAAAFgDAEQgFAGgJAAQgLAAgCgGgAkpBzIAAgKQgMgMgKgCQgHgBAAgCQAAgQAZAKQAZAJAAAOQAAASgKAAQgKAAgBgIgADbBcQgKgIAAgEQAAgLARACQARADAAANQAAAFgDAEQgDAEgFAAQgDAAgKgIgAmBBJIgGgKQAAgNAOADQAPADAAAOQAAAOgKAAQgGAAgHgLgAFWBDIgCgHQAAgNARAAQARAAAAANQAAANgPAAQgNAAgEgGgAA/BGQgBgBAAgHQAAgKAKABQALABAAAIQAAAEgDADQgDAEgFAAQgDAAgGgDgAmwA+IgHgKQAAgNAQADQAQAEAAAPQAAAMgKAAQgIAAgHgLgAGuA6QgDgGAAgFQAAgVAVACQAUABAAATQAAAGgEAGQgGAIgLAAQgLAAgGgKgAg3AqQgDgHAAgGQAAgRARAGQARAGAAAPQAAAIgDADQgDACgIAAQgLAAgGgKgACeAsIgBgFQAAgLAKABQAKABAAAJQAAADgDAEQgDAEgEAAQgHAAgCgGgAjfAkQgGgGAAgFQAAgKAQABQAQAAAAANQAAANgKAAQgJAAgHgGgAE2AgQgCgEAAgDQAAgHALgBQAKgBAAAKQAAAEgCADQgDAEgFAAQgGAAgDgFgAiEAHQgPgMAAACQAAgQAVAHQAVAGAAAOQAAANgLAAIgQgOgAAaANIgBgGQAAgHAKgBQALAAAAAIQAAALgLAAQgGAAgDgFgAjHkQQgDgFAAgFQAAgWAVACQAVACAAASQAAAFgFAHQgGAIgKAAQgMAAgGgKgAhckIIgEgDIgBgIQAAgKAKABQALAAAAAKQAAADgDAEQgDAEgFAAIgFgBgAEtkwQgDgGAAgGQAAgUAWgBQAWgBAAAXQAAAIgFAGQgHAGgKAAQgNAAgGgJg");
	this.shape.setTransform(47.6,1.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#99F5FF").s().p("AArFPQgHgNAAgJQAAgrArADQAqADAAAlQAAAMgKANQgMARgVAAQgYAAgLgUgACCD3IgEgaQAAgTAPgRIAEgEQgHgFgEgHIgCADQgFAFgGADQAFAKAAANQAAAMgJAMIgBABIAAACQgBAKgJANQgOASgTAAQgYAAgMgUQgGgMgBgKIAAgCQgQgDgIgPQgGgLAAgLIAAgHQgSAMgoAAQgHAAgXgFQgYgGgHAAIgPALQgOAKgUAAQgkAAgSgTIgJACQgSAAgJgPQgEgIAAgHIgEAFQgIANgQAAQgTAAgIgPIgCgCIgHABIAAABQgBAIgGAKQgKANgPAAQgTAAgJgPQgEgJgBgIQABgIACgGQgFACgFAAIgFAAIAAAFQABAIgIAKQgJANgPAAQgTAAgIgPQgGgJAAgIQAAghAhACIAEABIgBgGIACgMQgSgDgJgPQgGgMAAgLQAAgrAqADQAbACAKARQAFgBAIAAQAfADAAAdIAAADIAJACQAQgUAsAGQAPACANAGIABAAIgEgHQgGgLAAgLQgBgpArgBQAZAAAKAPIABAAIAFAAQABgpAqACQAkACAEAdQAJADAIAFQALgKAVACQApADABAlIgBAFIAHAAQAVACAIANQACgdAeACQAYACAGASQALgDAMAAIgCgLQAAghAkgCQAkgCAAAlQgBAJgDAHIAGACQALgMAWACQAjACAFAcIAIgGIgBgKIABgLQgGgLgBgKQAAgpArACQAmADAEAdQAHgDAJAAQAcgCAKAVQAFgeAjACQAqACABAnQgBALgIANIgEAFIAEAIQAJgGAQABQApADAAAnQAAAMgJAMQgLAQgWAAQgXAAgLgSIgFAGQgZAcgpAAQgPAAgMgCQgHACgIAAQgXAAgLgRIgGALQgMARgWAAQgUAaggAAIgLAAQgDAMgHAMQgOAYgcAAQghAAgKgYgAC+BtIAFADIgDgGIgCADgAhHBjIABAAIAAgBIgBABgAGeBLIABAAIAAgCIgBACgAofCXQgHgMAAgKQAAgoAqgCQAqgCgBAtQABAMgKAMQgMAQgUAAQgYAAgLgTgAAGAaQgGgJAAgIQAAgeAhgBQAfgBAAAhQABAIgIAKQgIANgQAAQgTAAgIgPgAjkjzQgEgKABgLQAAgVAPgPQAOgOAUgDQAwgGAAA4QAAASgGAIQgNARgpAAQgaAAgIgTgAhykEQgCgGAAgGQAAgLAEgGQAHgIAQAAQAQAAAGAKQAEAFAAAHQAAAIgHAJQgIALgNAAQgRAAgGgNgAELkWIgGgYQAAgdASgNQARgMAXADQAYAEARAQQATASgBAYQABAOgHAHQgMAPgkAAQgrAAgOgXg");
	this.shape_1.setTransform(46.8,2.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Bubbles, new cjs.Rectangle(-8.3,-33.1,110.2,70.9), null);


(lib.BrushHandle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#DEB498").s().p("Aj+DdQAAgFAog1QAug9AOgaQAohJA/hIIhgCQQg2BPg0BGIgBABIAAgEgAjtDaQAAgIAdgjIAeglQANgUAegVQAegWAOAAQgKANggAVQgfAWgKANQgSAagsA0IAAAAIgBgEgAh0A9QAMgIASgSQAmgjAdgyQAGgKAIguQAGgmATgPIABAAQABAAAAAAQAAAAAAABQAAAAAAABQAAAAAAABQAAAKgJAPQgNAWgEAKIgDAbQgBASgIAKQgQAUgYAkQgXAgglAUIAAABIAAgEgAg9AmQBphTA2gtQBghQAGg2IADAAIACABIAAAEQAAAwhsBbQg7AwhhBHgAAWhKQA+gaAngpQAVgXAdglQgKAggjAiQglAlg7AbQgJgBgBgCgACqh8QA3gaARgXQAPgVgKgbIAIAAIAAAkQgFAXhIApQgIgBAAgCgAA3iDQgKgIAAgTQAAgVASgSQAXgXAogEQAKAJAEAKQgBACgDABQgLgNgBgEQgkAHgVAUQgRARAAARQAAAFAGATIAAAEIgBgBg");
	this.shape.setTransform(27.8,29.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#EFD0B1").s().p("AkBEQQgPgBAAgDQAAgKBPiAQA9hmAyhNQAng8BNhbQAEgGAIgNQAKgMAngcQAmgcBHApQBFAeAAAuQAAAVg4AoQg+AogPAMQgYASgtAlQgrAigdAWQgeAXglAgQgnAigYAZIgwA6QgkAsgEAAIgfACIgHAAgAByi+QgRAGgQAPQgPAPgFARQgGAQAJAJQAIAIAQgGQARgFAQgPQAPgPAFgRQAFgQgIgIQgFgGgJAAQgFAAgFACg");
	this.shape_1.setTransform(27.3,27.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.BrushHandle, new cjs.Rectangle(0,0,54.5,54.3), null);


(lib.blueline_bathroombackground = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D8E6E9").s().p("A7jAoIAAhQMA3HAAAIAABQg");
	this.shape.setTransform(176.4,4.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueline_bathroombackground, new cjs.Rectangle(0,0,352.8,8.1), null);


(lib.bathroomsignwords = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#C8A080").s().p("AB5DNIgEgBIgDAAIgCABIgPAAIgFgBIgDgDIgFgKIgDgEIgCgFIAAgCIgGgLIgBgFIAAgFIABgEIADgEIAEgBIALAAIAEABIADABIADgBIAYABIAEABIAIgCIABgBIAAgDIgBgBIgOgJIgBgBIgDAAIgMgIIgEgFIgEAAIgJgKIgHgPIgBgKIABgDIAFgGIAAgIIACgHIADgIIACAAIAMgMIANgGIAHAAIADABIAHgCIAAgDIAKgCIAGAAIADgBIAFAAIAFACIAEgCIALAAIACABIAEgBIADAAIAFgBIADADIADAEIACAHIAFAKIAAAEIAEAQIgEAHIgKAAIgBAAIgGAAIgGgCIgBAAIgEABIgXgBIgGADIABADIADABIABADIAEAAIAFABIALAGIABADIAEAAIAGADIAKAIIAGAIIAAAHIAEACIABAEIABATIgBAFIgFAKIAAAFIgIAMIgRAMIgKAEIgFABIgCgBIgCAAIgEAAIgCACIgEACIgLABIgIACgAEMDIIgGgCIgEADIgUAAIgEgBIgCgDIgDgIIAAgEIACgMIAAgFIAAgDIAAgEIAAgKIABgFIAAgDIgBgDIAAgTIAAgEIAAgCIAAgEIAAgHIgCgFIAAgCIACgFIAAgFIgCgGIAAgHIgCgEIAEgIIAAgDIgDgDIAAgJIABgFIACgDIAFgEIAIAAIABgBIAFABIAGADIAEgEIAFAAIADABIAEgBIADABIAEADIABAAIAEgEIAEAAIAEABIAFADIACAGIgCANIABAEIAAAHIgBAHIABADIAEAAIADABIADgBIAGgBIAAgJIABgGIAAgIIgBgCIABgDIAAgIIACgDIAGgEIADAAIADAAIAEAAIASAAIAEABIACgBIAEAAIABABIADgBIALAAIAEADIABACIACAGIgCAFIAAANIgBAEIAAABIABADIAAAIIgBAGIAAABIABAFIAAANIgBAGIABAEIACAMIgCACIAAAGIgBACIABADIAAAUIgCAFIABAEIABAFIAAALIACAEIgDAHIgFAFIgIgCIgEAAIgBABIgFgBIgDAAIgCABIgHAAIgCABIgFAAIgDgCIgCAAIgDACIgBAAIgFgBIgFAAIgEgBIgDgJIgBgHIABgDIgBgDIAAgQIABgDIgBgGIABgJIAAgCIgEgEIgCAAIgCABIgGABIgBAIIgBAFIAAABIACAEIAAAOIgCAFIACAIIAAAKIgCAFIgFADIgGAAIgEgBIgJACgAkcDKIgDgBIAAgBIgFABIgEAAIgBABIgCgBIgBgBIgHACIgDgBIgFgGIAAgOIgDgDIgCgJIAAgCIgDgCIAAgEIgMghIgCgDIgCgFIAAgEIgIgOIgBgDIgEgIIgDgDIgDgNIgFgHIgBgEIAAgCIgJgSIgCgCIAAgDIAAgFIABgBIACgDIAIAAIAGABIACACIAHgCIAIAAIADgBIAEABIADACIADgCIAHgBIAGABIAIAIIACADIAAACIABAFIAAAGIADACIACABIAEALIAAADIADACIADgIIABgEIADgIIADgEIAAgFIAJgPIANAAIACADIACgBIACgCIAEAAIACABIADgBIAFAAIAAABIACAAIACABIADgCIADAAIAGACIAAgCIAJAAIADADIAGAMIAAAFIADAEIAFAIIAAAEIADAIIACgCIAAgDIAFgLIACgBIAEgCIAAgGIACgFIAAgCIAAgDIAJgIIAHgBIAGABIAFACIACgCIAEgBIADABIAKAAIAGACIADgCIAGgBIAJAAIABADIAEABIAAAFIgCADIgCACIgKASIAAAGIgGAHIgEANIgEADIgDALIgDAEIgBABIgGAMIAAABIgNAgIAAALIgDACIAAACIgCAJIgCADIAAAFIgBAFIAAAEIgGAGIgDABIgDgBIgBABIgaAAIgFgGIgMgcIgDgNIgIgHIgGgNIgKARIgJAXIgDANIgNAOIgEACgAAxDGIgCgDIgGAEIgJAAIgCABIgCAAIgDgDIgHACIgKAAIgGgBIgCgEIAAgFIgCgCIgEgIIgDgCIgFAAIgCgBIgFAAIgBABIgHgBIgCABIgGgCIgCACIgFABIgEAIIAAABIgDAIIgDADIgDABIgKAAIgBgBIgCAAIgFABIgEAAIgEgBIgJABIgHgBIgBABIgDAAIgBgBIgBABIgEAAIgEgCIgBgDIgBgBIAAgIIABgDIADgCIgBgDIACgCIABgCIAFgDIgBgCIAAgCIABgDIAAgDIAFgEIAAgDIAFgKIADgEIAFgNIACgBIABgDIgBgCIAGgLIADgDIAAgHIACgIIgBgCIgJABIgDgBIgDgDIgCgDIgBgFIAAgGIABgEIAAgEIADgFIgDgCIAAgCIAAgDIgBgCIABgKIAIgGIAEAAIAIAEIAEgEIAHAAIAEABIAFADIACAAIADgDIAGAAIABACIALgCIAEAEIACAAIADgCIADAAIAGABIAFAAIADABIAEgCIAFAAIAFABIAGADIADAKIAAAFIgBACIAFAHIADAQIABACIgBADIAAACIACADIAAACIAFAEIAEAKIAAADIgBAEIADAFIADACIAEAHIAAACIABADIAAAGIACADIABAEIAIAVIgBADIADADIAFAJIAAAEIAAAEIgBADIgEAFIgJACgAgdCCIAAAEIgDADIAAADIAHADIAEgCIgBgFIAAgGIgEgCIgBAAgABigmIgEgBIgDgEIgBgFIABgHIAAgaIABgDIAAgBIgCgDIABgLIgLAGIgBAEIgDAEIgDAAIgDAFIgCABIgGgBIgEgFIgCgCIgFgFIgBgDIgFgCIgDgDIgCgBIABADIAAASIgBADIABAGIABAbIgDAFIgQACIgEgBIgJAAIgCABIgDAAIgEgCIgIACIgFgBIgIgIIgBgEIAAgHIACgDIABgDIgCgGIAAgGIABgDIAAgDIgBgFIAAgDIACgGIAAgFIgBgFIgBgDIgBgFIADgHIAAgCIgCgDIAAgDIABgEIAAgQIABgDIgCgGIAAgGIABgDIAAgGIgBgDIgBgHIAAgHIABgEIAGgIIAHAAIAEABIADgBIAKgBIACABIAFAAIADgCIADAAIAGADIAIgDIAKADIAEADIAEALIADABIADADIAFAIIAFACIADADIAHgLIADgCIABgEIAJgMIAFgDIAEgBIAEABIAEgBIAWAAIACABIAQgCIAEABIAEAFIAAAFIgBAGIABAdIgCAEIgBADIACAFIAAALIABAGIAAADIgCAHIAAAKIACAGIAAAQIgBACIgCADIACADIABAEIACAEIgBAJIgBAEIAAADIACADIABAGIgBAFIgDACIgKAAIgCAAIgDAAIgCAAIgHgBIgFABIgHAAIgDAAIgDAAIgDAAIgDAAIgCAAIgHABgAhgglIgFgCIgGACIgFgCIgCgDIgBgVIACgEIgCgDIAAgEIABgDIAAgFIACgMIAAgDIgCgIIgBgZIACgFIAAgCIgBgDIAAgXIABgEIAAgVIgBgEIACgGIADgCIAEgCIAFgBIAEADIADgCIACAAIAEACIADgCIANAAIAFACIACAAIAGgDIAKADIAEAEIABAEIgCADIABAJIgCAFIAAAGIACAFIgBAEIAAAIIgBACIABABIABADIAAAHIgBAEIABADIgCAGIACAFIgCAEIACAIIAAAFIgBADIABAMIgCAFIABAEIgBAEIACAEIgBAKIABAFIAAACIgCAEIABAGIgBADIgEADIgCABIgEAAIgEgBIgDAAIgDgBIgDACIgHAAIgDgBIgGACgAjygmIgEABIgGgCIgDABIgCABIgDgBIgFAAIgDABIgLAAIgGgBIgDgCIgDgFIAAgQIADgEIgCgJIACgGIgBgFIAAgGIABgHIgBgEIgCgCIAAgEIACgCIAAgEIgCgGIABgGIACgDIgCgEIABgGIgBgEIAAgDIABgEIAAgBIgBgFIAAgEIABgFIgBgJIABgBIAAgHIgCgDIgCgHIACgEIAFgFIANgBIAIACIAFgDIAIAAIAHADIAGgDIAEAAIAFAFIABABIADAAIAGAKIABAFIAEACIACAFIAFADIAAAFIAFACIAFAFIABgBIAAgGIgBgJIABgGIgCgDIAAgNIACgDIAFgCIASAAIAIACIACgCIADAAIADABIAFgCIAIAAIADABIADADIABAEIgBAWIgCABIADAFIgBATIgDAGIACAEIAAAaIgBADIABAEIgBACIgCADIACAIIAAACIABAEIAAAMIgDAHIADAKIgBABIAAAFIABAFIgDAEIgEADIgLACIgGgDIgCABIgJACIgGAAIgDgBIgNgQIAAgDIgEgDIgKgKIgCgFIgCgCIgEgEIgEgDIgDgEIgBACIgBAJIABACIgBAIIgBACIADAIIgCAFIABAEIAAAFIgCAFIgCABIgHABgAGrgmIgCgBIgCABIgWAAIgEgCIgDACIgKAAIgEgBIgFgGIAAgGIAAgDIAAgNIAAgDIAAgFIAAgEIABgDIgBgFIAAgEIAAgSIABgIIAAgCIgBgCIAAgmIABgEIgBgfIADgFIAEgCIAEgBIANAAIADACIAHgDIADAAIAHgBIAGADIAEgCIAHgBIAGAEIABAEIgBAFIABAEIgBAFIgCAFIACAEIABAOIgCAFIACAZIgBAEIABAKIgDACIAAAEIADABIAAAEIgCAEIADAGIAHAAIAGABIAGgCIACACIADgCIADAAIADABIADgCIAFACIAFAEIAAAMIAAADIgCACIACAFIAAAEIABAKIgBALIgDADIgHACIgCgBIgDgCIgDADIgFAAIgDgCIgNACIgDAAIgDgCIgCABIgKABgAFXgnIgDgDIgGAEIgJAAIgCAAIgBAAIgEgDIgHADIgKAAIgFgCIgDgDIAAgGIgDgCIgEgHIgDgDIgEAAIgDgBIgEAAIgCABIgHgBIgCABIgFgBIgDABIgEABIgFAIIAAABIgDAJIgCADIgEABIgJAAIgCgCIgCAAIgFACIgEAAIgDgCIgDABIgHABIgHgBIAAABIgEAAIgBgBIgBABIgEAAIgEgDIgBgCIgCgDIgBgFIACgCIABgDIADgBIgBgEIACgBIACgDIAEgCIgBgDIAAgCIABgDIAAgDIADgCIACgBIAAgEIAFgKIAEgEIAEgNIADgBIABgDIgBgCIAGgLIACgDIAAgGIACgIIgBgDIgIABIgEgBIgDgCIgCgDIgBgGIAAgGIACgDIAAgFIACgEIgDgFIAAgDIgBgCIACgJIAIgGIADAAIAIADIAFgDIAHAAIAIADIACAAIADgCIAGAAIABABIALgBIAEADIACAAIAEgCIADAAIAFABIAFAAIAEABIAFgCIAEAAIAFABIAGADIAEAKIAAAFIgBADIAEAGIAEAQIABADIgBACIAAACIABAEIAAABIACACIADACIAEALIAAADIgBADIABACIACADIADACIAEAIIAAABIACAEIgBAFIADADIABAFIAHAUIgBADIADADIAFAJIABAEIAAAEIgCAEIgEAEIgDACIgFAAgAEHhsIAAAEIgDADIAAADIAHADIAFgCIgCgFIAAgGIgEgCIgBAAgAlAgnIgDgDIgFAEIgJAAIgCAAIgCAAIgDgDIgHADIgKAAIgGgCIgCgDIAAgGIgDgCIgEgHIgDgDIgFAAIgDgBIgDAAIgCABIgHgBIgCABIgGgBIgCABIgFABIgFAIIAAABIgCAJIgDADIgDABIgKAAIgBgCIgCAAIgFACIgEAAIgEgCIgDABIgGABIgHgBIgBABIgDAAIgCgBIgBABIgDAAIgFgDIAAgCIgCgDIgBgFIACgCIABgDIADgBIgCgEIADgBIABgDIAEgCIgBgDIAAgCIACgDIAAgDIACgCIADgBIAAgEIAFgKIADgEIAFgNIACgBIABgDIgBgCIAGgLIADgDIAAgGIACgIIgBgDIgJABIgDgBIgEgCIgBgDIgBgGIAAgGIABgDIAAgFIACgEIgCgDIAAgCIAAgDIgBgCIABgJIAIgGIAEAAIAIADIAEgDIAHAAIAJADIACAAIADgCIAFAAIACABIALgBIADADIADAAIADgCIAEAAIAFABIAFAAIADABIAFgCIAEAAIAGABIAGADIADAKIAAAFIAAADIAEAGIADAQIABADIgBACIAAACIACAEIAAABIACACIADACIAEALIAAADIgBADIABACIACADIADACIAEAIIAAABIABAEIAAAFIACADIABAFIAIAUIgBADIADADIAFAJIAAAEIAAAEIgBAEIgEAEIgEACIgFAAgAmPhsIAAAEIgDADIAAADIAHADIAFgCIgCgFIAAgGIgEgCIgBAAg");
	this.shape.setTransform(48.8,20.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomsignwords, new cjs.Rectangle(0,0,97.7,41.1), null);


(lib.bathroomshelftop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#E6BD9E").s().p("AtCAOQgJgCASgMQASgLALgBQMKAWMKgZQAKgCAhgBQAigBABACIggAGIgUADIgNADQgBADgDABIgJABIgRADQnUAPl8ABIh5AAQk8AAkkgFg");
	this.shape.setTransform(84.5,1.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#D4AD91").s().p("AgoATQgWgaAAgEQAAgJAIgGIARgEIAJgBQADgBABgDIANgDIATgDIAhgGIAAAAQAIAAADAEQACABAAASQAAAGAFADQAEADAAAGQhAA2gHAAQgJAAgXgdg");
	this.shape_1.setTransform(164.3,4.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Layer 1
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#B6957C").s().p("AovAvIjhgJQgzgDAAgQQAAgyA6gPQFbAhGdgBQGWgCF3gZQBGgFACAsQACAqg0AHg");
	this.shape_2.setTransform(83.6,4.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomshelftop, new cjs.Rectangle(0,-0.3,170.6,9.8), null);


(lib.bathroomdoorshadow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#BBE1EA").s().p("AhKx6ICVAAMAAAAhtIiVCIg");
	this.shape.setTransform(7.5,114.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomdoorshadow, new cjs.Rectangle(0,0,14.9,229.4), null);


(lib.bathroomdoor_wallpart = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#CBF5FF").s().p("AbgVZInJAAIhAAAIkVAAIiTAAIoFAAIiTAAMAAAgisI9nAAMAAAAinI8MAAMAAAgqsMBu5AAAMAAAAqxg");
	this.shape.setTransform(354.9,136.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomdoor_wallpart, new cjs.Rectangle(0,0,709.7,273.8), null);


(lib.bathroombfloor2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer 616
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D8E6E9").s().p("AgxBNIiliZIDmAAIDHCZg");
	this.shape.setTransform(1289,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 617
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#D8E6E9").s().p("AgjBIIibiQIDCAAIC7CQg");
	this.shape_1.setTransform(1268.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 620
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#D8E6E9").s().p("AgfA8Ih/h2ICjAAICaB2g");
	this.shape_2.setTransform(1250.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 621
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#D8E6E9").s().p("AggB4IkBjvIEOAAIE1Dvg");
	this.shape_3.setTransform(1315,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

	// Layer 622
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#D8E6E9").s().p("AhHBvQAAgDgDgCIjnjYIFFAAIEeDdg");
	this.shape_4.setTransform(1344.6,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(1));

	// Layer 609
	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#D8E6E9").s().p("AASB4Ij3jvIDLAAID/Dvg");
	this.shape_5.setTransform(1285.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_5).wait(1));

	// Layer 610
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#D8E6E9").s().p("AgUBNIifiZIDCAAIClCZg");
	this.shape_6.setTransform(1263,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(1));

	// Layer 611
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#D8E6E9").s().p("AgWBIIiViQIC8AAICbCQg");
	this.shape_7.setTransform(1245.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_7).wait(1));

	// Layer 612
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#D8E6E9").s().p("AggA8Ih6h2IC2AAIB/B2g");
	this.shape_8.setTransform(1229.2,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(1));

	// Layer 614
	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#D8E6E9").s().p("AADBvIjjjdIDVAAIDsDdg");
	this.shape_9.setTransform(1312.2,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_9).wait(1));

	// Layer 597
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#D8E6E9").s().p("Ah5BvIjTjdIG1AAIDkDdg");
	this.shape_10.setTransform(1276.3,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_10).wait(1));

	// Layer 598
	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#D8E6E9").s().p("AiJA8Ihxh2IF7AAIB6B2g");
	this.shape_11.setTransform(1197.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_11).wait(1));

	// Layer 603
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#D8E6E9").s().p("AhnB4IjljvIGhAAID4Dvg");
	this.shape_12.setTransform(1251.5,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_12).wait(1));

	// Layer 604
	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#D8E6E9").s().p("AiGBNIiTiZIGUAAICeCZg");
	this.shape_13.setTransform(1229.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_13).wait(1));

	// Layer 605
	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#D8E6E9").s().p("AiDBIIiKiQIGGAAICVCQg");
	this.shape_14.setTransform(1213,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_14).wait(1));

	// Layer 589
	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#D8E6E9").s().p("AhPB4IjUjvIFiAAIDlDvg");
	this.shape_15.setTransform(1209.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_15).wait(1));

	// Layer 590
	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#D8E6E9").s().p("AhfBvIjEjdIF0AAIDTDdg");
	this.shape_16.setTransform(1232.2,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(1));

	// Layer 591
	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#D8E6E9").s().p("AhsBNIiJiZIFYAAICTCZg");
	this.shape_17.setTransform(1189,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_17).wait(1));

	// Layer 592
	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#D8E6E9").s().p("AhqBIIiBiQIFMAAICLCQg");
	this.shape_18.setTransform(1173.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_18).wait(1));

	// Layer 595
	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#D8E6E9").s().p("AhwA8Ihqh2IFDAAIByB2g");
	this.shape_19.setTransform(1159.4,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_19).wait(1));

	// Layer 583
	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#D8E6E9").s().p("AiOBvIi0jdIHAAAIDFDdg");
	this.shape_20.setTransform(1187.7,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_20).wait(1));

	// Layer 584
	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#D8E6E9").s().p("Ah+B4IjBjvIGrAAIDVDvg");
	this.shape_21.setTransform(1166.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_21).wait(1));

	// Layer 585
	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#D8E6E9").s().p("AiWBNIh9iZIGeAAICJCZg");
	this.shape_22.setTransform(1147.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_22).wait(1));

	// Layer 586
	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#D8E6E9").s().p("AiXA8Ihgh2IGFAAIBqB2g");
	this.shape_23.setTransform(1120.6,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_23).wait(1));

	// Layer 587
	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#D8E6E9").s().p("AiTBIIh1iQIGQAAICBCQg");
	this.shape_24.setTransform(1133.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(1));

	// Layer 570
	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#D8E6E9").s().p("Ah8B4IiwjvIGYAAIDBDvg");
	this.shape_25.setTransform(1121.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_25).wait(1));

	// Layer 571
	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#D8E6E9").s().p("AiSBNIhxiZIGLAAIB8CZg");
	this.shape_26.setTransform(1104.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_26).wait(1));

	// Layer 572
	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#D8E6E9").s().p("AiPBIIhqiQIF+AAIB1CQg");
	this.shape_27.setTransform(1091.1,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_27).wait(1));

	// Layer 576
	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#D8E6E9").s().p("AiSA8IhXh2IFzAAIBgB2g");
	this.shape_28.setTransform(1079.4,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_28).wait(1));

	// Layer 578
	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#D8E6E9").s().p("AiMBvIijjdIGsAAICzDdg");
	this.shape_29.setTransform(1140.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_29).wait(1));

	// Layer 561
	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#D8E6E9").s().p("Ah9B4IiejvIGIAAICwDvg");
	this.shape_30.setTransform(1077.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_30).wait(1));

	// Layer 562
	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#D8E6E9").s().p("AiMBvIiSjdIGbAAICiDdg");
	this.shape_31.setTransform(1095,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_31).wait(1));

	// Layer 567
	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#D8E6E9").s().p("AiPA8IhPh2IFmAAIBXB2g");
	this.shape_32.setTransform(1039.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_32).wait(1));

	// Layer 568
	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#D8E6E9").s().p("AiQBNIhmiZIF8AAIBxCZg");
	this.shape_33.setTransform(1062.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_33).wait(1));

	// Layer 569
	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#D8E6E9").s().p("AiNBIIhfiQIFvAAIBqCQg");
	this.shape_34.setTransform(1050.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_34).wait(1));

	// Layer 552
	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#D8E6E9").s().p("AiTBvIiCjdIGZAAICSDdg");
	this.shape_35.setTransform(1050.7,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_35).wait(1));

	// Layer 554
	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#D8E6E9").s().p("AiFB4IiNjvIGGAAICfDvg");
	this.shape_36.setTransform(1035.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_36).wait(1));

	// Layer 555
	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#D8E6E9").s().p("AiTA8IhGh2IFkAAIBPB2g");
	this.shape_37.setTransform(1001.2,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_37).wait(1));

	// Layer 556
	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#D8E6E9").s().p("AiVBNIhaiZIF6AAIBlCZg");
	this.shape_38.setTransform(1021.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_38).wait(1));

	// Layer 557
	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#D8E6E9").s().p("AiRBIIhViQIFuAAIBfCQg");
	this.shape_39.setTransform(1010.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_39).wait(1));

	// Layer 547
	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#D8E6E9").s().p("AieB4Ih7jvIGmAAICNDvg");
	this.shape_40.setTransform(991.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_40).wait(1));

	// Layer 548
	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#D8E6E9").s().p("AisBvIhxjdIG5AAICCDdg");
	this.shape_41.setTransform(1005,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_41).wait(1));

	// Layer 549
	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#D8E6E9").s().p("AimA8Ig9h2IGBAAIBGB2g");
	this.shape_42.setTransform(961.4,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_42).wait(1));

	// Layer 550
	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#D8E6E9").s().p("AiqBNIhPiZIGYAAIBbCZg");
	this.shape_43.setTransform(979.1,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_43).wait(1));

	// Layer 551
	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#D8E6E9").s().p("AimBIIhKiQIGMAAIBVCQg");
	this.shape_44.setTransform(969.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_44).wait(1));

	// Layer 534
	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#D8E6E9").s().p("Ah6B4IhrjvIFRAAIB6Dvg");
	this.shape_45.setTransform(950,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_45).wait(1));

	// Layer 535
	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#D8E6E9").s().p("AiCA8Ig1h2IEzAAIA8B2g");
	this.shape_46.setTransform(923.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_46).wait(1));

	// Layer 536
	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#D8E6E9").s().p("AiFBNIhFiZIFGAAIBPCZg");
	this.shape_47.setTransform(939.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_47).wait(1));

	// Layer 537
	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#D8E6E9").s().p("AiBBIIhBiQIE7AAIBKCQg");
	this.shape_48.setTransform(931.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_48).wait(1));

	// Layer 542
	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#D8E6E9").s().p("AiFBvIhkjdIFhAAIByDdg");
	this.shape_49.setTransform(962,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_49).wait(1));

	// Layer 525
	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#D8E6E9").s().p("AimB4IhajvIGVAAIBsDvg");
	this.shape_50.setTransform(909.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_50).wait(1));

	// Layer 526
	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#D8E6E9").s().p("AizBvIhTjdIGpAAIBkDdg");
	this.shape_51.setTransform(920.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_51).wait(1));

	// Layer 529
	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#D8E6E9").s().p("AinA8Igsh2IFyAAIA1B2g");
	this.shape_52.setTransform(887.5,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_52).wait(1));

	// Layer 530
	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#D8E6E9").s().p("AitBNIg5iZIGIAAIBFCZg");
	this.shape_53.setTransform(900.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_53).wait(1));

	// Layer 531
	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#D8E6E9").s().p("AioBIIg2iQIF8AAIBBCQg");
	this.shape_54.setTransform(893.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_54).wait(1));

	// Layer 516
	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#D8E6E9").s().p("AiXBvIhFjdIFmAAIBTDdg");
	this.shape_55.setTransform(878,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_55).wait(1));

	// Layer 517
	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#D8E6E9").s().p("AiMB4IhLjvIFVAAIBaDvg");
	this.shape_56.setTransform(869.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_56).wait(1));

	// Layer 518
	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#D8E6E9").s().p("AiMA+Igmh7IE3AAIAuB7g");
	this.shape_57.setTransform(850.6,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_57).wait(1));

	// Layer 519
	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#D8E6E9").s().p("AiSBNIgwiZIFLAAIA6CZg");
	this.shape_58.setTransform(861.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_58).wait(1));

	// Layer 520
	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#D8E6E9").s().p("AiOBIIgtiQIFAAAIA3CQg");
	this.shape_59.setTransform(856,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_59).wait(1));

	// Layer 507
	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#D8E6E9").s().p("Ah1FhIg0jXIGFgBIBODYgAjohnIF2gBIBLDVImNACgAjyiCIg3jeIFwAAIBFDeg");
	this.shape_60.setTransform(846.7,155.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_60).wait(1));

	// Layer 508
	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#D8E6E9").s().p("AiUA+Igfh7IFAAAIAnB7g");
	this.shape_61.setTransform(816.5,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_61).wait(1));

	// Layer 509
	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#D8E6E9").s().p("AibBNIgmiZIFTAAIAwCZg");
	this.shape_62.setTransform(825.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_62).wait(1));

	// Layer 510
	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#D8E6E9").s().p("AiZB4Ig7jvIFfAAIBKDvg");
	this.shape_63.setTransform(831.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_63).wait(1));

	// Layer 511
	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#D8E6E9").s().p("AiXBIIgkiQIFKAAIAtCQg");
	this.shape_64.setTransform(820.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_64).wait(1));

	// Layer 498
	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#D8E6E9").s().p("AiYA+IgXh7IFAAAIAfB7g");
	this.shape_65.setTransform(781.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_65).wait(1));

	// Layer 499
	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#D8E6E9").s().p("AihB4IgsjvIFfAAIA8Dvg");
	this.shape_66.setTransform(793.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_66).wait(1));

	// Layer 500
	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#D8E6E9").s().p("AicBIIgaiQIFJAAIAkCQg");
	this.shape_67.setTransform(785.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_67).wait(1));

	// Layer 501
	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#D8E6E9").s().p("AihBNIgciZIFVAAIAmCZg");
	this.shape_68.setTransform(788.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_68).wait(1));

	// Layer 506
	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#D8E6E9").s().p("AiQFhIgpjeIGVAFIA3DdgAi9BtIgojYIGDACIA2DYgAjqiGIgojeIFwAAIA3Deg");
	this.shape_69.setTransform(805.4,155.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_69).wait(1));

	// Layer 489
	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#D8E6E9").s().p("AjDCFIGYgCIApDeImoACgAjEBvIgZjcIGGAAIAoDdgAjjiFIgajdIF9AAIAoDeg");
	this.shape_70.setTransform(763.1,155.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_70).wait(1));

	// Layer 490
	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#D8E6E9").s().p("AivB4IgcjvIFrAAIAsDvg");
	this.shape_71.setTransform(755.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_71).wait(1));

	// Layer 491
	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#D8E6E9").s().p("AimBIIgRiQIFVAAIAaCQg");
	this.shape_72.setTransform(749.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_72).wait(1));

	// Layer 492
	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#D8E6E9").s().p("AirBNIgSiZIFfAAIAcCZg");
	this.shape_73.setTransform(751.7,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_73).wait(1));

	// Layer 497
	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#D8E6E9").s().p("AiiA8IgOh2IFLAAIAWB2g");
	this.shape_74.setTransform(746.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_74).wait(1));

	// Layer 480
	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#D8E6E9").s().p("AixB4IgMjvIFfAAIAcDvg");
	this.shape_75.setTransform(716.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_75).wait(1));

	// Layer 481
	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#D8E6E9").s().p("AiuFcIgSjVIGHgBIAZDbgAjCBvIgOjdIF9ABIAZDcgAjTiDIgMjdIFwAAIAaDdg");
	this.shape_76.setTransform(721.1,155.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_76).wait(1));

	// Layer 482
	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#D8E6E9").s().p("AilBIIgIiQIFKAAIARCQg");
	this.shape_77.setTransform(713,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_77).wait(1));

	// Layer 483
	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#D8E6E9").s().p("AigA8IgHh2IFBAAIAOB2g");
	this.shape_78.setTransform(711.7,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_78).wait(1));

	// Layer 488
	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#D8E6E9").s().p("AiqBNIgIiZIFUAAIASCZg");
	this.shape_79.setTransform(714.5,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_79).wait(1));

	// Layer 471
	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#D8E6E9").s().p("AiYBvIAAjdIEmAAIALDdg");
	this.shape_80.setTransform(682.6,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_80).wait(1));

	// Layer 472
	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#D8E6E9").s().p("AiSB4IAAjvIEYAAIANDvg");
	this.shape_81.setTransform(682,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_81).wait(1));

	// Layer 473
	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#D8E6E9").s().p("AiCA8IAAh2ID/AAIAGB2g");
	this.shape_82.setTransform(680.4,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_82).wait(1));

	// Layer 474
	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#D8E6E9").s().p("AiLBNIAAiZIEPAAIAICZg");
	this.shape_83.setTransform(681.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_83).wait(1));

	// Layer 475
	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#D8E6E9").s().p("AiHBIIAAiQIEHAAIAICQg");
	this.shape_84.setTransform(680.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_84).wait(1));

	// Layer 462
	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#D8E6E9").s().p("AieB4IAOjvIEuAAIAADvg");
	this.shape_85.setTransform(649.5,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_85).wait(1));

	// Layer 463
	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#D8E6E9").s().p("AikBuIAMjcIE9AAIAADdg");
	this.shape_86.setTransform(648.8,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_86).wait(1));

	// Layer 464
	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#D8E6E9").s().p("AiNA8IAHh2IEUAAIAAB2g");
	this.shape_87.setTransform(651.1,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_87).wait(1));

	// Layer 465
	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#D8E6E9").s().p("AiWBNIAIiZIElAAIAACZg");
	this.shape_88.setTransform(650.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_88).wait(1));

	// Layer 466
	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#D8E6E9").s().p("AiRBIIAIiQIEbAAIAACQg");
	this.shape_89.setTransform(650.7,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_89).wait(1));

	// Layer 453
	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#D8E6E9").s().p("AiiBuIAYjbIEtAAIgMDbg");
	this.shape_90.setTransform(615.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_90).wait(1));

	// Layer 454
	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#D8E6E9").s().p("AicB4IAajvIEfAAIgODvg");
	this.shape_91.setTransform(617.3,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_91).wait(1));

	// Layer 455
	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#D8E6E9").s().p("AiOBIIAQiQIEMAAIgICQg");
	this.shape_92.setTransform(620.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_92).wait(1));

	// Layer 456
	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#D8E6E9").s().p("AiTBNIARiZIEVAAIgICZg");
	this.shape_93.setTransform(619.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_93).wait(1));

	// Layer 457
	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#D8E6E9").s().p("AiIA8IANh2IEEAAIgGB2g");
	this.shape_94.setTransform(621.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_94).wait(1));

	// Layer 444
	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#D8E6E9").s().p("AieBuIAkjbIEYAAIgXDbg");
	this.shape_95.setTransform(583.5,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_95).wait(1));

	// Layer 445
	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#D8E6E9").s().p("AiIBIIAXiQID6AAIgPCQg");
	this.shape_96.setTransform(592.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_96).wait(1));

	// Layer 446
	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#D8E6E9").s().p("AiZB4IAnjvIELAAIgaDvg");
	this.shape_97.setTransform(586.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_97).wait(1));

	// Layer 447
	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#D8E6E9").s().p("AiNBNIAYiZIEDAAIgRCZg");
	this.shape_98.setTransform(589.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_98).wait(1));

	// Layer 448
	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#D8E6E9").s().p("AiDA8IATh2ID0AAIgNB2g");
	this.shape_99.setTransform(594.2,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_99).wait(1));

	// Layer 435
	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#D8E6E9").s().p("AigB4IAyjvIEPAAIgmDvg");
	this.shape_100.setTransform(557.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_100).wait(1));

	// Layer 436
	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#D8E6E9").s().p("AilBuIAujbIEdAAIgjDbg");
	this.shape_101.setTransform(552.6,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_101).wait(1));

	// Layer 437
	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#D8E6E9").s().p("AiHA8IAZh2ID2AAIgSB2g");
	this.shape_102.setTransform(567.2,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_102).wait(1));

	// Layer 438
	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#D8E6E9").s().p("AiTBNIAgiZIEHAAIgZCZg");
	this.shape_103.setTransform(561.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_103).wait(1));

	// Layer 439
	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#D8E6E9").s().p("AiOBIIAfiQID+AAIgXCQg");
	this.shape_104.setTransform(564.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_104).wait(1));

	// Layer 426
	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#D8E6E9").s().p("Ai0BuIA6jbIEvAAIguDbg");
	this.shape_105.setTransform(520.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_105).wait(1));

	// Layer 427
	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#D8E6E9").s().p("AiwB4IBAjvIEhAAIgzDvg");
	this.shape_106.setTransform(526.3,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_106).wait(1));

	// Layer 428
	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#D8E6E9").s().p("AigBNIApiZIEYAAIghCZg");
	this.shape_107.setTransform(531.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_107).wait(1));

	// Layer 429
	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#D8E6E9").s().p("AiaBIIAmiQIEPAAIgeCQg");
	this.shape_108.setTransform(535.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_108).wait(1));

	// Layer 431
	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#D8E6E9").s().p("AiTA8IAfh2IEIAAIgZB2g");
	this.shape_109.setTransform(539.3,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_109).wait(1));

	// Layer 417
	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#D8E6E9").s().p("AjIB4IBNjvIFEAAIg/Dvg");
	this.shape_110.setTransform(492.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_110).wait(1));

	// Layer 418
	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#D8E6E9").s().p("AjNBuIBIjbIFTAAIg7Dbg");
	this.shape_111.setTransform(485.5,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_111).wait(1));

	// Layer 419
	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#D8E6E9").s().p("AivBIIAviQIEvAAIgmCQg");
	this.shape_112.setTransform(504.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_112).wait(1));

	// Layer 420
	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#D8E6E9").s().p("Ai1BNIAyiZIE5AAIgpCZg");
	this.shape_113.setTransform(499.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_113).wait(1));

	// Layer 421
	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#D8E6E9").s().p("AimA8IAmh2IEnAAIgfB2g");
	this.shape_114.setTransform(508.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_114).wait(1));

	// Layer 408
	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#D8E6E9").s().p("AjIBuIBUjbIE9AAIhIDbg");
	this.shape_115.setTransform(449.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_115).wait(1));

	// Layer 409
	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#D8E6E9").s().p("AjEB4IBbjvIEuAAIhNDvg");
	this.shape_116.setTransform(458.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_116).wait(1));

	// Layer 410
	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#D8E6E9").s().p("AipBIIA3iQIEcAAIgvCQg");
	this.shape_117.setTransform(472.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_117).wait(1));

	// Layer 411
	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#D8E6E9").s().p("AivBNIA7iZIEkAAIgyCZg");
	this.shape_118.setTransform(466.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_118).wait(1));

	// Layer 412
	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#D8E6E9").s().p("AigA8IAth2IEUAAIgnB2g");
	this.shape_119.setTransform(477.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_119).wait(1));

	// Layer 399
	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#D8E6E9").s().p("AjSBuIBgjbIFFAAIhUDbg");
	this.shape_120.setTransform(415,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_120).wait(1));

	// Layer 400
	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#D8E6E9").s().p("AjPB4IBpjvIE2AAIhbDvg");
	this.shape_121.setTransform(425.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_121).wait(1));

	// Layer 401
	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#D8E6E9").s().p("AinA8IA0h2IEbAAIguB2g");
	this.shape_122.setTransform(447.3,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_122).wait(1));

	// Layer 402
	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#D8E6E9").s().p("Ai3BNIBDiZIEsAAIg7CZg");
	this.shape_123.setTransform(434.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_123).wait(1));

	// Layer 403
	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#D8E6E9").s().p("AiwBIIA/iQIEiAAIg3CQg");
	this.shape_124.setTransform(441.1,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_124).wait(1));

	// Layer 390
	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#D8E6E9").s().p("AkKB4IB7jvIGaAAIhpDvg");
	this.shape_125.setTransform(386,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_125).wait(1));

	// Layer 391
	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#D8E6E9").s().p("AkPBuIBxjbIGuAAIhhDbg");
	this.shape_126.setTransform(374.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_126).wait(1));

	// Layer 392
	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#D8E6E9").s().p("AjZA8IA9h2IF2AAIg0B2g");
	this.shape_127.setTransform(411.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_127).wait(1));

	// Layer 393
	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#D8E6E9").s().p("AjtBNIBOiZIGOAAIhECZg");
	this.shape_128.setTransform(396.5,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_128).wait(1));

	// Layer 394
	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#D8E6E9").s().p("AjlBIIBKiQIGBAAIg/CQg");
	this.shape_129.setTransform(404.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_129).wait(1));

	// Layer 381
	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#D8E6E9").s().p("AkEBuICAjbIGJAAIhxDbg");
	this.shape_130.setTransform(329.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_130).wait(1));

	// Layer 382
	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#D8E6E9").s().p("AkBB4ICMjvIF3AAIh7Dvg");
	this.shape_131.setTransform(343.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_131).wait(1));

	// Layer 383
	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#D8E6E9").s().p("AjNA8IBFh2IFWAAIg9B2g");
	this.shape_132.setTransform(373.2,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_132).wait(1));

	// Layer 384
	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#D8E6E9").s().p("AjiBNIBaiZIFrAAIhPCZg");
	this.shape_133.setTransform(355.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_133).wait(1));

	// Layer 385
	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#D8E6E9").s().p("AjaBIIBViQIFgAAIhLCQg");
	this.shape_134.setTransform(364.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_134).wait(1));

	// Layer 372
	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#D8E6E9").s().p("AkkB4ICejvIGrAAIiMDvg");
	this.shape_135.setTransform(300.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_135).wait(1));

	// Layer 373
	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#D8E6E9").s().p("AknBuICRjbIG+AAIiADbg");
	this.shape_136.setTransform(284.7,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_136).wait(1));

	// Layer 374
	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#D8E6E9").s().p("AjpA8IBOh2IGFAAIhFB2g");
	this.shape_137.setTransform(333.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_137).wait(1));

	// Layer 376
	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#D8E6E9").s().p("AkBBNIBmiZIGcAAIhZCZg");
	this.shape_138.setTransform(313.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_138).wait(1));

	// Layer 377
	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#D8E6E9").s().p("Aj3BIIBfiQIGQAAIhUCQg");
	this.shape_139.setTransform(324.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_139).wait(1));

	// Layer 363
	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#D8E6E9").s().p("AjsBuICdjbIE8AAIiRDbg");
	this.shape_140.setTransform(243.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_140).wait(1));

	// Layer 364
	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#D8E6E9").s().p("AjsB4ICsjvIEtAAIieDvg");
	this.shape_141.setTransform(260.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_141).wait(1));

	// Layer 365
	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#D8E6E9").s().p("AjIBNIBuiZIEjAAIhlCZg");
	this.shape_142.setTransform(275.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_142).wait(1));

	// Layer 366
	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#D8E6E9").s().p("AjBBIIBoiQIEaAAIhfCQg");
	this.shape_143.setTransform(287.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_143).wait(1));

	// Layer 367
	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#D8E6E9").s().p("AizA8IBVh2IESAAIhOB2g");
	this.shape_144.setTransform(297.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_144).wait(1));

	// Layer 354
	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#D8E6E9").s().p("AlHB4IDAjvIHPAAIisDvg");
	this.shape_145.setTransform(218.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_145).wait(1));

	// Layer 355
	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#D8E6E9").s().p("AlKBuICwjbIHlAAIidDbg");
	this.shape_146.setTransform(199.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_146).wait(1));

	// Layer 356
	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#D8E6E9").s().p("AkDA8IBgh2IGnAAIhWB2g");
	this.shape_147.setTransform(259.8,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_147).wait(1));

	// Layer 357
	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#D8E6E9").s().p("AkeBNIB8iZIHBAAIhvCZg");
	this.shape_148.setTransform(235.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_148).wait(1));

	// Layer 358
	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#D8E6E9").s().p("AkTBIIB0iQIGzAAIhoCQg");
	this.shape_149.setTransform(248.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_149).wait(1));

	// Layer 345
	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#D8E6E9").s().p("AknBuIDAjbIGPAAIiwDbg");
	this.shape_150.setTransform(152.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_150).wait(1));

	// Layer 346
	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#D8E6E9").s().p("AkmB4IDQjvIF9AAIjADvg");
	this.shape_151.setTransform(173.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_151).wait(1));

	// Layer 347
	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#D8E6E9").s().p("Aj7BNICGiZIFxAAIh7CZg");
	this.shape_152.setTransform(191.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_152).wait(1));

	// Layer 348
	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#D8E6E9").s().p("AjxBIIB+iQIFlAAIh0CQg");
	this.shape_153.setTransform(205.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_153).wait(1));

	// Layer 349
	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#D8E6E9").s().p("AjhA8IBoh2IFbAAIhfB2g");
	this.shape_154.setTransform(218.3,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_154).wait(1));

	// Layer 336
	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#D8E6E9").s().p("AlSBuIDSjbIHTAAIjADbg");
	this.shape_155.setTransform(105.3,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_155).wait(1));

	// Layer 337
	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#D8E6E9").s().p("AlQB4IDkjvIG+AAIjRDvg");
	this.shape_156.setTransform(128.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_156).wait(1));

	// Layer 338
	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#D8E6E9").s().p("AkDA8IBxh2IGXAAIhoB2g");
	this.shape_157.setTransform(177.4,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_157).wait(1));

	// Layer 339
	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#D8E6E9").s().p("AkgBNICSiZIGwAAIiHCZg");
	this.shape_158.setTransform(148,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_158).wait(1));

	// Layer 340
	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#D8E6E9").s().p("AkWBIICLiQIGhAAIh+CQg");
	this.shape_159.setTransform(163.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_159).wait(1));

	// Layer 327
	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#D8E6E9").s().p("AkcBuIDfjbIFaAAIjSDbg");
	this.shape_160.setTransform(61.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_160).wait(1));

	// Layer 328
	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#D8E6E9").s().p("AkeB4ID0jvIFJAAIjlDvg");
	this.shape_161.setTransform(85.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_161).wait(1));

	// Layer 329
	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#D8E6E9").s().p("AjjBIICTiQIE0AAIiKCQg");
	this.shape_162.setTransform(123.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_162).wait(1));

	// Layer 330
	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#D8E6E9").s().p("AjtBNICdiZIE+AAIiTCZg");
	this.shape_163.setTransform(107.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_163).wait(1));

	// Layer 331
	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#D8E6E9").s().p("AjSA8IB5h2IEsAAIhyB2g");
	this.shape_164.setTransform(138.9,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_164).wait(1));

	// Layer 318
	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#D8E6E9").s().p("EBiaAFiIgNAAIjRjeIHcAGIDUDegEBadAFiIgZAAIjFjeIHcAGIDUDegEBSEAFiIi0jeIHPgDIDFDeIhhADgEBKUAFgIiqjcIHCAAIC0DegEA6sAFeIh7jeIHPABICfDggEBC/AFhIiejeIGeAAICuDegEAySACBIGDgDICEDeImVADgEgpXAFdIBWjcIFRAAIhHDcgEg4bAFdIBzjcIGXAAIhkDcgEAr4AFZIhWjeIHWADIByDegA9UFcIA8jcIFjAAIg2DcgAERB5IFGAHIAQDYIlPADgAmqB7IFXACIAADdIgFAAIlmABgEgxDAFbIBhjdIHAAAIhPDdgAg/FZIAAjeIEmACIASgCIAHDeIgGABgAsfFaIAljdIE7gBIgYDdIgmABgAtDFaIkdAAIAljdIEqAAIgkDdgA3NFaIAvjdIE+AAIgpDdgEgjRAFaIBIjdIFIAAIg5DdgEhWTAFZICzjcIGiAAIihDcgEhlaAFZIDWjcIFtAAIjDDcgEhApAFZICBjdIHZAAIh7DdgEhGOAFZICKjdIE+AAIiBDdgEhPCAFZIChjdIH+AAIiVDdgEhezAFZIDDjdIHeAAIi0DdgEhuTAFZIETjcIHSAAIjjDcgEAlVAFVIhOjcIF7ACIBVDagEBoYAB5IgEgEIjpjZIFJAAIEgDdgEBkeAB5IgLgKIlrAEIjUjdIFfgEIALAKIDQAAIDvDdgEBXHABvIgZAAIjGjdIHQAEIDUDdgEBU9ABvIl/AAIi0jdIHDAAIDGDdgEgnzABuIBVjcIFNAAIhHDcgEg2dABuIByjcIGRAAIhjDcgA8WBtIA6jcIFfAAIg1DcgEBHaABsIikjdIGvAAIC0DdgEgvaABsIBhjdIG6AAIhODdgAhBhxIE3gDIAFDdIk8ACgAmqBnIAUjYIFAAAIAADcgAr4BqIAkjbIEsAAIgXDbgAw6BqIAkjbIEnAAIgkDbgA2UBqIAujbIE6AAIgpDbgEgiBABqIBHjbIFEAAIg4DbgEhTuABqICxjbIGdAAIifDbgEhiZABpIDSjaIFoAAIjADbgEg+XABpICBjbIHSAAIh5DbgEhD2ABpICIjbIE6AAIh/DbgEhMiABpICfjbIH2AAIiSDbgEhb4ABpIDAjbIHYAAIiyDbgEhrLABpIEPjaIHNAAIjhDagAETBnIgLjcIE8ABIAQDdgEA4gABnIiCjdIG+ABICTDdgEAwRgB3IF1gCICEDdImIACgEAqZABdIhVjXIG1ACIBzDegEBAGABkIiSjdIGeAAICjDdgEAj+ABhIhOjaIF8ABIBUDZgEhlsgCLIENjcIFnAAIjgDcg");
	this.shape_165.setTransform(640.4,155.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_165).wait(1));

	// Layer 320
	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#D8E6E9").s().p("AkqB4IEljvIEwAAIjzDvg");
	this.shape_166.setTransform(48.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_166).wait(1));

	// Layer 319
	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#D8E6E9").s().p("AjjBNIC8iZIELAAIicCZg");
	this.shape_167.setTransform(73.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_167).wait(1));

	// Layer 321
	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#D8E6E9").s().p("AiuA8ICRh2IDMAAIh5B2g");
	this.shape_168.setTransform(109.6,52);

	this.timeline.addTween(cjs.Tween.get(this.shape_168).wait(1));

	// Layer 322
	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#D8E6E9").s().p("AjNBIICyiQIDpAAIiUCQg");
	this.shape_169.setTransform(92.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_169).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroombfloor2, new cjs.Rectangle(-65.6,45.7,1440.8,146.2), null);


(lib.bathroombfloor = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Layer 615
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#D8E6E9").s().p("AgHAoIhWhPIBVAAIBmBPg");
	this.shape.setTransform(1205.5,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 616
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#D8E6E9").s().p("AgxBNIiliZIDmAAIDHCZg");
	this.shape_1.setTransform(1289,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

	// Layer 617
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#D8E6E9").s().p("AgjBIIibiQIDCAAIC7CQg");
	this.shape_2.setTransform(1268.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 618
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#D8E6E9").s().p("AgJBBIiLiBICDAAICmCBg");
	this.shape_3.setTransform(1233.4,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

	// Layer 619
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#D8E6E9").s().p("AgOAtIhghZIBqAAIBzBZg");
	this.shape_4.setTransform(1217.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_4).wait(1));

	// Layer 620
	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#D8E6E9").s().p("AgcA+IiEh7ICiAAICfB7g");
	this.shape_5.setTransform(1250.7,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_5).wait(1));

	// Layer 621
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#D8E6E9").s().p("AggB4IkBjvIEOAAIE1Dvg");
	this.shape_6.setTransform(1315,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_6).wait(1));

	// Layer 622
	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#D8E6E9").s().p("AhHBvQAAgDgDgCIjnjYIFFAAIEeDdg");
	this.shape_7.setTransform(1344.6,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_7).wait(1));

	// Layer 623
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#D8E6E9").s().p("AABAnIhRhNIA+AAIBjBNg");
	this.shape_8.setTransform(1193.9,3.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_8).wait(1));

	// Layer 606
	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#D8E6E9").s().p("AgrAnIhPhMICigBIBTBNg");
	this.shape_9.setTransform(1178.7,3.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_9).wait(1));

	// Layer 607
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#D8E6E9").s().p("AgpAtIhchZICrAAIBgBZg");
	this.shape_10.setTransform(1200,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_10).wait(1));

	// Layer 608
	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#D8E6E9").s().p("AgrAoIhThPICnAAIBWBPg");
	this.shape_11.setTransform(1189,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_11).wait(1));

	// Layer 609
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#D8E6E9").s().p("AASB4Ij3jvIDLAAID/Dvg");
	this.shape_12.setTransform(1285.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_12).wait(1));

	// Layer 610
	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#D8E6E9").s().p("AgUBNIifiZIDCAAIClCZg");
	this.shape_13.setTransform(1263,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_13).wait(1));

	// Layer 611
	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#D8E6E9").s().p("AgWBIIiViQIC8AAICbCQg");
	this.shape_14.setTransform(1245.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_14).wait(1));

	// Layer 612
	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#D8E6E9").s().p("AgeA+Ih+h7IC2AAICDB7g");
	this.shape_15.setTransform(1229,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_15).wait(1));

	// Layer 613
	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#D8E6E9").s().p("AgXBBIiGiBICwAAICLCBg");
	this.shape_16.setTransform(1213.7,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_16).wait(1));

	// Layer 614
	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#D8E6E9").s().p("AADBvIjjjdIDVAAIDsDdg");
	this.shape_17.setTransform(1312.2,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_17).wait(1));

	// Layer 597
	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#D8E6E9").s().p("Ah5BvIjTjdIG1AAIDkDdg");
	this.shape_18.setTransform(1276.3,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_18).wait(1));

	// Layer 598
	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#D8E6E9").s().p("AiHA+Ih1h7IF7AAIB+B7g");
	this.shape_19.setTransform(1197.7,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_19).wait(1));

	// Layer 599
	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#D8E6E9").s().p("AiMAoIhMhPIFfAAIBSBPg");
	this.shape_20.setTransform(1159.8,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_20).wait(1));

	// Layer 600
	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#D8E6E9").s().p("AiKAmIhIhKIFWgBIBPBLg");
	this.shape_21.setTransform(1150.1,3.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_21).wait(1));

	// Layer 601
	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#D8E6E9").s().p("Ah+BBIh8iBIFvAAICGCBg");
	this.shape_22.setTransform(1183.2,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_22).wait(1));

	// Layer 602
	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#D8E6E9").s().p("AiMAtIhVhZIFnAAIBcBZg");
	this.shape_23.setTransform(1170.2,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_23).wait(1));

	// Layer 603
	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#D8E6E9").s().p("AhnB4IjljvIGhAAID4Dvg");
	this.shape_24.setTransform(1251.5,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_24).wait(1));

	// Layer 604
	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#D8E6E9").s().p("AiGBNIiTiZIGUAAICeCZg");
	this.shape_25.setTransform(1229.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_25).wait(1));

	// Layer 605
	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#D8E6E9").s().p("AiDBIIiKiQIGGAAICVCQg");
	this.shape_26.setTransform(1213,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_26).wait(1));

	// Layer 588
	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#D8E6E9").s().p("AhzAmIhChJIEkgCIBHBLg");
	this.shape_27.setTransform(1115.2,3.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_27).wait(1));

	// Layer 589
	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#D8E6E9").s().p("AhPB4IjUjvIFiAAIDlDvg");
	this.shape_28.setTransform(1209.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_28).wait(1));

	// Layer 590
	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#D8E6E9").s().p("AhfBvIjEjdIF0AAIDTDdg");
	this.shape_29.setTransform(1232.2,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_29).wait(1));

	// Layer 591
	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#D8E6E9").s().p("AhsBNIiJiZIFYAAICTCZg");
	this.shape_30.setTransform(1189,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_30).wait(1));

	// Layer 592
	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#D8E6E9").s().p("AhqBIIiBiQIFMAAICLCQg");
	this.shape_31.setTransform(1173.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_31).wait(1));

	// Layer 593
	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#D8E6E9").s().p("Ah0AoIhHhPIErAAIBMBPg");
	this.shape_32.setTransform(1124.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_32).wait(1));

	// Layer 594
	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#D8E6E9").s().p("Ah0AtIhPhZIEyAAIBVBZg");
	this.shape_33.setTransform(1133.8,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_33).wait(1));

	// Layer 595
	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#D8E6E9").s().p("AhvA+Ihsh7IFCAAIB1B7g");
	this.shape_34.setTransform(1159.2,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_34).wait(1));

	// Layer 596
	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#D8E6E9").s().p("AhnBBIhziBIE5AAIB8CBg");
	this.shape_35.setTransform(1145.7,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_35).wait(1));

	// Layer 579
	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#D8E6E9").s().p("AiXAoIhAhPIFoAAIBHBPg");
	this.shape_36.setTransform(1088.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_36).wait(1));

	// Layer 580
	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#D8E6E9").s().p("AiVAlIg7hIIFggBIBBBJg");
	this.shape_37.setTransform(1079.9,4);

	this.timeline.addTween(cjs.Tween.get(this.shape_37).wait(1));

	// Layer 581
	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#D8E6E9").s().p("AiNBBIhpiBIF5AAIB0CBg");
	this.shape_38.setTransform(1108,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_38).wait(1));

	// Layer 582
	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#D8E6E9").s().p("AiXAtIhIhZIFwAAIBPBZg");
	this.shape_39.setTransform(1097,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_39).wait(1));

	// Layer 583
	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#D8E6E9").s().p("AiOBvIi0jdIHAAAIDFDdg");
	this.shape_40.setTransform(1187.7,131);

	this.timeline.addTween(cjs.Tween.get(this.shape_40).wait(1));

	// Layer 584
	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#D8E6E9").s().p("Ah+B4IjBjvIGrAAIDVDvg");
	this.shape_41.setTransform(1166.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_41).wait(1));

	// Layer 585
	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#D8E6E9").s().p("AiWBNIh9iZIGeAAICJCZg");
	this.shape_42.setTransform(1147.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_42).wait(1));

	// Layer 586
	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#D8E6E9").s().p("AiVA+Ihjh7IGEAAIBtB7g");
	this.shape_43.setTransform(1120.4,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_43).wait(1));

	// Layer 587
	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#D8E6E9").s().p("AiTBIIh1iQIGQAAICBCQg");
	this.shape_44.setTransform(1133.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_44).wait(1));

	// Layer 570
	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#D8E6E9").s().p("Ah8B4IiwjvIGYAAIDBDvg");
	this.shape_45.setTransform(1121.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_45).wait(1));

	// Layer 571
	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#D8E6E9").s().p("AiSBNIhxiZIGLAAIB8CZg");
	this.shape_46.setTransform(1104.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_46).wait(1));

	// Layer 572
	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#D8E6E9").s().p("AiPBIIhqiQIF+AAIB1CQg");
	this.shape_47.setTransform(1091.1,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_47).wait(1));

	// Layer 573
	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#D8E6E9").s().p("AiQAkIg0hGIFPgBIA7BHg");
	this.shape_48.setTransform(1042.4,4.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_48).wait(1));

	// Layer 574
	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#D8E6E9").s().p("AiRAoIg7hPIFYAAIBBBPg");
	this.shape_49.setTransform(1049.8,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_49).wait(1));

	// Layer 575
	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#D8E6E9").s().p("AiSAtIhBhZIFfAAIBIBZg");
	this.shape_50.setTransform(1057.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_50).wait(1));

	// Layer 576
	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#D8E6E9").s().p("AiRA+Ihah7IFzAAIBkB7g");
	this.shape_51.setTransform(1079.2,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_51).wait(1));

	// Layer 577
	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#D8E6E9").s().p("AiJBBIhfiBIFoAAIBpCBg");
	this.shape_52.setTransform(1067.9,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_52).wait(1));

	// Layer 578
	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#D8E6E9").s().p("AiMBvIijjdIGsAAICzDdg");
	this.shape_53.setTransform(1140.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_53).wait(1));

	// Layer 561
	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#D8E6E9").s().p("Ah9B4IiejvIGIAAICwDvg");
	this.shape_54.setTransform(1077.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_54).wait(1));

	// Layer 562
	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#D8E6E9").s().p("AiMBvIiSjdIGbAAICiDdg");
	this.shape_55.setTransform(1095,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_55).wait(1));

	// Layer 563
	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#D8E6E9").s().p("AiOAoIg0hPIFLAAIA6BPg");
	this.shape_56.setTransform(1013.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_56).wait(1));

	// Layer 564
	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#D8E6E9").s().p("AiNAkIguhFIFDgCIA0BHg");
	this.shape_57.setTransform(1006.4,4.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_57).wait(1));

	// Layer 565
	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#D8E6E9").s().p("AiOAtIg8hZIFTAAIBCBZg");
	this.shape_58.setTransform(1020.4,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_58).wait(1));

	// Layer 566
	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#D8E6E9").s().p("AiHBBIhViBIFaAAIBfCBg");
	this.shape_59.setTransform(1029.5,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_59).wait(1));

	// Layer 567
	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#D8E6E9").s().p("AiOA+IhRh7IFlAAIBaB7g");
	this.shape_60.setTransform(1039.7,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_60).wait(1));

	// Layer 568
	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#D8E6E9").s().p("AiQBNIhmiZIF8AAIBxCZg");
	this.shape_61.setTransform(1062.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_61).wait(1));

	// Layer 569
	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#D8E6E9").s().p("AiNBIIhfiQIFvAAIBqCQg");
	this.shape_62.setTransform(1050.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_62).wait(1));

	// Layer 552
	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#D8E6E9").s().p("AiTBvIiCjdIGZAAICSDdg");
	this.shape_63.setTransform(1050.7,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_63).wait(1));

	// Layer 553
	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#D8E6E9").s().p("AiKBBIhNiBIFZAAIBWCBg");
	this.shape_64.setTransform(992,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_64).wait(1));

	// Layer 554
	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#D8E6E9").s().p("AiFB4IiNjvIGGAAICfDvg");
	this.shape_65.setTransform(1035.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_65).wait(1));

	// Layer 555
	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#D8E6E9").s().p("AiSA+IhIh7IFkAAIBRB7g");
	this.shape_66.setTransform(1001.1,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_66).wait(1));

	// Layer 556
	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#D8E6E9").s().p("AiVBNIhaiZIF6AAIBlCZg");
	this.shape_67.setTransform(1021.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_67).wait(1));

	// Layer 557
	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#D8E6E9").s().p("AiRBIIhViQIFuAAIBfCQg");
	this.shape_68.setTransform(1010.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_68).wait(1));

	// Layer 558
	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#D8E6E9").s().p("AiPAjIgphEIFDgBIAuBFg");
	this.shape_69.setTransform(971.3,4.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_69).wait(1));

	// Layer 559
	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#D8E6E9").s().p("AiQAoIgvhPIFKAAIA1BPg");
	this.shape_70.setTransform(977.2,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_70).wait(1));

	// Layer 560
	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#D8E6E9").s().p("AiRAtIg0hZIFQAAIA8BZg");
	this.shape_71.setTransform(983.8,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_71).wait(1));

	// Layer 543
	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#D8E6E9").s().p("AieBBIhCiBIF1AAIBMCBg");
	this.shape_72.setTransform(953.2,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_72).wait(1));

	// Layer 544
	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#D8E6E9").s().p("AigAoIgphPIFkAAIAvBPg");
	this.shape_73.setTransform(940.2,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_73).wait(1));

	// Layer 545
	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#D8E6E9").s().p("AigAiIgihCIFdgBIAoBDg");
	this.shape_74.setTransform(935.1,4.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_74).wait(1));

	// Layer 546
	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#D8E6E9").s().p("AiiAtIguhZIFsAAIA1BZg");
	this.shape_75.setTransform(946,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_75).wait(1));

	// Layer 547
	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#D8E6E9").s().p("AieB4Ih7jvIGmAAICNDvg");
	this.shape_76.setTransform(991.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_76).wait(1));

	// Layer 548
	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#D8E6E9").s().p("AisBvIhxjdIG5AAICCDdg");
	this.shape_77.setTransform(1005,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_77).wait(1));

	// Layer 549
	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#D8E6E9").s().p("AilA+Ig/h7IGAAAIBJB7g");
	this.shape_78.setTransform(961.3,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_78).wait(1));

	// Layer 550
	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#D8E6E9").s().p("AiqBNIhPiZIGYAAIBbCZg");
	this.shape_79.setTransform(979.1,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_79).wait(1));

	// Layer 551
	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#D8E6E9").s().p("AimBIIhKiQIGMAAIBVCQg");
	this.shape_80.setTransform(969.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_80).wait(1));

	// Layer 534
	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#D8E6E9").s().p("Ah6B4IhrjvIFRAAIB6Dvg");
	this.shape_81.setTransform(950,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_81).wait(1));

	// Layer 535
	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#D8E6E9").s().p("AiBA+Ig3h7IEyAAIA/B7g");
	this.shape_82.setTransform(923.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_82).wait(1));

	// Layer 536
	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#D8E6E9").s().p("AiFBNIhFiZIFGAAIBPCZg");
	this.shape_83.setTransform(939.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_83).wait(1));

	// Layer 537
	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#D8E6E9").s().p("AiBBIIhBiQIE7AAIBKCQg");
	this.shape_84.setTransform(931.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_84).wait(1));

	// Layer 538
	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#D8E6E9").s().p("Ah/AtIgphZIEjAAIAuBZg");
	this.shape_85.setTransform(910.5,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_85).wait(1));

	// Layer 539
	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#D8E6E9").s().p("Ah7BBIg6iBIEpAAIBCCBg");
	this.shape_86.setTransform(916.8,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_86).wait(1));

	// Layer 540
	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#D8E6E9").s().p("Ah+AoIgkhPIEcAAIApBPg");
	this.shape_87.setTransform(905.5,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_87).wait(1));

	// Layer 541
	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#D8E6E9").s().p("Ah+AiIgehCIEXgBIAiBDg");
	this.shape_88.setTransform(901,4.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_88).wait(1));

	// Layer 542
	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#D8E6E9").s().p("AiFBvIhkjdIFhAAIByDdg");
	this.shape_89.setTransform(962,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_89).wait(1));

	// Layer 525
	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#D8E6E9").s().p("AimB4IhajvIGVAAIBsDvg");
	this.shape_90.setTransform(909.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_90).wait(1));

	// Layer 526
	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#D8E6E9").s().p("AizBvIhTjdIGpAAIBkDdg");
	this.shape_91.setTransform(920.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_91).wait(1));

	// Layer 527
	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#D8E6E9").s().p("AieAhIgYg/IFQgCIAdBBg");
	this.shape_92.setTransform(867.8,4.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_92).wait(1));

	// Layer 528
	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#D8E6E9").s().p("AifAoIgehPIFXAAIAkBPg");
	this.shape_93.setTransform(871.6,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_93).wait(1));

	// Layer 529
	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#D8E6E9").s().p("AimA+Iguh7IFyAAIA3B7g");
	this.shape_94.setTransform(887.4,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_94).wait(1));

	// Layer 530
	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#D8E6E9").s().p("AitBNIg5iZIGIAAIBFCZg");
	this.shape_95.setTransform(900.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_95).wait(1));

	// Layer 531
	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#D8E6E9").s().p("AioBIIg2iQIF8AAIBBCQg");
	this.shape_96.setTransform(893.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_96).wait(1));

	// Layer 532
	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#D8E6E9").s().p("AifBBIgxiBIFnAAIA6CBg");
	this.shape_97.setTransform(881.4,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_97).wait(1));

	// Layer 533
	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#D8E6E9").s().p("AihAtIgihZIFfAAIAoBZg");
	this.shape_98.setTransform(875.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_98).wait(1));

	// Layer 516
	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#D8E6E9").s().p("AiXBvIhFjdIFmAAIBTDdg");
	this.shape_99.setTransform(878,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_99).wait(1));

	// Layer 517
	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#D8E6E9").s().p("AiMB4IhLjvIFVAAIBaDvg");
	this.shape_100.setTransform(869.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_100).wait(1));

	// Layer 518
	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#D8E6E9").s().p("AiMA+Igmh7IE3AAIAuB7g");
	this.shape_101.setTransform(850.6,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_101).wait(1));

	// Layer 519
	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#D8E6E9").s().p("AiSBNIgwiZIFLAAIA6CZg");
	this.shape_102.setTransform(861.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_102).wait(1));

	// Layer 520
	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#D8E6E9").s().p("AiOBIIgtiQIFAAAIA3CQg");
	this.shape_103.setTransform(856,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_103).wait(1));

	// Layer 521
	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#D8E6E9").s().p("AiGAoIgZhPIEhAAIAeBPg");
	this.shape_104.setTransform(837.5,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_104).wait(1));

	// Layer 522
	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#D8E6E9").s().p("AiFAgIgUg+IEbgBIAYA/g");
	this.shape_105.setTransform(834.3,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_105).wait(1));

	// Layer 523
	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#D8E6E9").s().p("AiGBBIgpiBIEuAAIAxCBg");
	this.shape_106.setTransform(845.6,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_106).wait(1));

	// Layer 524
	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#D8E6E9").s().p("AiIAtIgchZIEnAAIAiBZg");
	this.shape_107.setTransform(841.1,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_107).wait(1));

	// Layer 507
	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#D8E6E9").s().p("AjEALIF+ABIBIDcImPABgAjKgKIg3jeIFwAAIBFDeg");
	this.shape_108.setTransform(842.7,143.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_108).wait(1));

	// Layer 508
	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#D8E6E9").s().p("AiUA+Igfh7IFAAAIAnB7g");
	this.shape_109.setTransform(816.5,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_109).wait(1));

	// Layer 509
	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#D8E6E9").s().p("AibBNIgmiZIFTAAIAwCZg");
	this.shape_110.setTransform(825.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_110).wait(1));

	// Layer 510
	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#D8E6E9").s().p("AiZB4Ig7jvIFfAAIBKDvg");
	this.shape_111.setTransform(831.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_111).wait(1));

	// Layer 511
	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#D8E6E9").s().p("AiXBIIgkiQIFKAAIAtCQg");
	this.shape_112.setTransform(820.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_112).wait(1));

	// Layer 512
	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#D8E6E9").s().p("AiNAoIgThPIEoAAIAZBPg");
	this.shape_113.setTransform(805.8,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_113).wait(1));

	// Layer 513
	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#D8E6E9").s().p("AiLAgIgQg+IEjgBIAUA/g");
	this.shape_114.setTransform(803.2,4.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_114).wait(1));

	// Layer 514
	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#D8E6E9").s().p("AiPBBIggiBIE2AAIApCBg");
	this.shape_115.setTransform(812.4,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_115).wait(1));

	// Layer 515
	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#D8E6E9").s().p("AiPAtIgWhZIEvAAIAcBZg");
	this.shape_116.setTransform(808.7,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_116).wait(1));

	// Layer 498
	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#D8E6E9").s().p("AiYA+IgXh7IFAAAIAfB7g");
	this.shape_117.setTransform(781.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_117).wait(1));

	// Layer 499
	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#D8E6E9").s().p("AihB4IgsjvIFfAAIA8Dvg");
	this.shape_118.setTransform(793.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_118).wait(1));

	// Layer 500
	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#D8E6E9").s().p("AicBIIgaiQIFJAAIAkCQg");
	this.shape_119.setTransform(785.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_119).wait(1));

	// Layer 501
	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#D8E6E9").s().p("AihBNIgciZIFVAAIAmCZg");
	this.shape_120.setTransform(788.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_120).wait(1));

	// Layer 502
	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#D8E6E9").s().p("AiOAfIgLg8IEkgBIAPA9g");
	this.shape_121.setTransform(771.6,4.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_121).wait(1));

	// Layer 503
	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#D8E6E9").s().p("AiPAoIgPhPIEpAAIAUBPg");
	this.shape_122.setTransform(773.6,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_122).wait(1));

	// Layer 504
	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#D8E6E9").s().p("AiTBBIgYiBIE3AAIAgCBg");
	this.shape_123.setTransform(778.8,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_123).wait(1));

	// Layer 505
	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#D8E6E9").s().p("AiSAtIgQhZIEvAAIAWBZg");
	this.shape_124.setTransform(775.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_124).wait(1));

	// Layer 506
	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#D8E6E9").s().p("AifDmIgpjeIGFADIA3DdgAjKgKIgpjdIFxAAIA3Ddg");
	this.shape_125.setTransform(802.3,143.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_125).wait(1));

	// Layer 489
	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#D8E6E9").s().p("AiuDnIgZjeIGGABIApDdgAjNgJIgajdIF9AAIAoDdg");
	this.shape_126.setTransform(760.9,143);

	this.timeline.addTween(cjs.Tween.get(this.shape_126).wait(1));

	// Layer 490
	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#D8E6E9").s().p("AivB4IgcjvIFrAAIAsDvg");
	this.shape_127.setTransform(755.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_127).wait(1));

	// Layer 491
	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#D8E6E9").s().p("AimBIIgRiQIFVAAIAaCQg");
	this.shape_128.setTransform(749.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_128).wait(1));

	// Layer 492
	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#D8E6E9").s().p("AirBNIgSiZIFfAAIAcCZg");
	this.shape_129.setTransform(751.7,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_129).wait(1));

	// Layer 493
	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#D8E6E9").s().p("AiXAoIgJhPIEyAAIAPBPg");
	this.shape_130.setTransform(741,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_130).wait(1));

	// Layer 494
	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#D8E6E9").s().p("AiVAfIgHg8IEtgBIALA9g");
	this.shape_131.setTransform(739.7,4.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_131).wait(1));

	// Layer 495
	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#D8E6E9").s().p("AidBBIgPiBIFBAAIAYCBg");
	this.shape_132.setTransform(744.6,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_132).wait(1));

	// Layer 496
	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#D8E6E9").s().p("AiaAtIgKhZIE5AAIARBZg");
	this.shape_133.setTransform(742.6,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_133).wait(1));

	// Layer 497
	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#D8E6E9").s().p("AiiA+IgOh7IFLAAIAWB7g");
	this.shape_134.setTransform(746.8,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_134).wait(1));

	// Layer 480
	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#D8E6E9").s().p("AixB4IgMjvIFfAAIAcDvg");
	this.shape_135.setTransform(716.4,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_135).wait(1));

	// Layer 481
	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#D8E6E9").s().p("AjCAKIF7gBIAaDeImJAAgAjGgJIgMjdIFwAAIAaDdg");
	this.shape_136.setTransform(719.8,143);

	this.timeline.addTween(cjs.Tween.get(this.shape_136).wait(1));

	// Layer 482
	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#D8E6E9").s().p("AilBIIgIiQIFKAAIARCQg");
	this.shape_137.setTransform(713,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_137).wait(1));

	// Layer 483
	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#D8E6E9").s().p("AigA+IgHh7IFAAAIAPB7g");
	this.shape_138.setTransform(711.7,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_138).wait(1));

	// Layer 484
	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#D8E6E9").s().p("AiYAtIgEhZIEvAAIALBZg");
	this.shape_139.setTransform(709.3,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_139).wait(1));

	// Layer 485
	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#D8E6E9").s().p("AicBBIgGiBIE2AAIAPCBg");
	this.shape_140.setTransform(710.5,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_140).wait(1));

	// Layer 486
	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#D8E6E9").s().p("AiUAoIgFhPIEpAAIAKBPg");
	this.shape_141.setTransform(708.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_141).wait(1));

	// Layer 487
	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#D8E6E9").s().p("AiSAeIgDg6IEkgBIAHA7g");
	this.shape_142.setTransform(707.7,4.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_142).wait(1));

	// Layer 488
	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#D8E6E9").s().p("AiqBNIgIiZIFUAAIASCZg");
	this.shape_143.setTransform(714.5,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_143).wait(1));

	// Layer 471
	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#D8E6E9").s().p("AiYBvIAAjdIEmAAIALDdg");
	this.shape_144.setTransform(682.6,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_144).wait(1));

	// Layer 472
	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#D8E6E9").s().p("AiSB4IAAjvIEYAAIANDvg");
	this.shape_145.setTransform(682,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_145).wait(1));

	// Layer 473
	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#D8E6E9").s().p("AiCA+IAAh7ID/AAIAGB7g");
	this.shape_146.setTransform(680.4,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_146).wait(1));

	// Layer 474
	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#D8E6E9").s().p("AiLBNIAAiZIEPAAIAICZg");
	this.shape_147.setTransform(681.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_147).wait(1));

	// Layer 475
	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#D8E6E9").s().p("AiHBIIAAiQIEHAAIAICQg");
	this.shape_148.setTransform(680.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_148).wait(1));

	// Layer 476
	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#D8E6E9").s().p("Ah1AeIAAg6IDogBIADA7g");
	this.shape_149.setTransform(679.1,4.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_149).wait(1));

	// Layer 477
	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#D8E6E9").s().p("Ah4AoIAAhPIDtAAIAEBPg");
	this.shape_150.setTransform(679.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_150).wait(1));

	// Layer 478
	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#D8E6E9").s().p("Ah/BBIAAiBID4AAIAHCBg");
	this.shape_151.setTransform(680.1,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_151).wait(1));

	// Layer 479
	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#D8E6E9").s().p("Ah7AtIAAhZIDyAAIAFBZg");
	this.shape_152.setTransform(679.7,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_152).wait(1));

	// Layer 462
	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#D8E6E9").s().p("AieB4IAOjvIEuAAIAADvg");
	this.shape_153.setTransform(649.5,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_153).wait(1));

	// Layer 463
	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#D8E6E9").s().p("AikBuIAMjcIE9AAIAADdg");
	this.shape_154.setTransform(648.8,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_154).wait(1));

	// Layer 464
	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#D8E6E9").s().p("AiNA+IAHh7IEUAAIAAB7g");
	this.shape_155.setTransform(651.1,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_155).wait(1));

	// Layer 465
	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#D8E6E9").s().p("AiWBNIAIiZIElAAIAACZg");
	this.shape_156.setTransform(650.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_156).wait(1));

	// Layer 466
	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#D8E6E9").s().p("AiRBIIAIiQIEbAAIAACQg");
	this.shape_157.setTransform(650.7,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_157).wait(1));

	// Layer 467
	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#D8E6E9").s().p("AiCAoIAFhPIEAAAIAABPg");
	this.shape_158.setTransform(652.2,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_158).wait(1));

	// Layer 468
	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#D8E6E9").s().p("Ah/AdIADg4ID8gBIAAA5g");
	this.shape_159.setTransform(652.5,4.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_159).wait(1));

	// Layer 469
	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#D8E6E9").s().p("AiJBBIAIiBIELAAIAACBg");
	this.shape_160.setTransform(651.5,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_160).wait(1));

	// Layer 470
	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#D8E6E9").s().p("AiFAtIAFhZIEGAAIAABZg");
	this.shape_161.setTransform(651.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_161).wait(1));

	// Layer 453
	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#D8E6E9").s().p("AiiBuIAYjbIEtAAIgMDbg");
	this.shape_162.setTransform(615.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_162).wait(1));

	// Layer 454
	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#D8E6E9").s().p("AicB4IAajvIEfAAIgODvg");
	this.shape_163.setTransform(617.3,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_163).wait(1));

	// Layer 455
	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#D8E6E9").s().p("AiOBIIAQiQIEMAAIgICQg");
	this.shape_164.setTransform(620.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_164).wait(1));

	// Layer 456
	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#D8E6E9").s().p("AiTBNIARiZIEVAAIgICZg");
	this.shape_165.setTransform(619.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_165).wait(1));

	// Layer 457
	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#D8E6E9").s().p("AiIA+IANh7IEEAAIgGB7g");
	this.shape_166.setTransform(621.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_166).wait(1));

	// Layer 458
	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#D8E6E9").s().p("AiAAtIAKhZID3AAIgFBZg");
	this.shape_167.setTransform(624.2,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_167).wait(1));

	// Layer 459
	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#D8E6E9").s().p("AiFBBIAOiBID9AAIgICBg");
	this.shape_168.setTransform(623.1,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_168).wait(1));

	// Layer 460
	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#D8E6E9").s().p("Ah9AoIAJhPIDxAAIgEBPg");
	this.shape_169.setTransform(625.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_169).wait(1));

	// Layer 461
	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#D8E6E9").s().p("Ah5AdIAGg4IDtgBIgDA5g");
	this.shape_170.setTransform(625.8,4.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_170).wait(1));

	// Layer 444
	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#D8E6E9").s().p("AieBuIAkjbIEYAAIgXDbg");
	this.shape_171.setTransform(583.5,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_171).wait(1));

	// Layer 445
	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#D8E6E9").s().p("AiIBIIAXiQID6AAIgPCQg");
	this.shape_172.setTransform(592.2,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_172).wait(1));

	// Layer 446
	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#D8E6E9").s().p("AiZB4IAnjvIELAAIgaDvg");
	this.shape_173.setTransform(586.9,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_173).wait(1));

	// Layer 447
	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#D8E6E9").s().p("AiNBNIAYiZIEDAAIgRCZg");
	this.shape_174.setTransform(589.9,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_174).wait(1));

	// Layer 448
	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#D8E6E9").s().p("AiDA+IATh7ID0AAIgNB7g");
	this.shape_175.setTransform(594.3,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_175).wait(1));

	// Layer 449
	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#D8E6E9").s().p("AhzAcIAJg2IDegBIgGA3g");
	this.shape_176.setTransform(600.7,4.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_176).wait(1));

	// Layer 450
	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#D8E6E9").s().p("Ah3AoIANhPIDiAAIgJBPg");
	this.shape_177.setTransform(599.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_177).wait(1));

	// Layer 451
	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#D8E6E9").s().p("AiABBIAViBIDsAAIgOCBg");
	this.shape_178.setTransform(596.2,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_178).wait(1));

	// Layer 452
	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#D8E6E9").s().p("Ah6AtIAOhZIDnAAIgKBZg");
	this.shape_179.setTransform(598,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_179).wait(1));

	// Layer 435
	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#D8E6E9").s().p("AigB4IAyjvIEPAAIgmDvg");
	this.shape_180.setTransform(557.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_180).wait(1));

	// Layer 436
	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#D8E6E9").s().p("AilBuIAujbIEdAAIgjDbg");
	this.shape_181.setTransform(552.6,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_181).wait(1));

	// Layer 437
	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#D8E6E9").s().p("AiIA+IAah7ID3AAIgUB7g");
	this.shape_182.setTransform(567.3,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_182).wait(1));

	// Layer 438
	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#D8E6E9").s().p("AiTBNIAgiZIEHAAIgZCZg");
	this.shape_183.setTransform(561.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_183).wait(1));

	// Layer 439
	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#D8E6E9").s().p("AiOBIIAfiQID+AAIgXCQg");
	this.shape_184.setTransform(564.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_184).wait(1));

	// Layer 440
	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#D8E6E9").s().p("Ah6AoIAQhPIDlAAIgNBPg");
	this.shape_185.setTransform(574.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_185).wait(1));

	// Layer 441
	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#D8E6E9").s().p("AiFBBIAbiBIDwAAIgVCBg");
	this.shape_186.setTransform(570,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_186).wait(1));

	// Layer 442
	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#D8E6E9").s().p("Ah+AtIAThZIDqAAIgOBZg");
	this.shape_187.setTransform(572.4,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_187).wait(1));

	// Layer 443
	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#D8E6E9").s().p("Ah2AcIALg2IDigBIgJA3g");
	this.shape_188.setTransform(576,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_188).wait(1));

	// Layer 426
	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#D8E6E9").s().p("Ai0BuIA6jbIEvAAIguDbg");
	this.shape_189.setTransform(520.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_189).wait(1));

	// Layer 427
	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#D8E6E9").s().p("AiwB4IBAjvIEhAAIgzDvg");
	this.shape_190.setTransform(526.3,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_190).wait(1));

	// Layer 428
	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#D8E6E9").s().p("AigBNIApiZIEYAAIghCZg");
	this.shape_191.setTransform(531.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_191).wait(1));

	// Layer 429
	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#D8E6E9").s().p("AiaBIIAmiQIEPAAIgeCQg");
	this.shape_192.setTransform(535.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_192).wait(1));

	// Layer 430
	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#D8E6E9").s().p("AiIAtIAYhZID5AAIgTBZg");
	this.shape_193.setTransform(545.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_193).wait(1));

	// Layer 431
	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#D8E6E9").s().p("AiTA+IAgh7IEHAAIgZB7g");
	this.shape_194.setTransform(539.3,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_194).wait(1));

	// Layer 432
	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#D8E6E9").s().p("AiQBBIAiiBID/AAIgbCBg");
	this.shape_195.setTransform(542.8,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_195).wait(1));

	// Layer 433
	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#D8E6E9").s().p("AiEAoIAVhPID0AAIgRBPg");
	this.shape_196.setTransform(548.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_196).wait(1));

	// Layer 434
	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#D8E6E9").s().p("Ah/AbIAOg0IDxgBIgLA1g");
	this.shape_197.setTransform(550.5,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_197).wait(1));

	// Layer 417
	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#D8E6E9").s().p("AjIB4IBNjvIFEAAIg/Dvg");
	this.shape_198.setTransform(492.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_198).wait(1));

	// Layer 418
	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#D8E6E9").s().p("AjNBuIBIjbIFTAAIg7Dbg");
	this.shape_199.setTransform(485.5,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_199).wait(1));

	// Layer 419
	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#D8E6E9").s().p("AivBIIAviQIEvAAIgmCQg");
	this.shape_200.setTransform(504.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_200).wait(1));

	// Layer 420
	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#D8E6E9").s().p("Ai1BNIAyiZIE5AAIgpCZg");
	this.shape_201.setTransform(499.3,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_201).wait(1));

	// Layer 421
	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#D8E6E9").s().p("AinA+IAoh7IEnAAIghB7g");
	this.shape_202.setTransform(508.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_202).wait(1));

	// Layer 422
	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#D8E6E9").s().p("AijBBIAqiBIEdAAIgiCBg");
	this.shape_203.setTransform(513.1,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_203).wait(1));

	// Layer 423
	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#D8E6E9").s().p("AiOAbIAQgzIENgCIgOA1g");
	this.shape_204.setTransform(522.7,5);

	this.timeline.addTween(cjs.Tween.get(this.shape_204).wait(1));

	// Layer 424
	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#D8E6E9").s().p("AiVAoIAahPIERAAIgVBPg");
	this.shape_205.setTransform(520.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_205).wait(1));

	// Layer 425
	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#D8E6E9").s().p("AiZAtIAdhZIEWAAIgXBZg");
	this.shape_206.setTransform(517,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_206).wait(1));

	// Layer 408
	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#D8E6E9").s().p("AjIBuIBUjbIE9AAIhIDbg");
	this.shape_207.setTransform(449.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_207).wait(1));

	// Layer 409
	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#D8E6E9").s().p("AjEB4IBbjvIEuAAIhNDvg");
	this.shape_208.setTransform(458.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_208).wait(1));

	// Layer 410
	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#D8E6E9").s().p("AipBIIA3iQIEcAAIgvCQg");
	this.shape_209.setTransform(472.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_209).wait(1));

	// Layer 411
	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#D8E6E9").s().p("AivBNIA7iZIEkAAIgyCZg");
	this.shape_210.setTransform(466.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_210).wait(1));

	// Layer 412
	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#D8E6E9").s().p("AihA+IAvh7IETAAIgnB7g");
	this.shape_211.setTransform(477.8,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_211).wait(1));

	// Layer 413
	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#D8E6E9").s().p("AiHAaIATgyID8gBIgQAzg");
	this.shape_212.setTransform(494.3,5.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_212).wait(1));

	// Layer 414
	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#D8E6E9").s().p("AiOAoIAehPIEAAAIgaBPg");
	this.shape_213.setTransform(491.3,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_213).wait(1));

	// Layer 415
	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#D8E6E9").s().p("AieBBIAyiBIELAAIgqCBg");
	this.shape_214.setTransform(483,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_214).wait(1));

	// Layer 416
	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#D8E6E9").s().p("AiTAtIAihZIEFAAIgdBZg");
	this.shape_215.setTransform(487.6,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_215).wait(1));

	// Layer 399
	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#D8E6E9").s().p("AjSBuIBgjbIFFAAIhUDbg");
	this.shape_216.setTransform(415,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_216).wait(1));

	// Layer 400
	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#D8E6E9").s().p("AjPB4IBpjvIE2AAIhbDvg");
	this.shape_217.setTransform(425.2,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_217).wait(1));

	// Layer 401
	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#D8E6E9").s().p("AinA+IA1h7IEaAAIguB7g");
	this.shape_218.setTransform(447.4,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_218).wait(1));

	// Layer 402
	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#D8E6E9").s().p("Ai3BNIBDiZIEsAAIg7CZg");
	this.shape_219.setTransform(434.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_219).wait(1));

	// Layer 403
	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#D8E6E9").s().p("AiwBIIA/iQIEiAAIg3CQg");
	this.shape_220.setTransform(441.1,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_220).wait(1));

	// Layer 404
	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#D8E6E9").s().p("AilBBIA5iBIESAAIgyCBg");
	this.shape_221.setTransform(453.4,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_221).wait(1));

	// Layer 405
	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#D8E6E9").s().p("AiYAtIAmhZIELAAIgiBZg");
	this.shape_222.setTransform(458.7,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_222).wait(1));

	// Layer 406
	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#D8E6E9").s().p("AiLAaIAWgxIEBgBIgTAyg");
	this.shape_223.setTransform(466.5,5.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_223).wait(1));

	// Layer 407
	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#D8E6E9").s().p("AiUAoIAjhPIEFAAIgeBPg");
	this.shape_224.setTransform(463,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_224).wait(1));

	// Layer 390
	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#D8E6E9").s().p("AkKB4IB7jvIGaAAIhpDvg");
	this.shape_225.setTransform(386,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_225).wait(1));

	// Layer 391
	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#D8E6E9").s().p("AkPBuIBxjbIGuAAIhhDbg");
	this.shape_226.setTransform(374.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_226).wait(1));

	// Layer 392
	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#D8E6E9").s().p("AjaA+IA/h7IF2AAIg2B7g");
	this.shape_227.setTransform(411.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_227).wait(1));

	// Layer 393
	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#D8E6E9").s().p("AjtBNIBOiZIGOAAIhECZg");
	this.shape_228.setTransform(396.5,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_228).wait(1));

	// Layer 394
	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#D8E6E9").s().p("AjlBIIBKiQIGBAAIg/CQg");
	this.shape_229.setTransform(404.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_229).wait(1));

	// Layer 395
	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#D8E6E9").s().p("AjWBBIBCiBIFrAAIg5CBg");
	this.shape_230.setTransform(418.8,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_230).wait(1));

	// Layer 396
	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#D8E6E9").s().p("AjIAtIAuhZIFjAAIgnBZg");
	this.shape_231.setTransform(425,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_231).wait(1));

	// Layer 397
	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#D8E6E9").s().p("Ai3AZIAZgwIFWgBIgWAxg");
	this.shape_232.setTransform(434.1,5.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_232).wait(1));

	// Layer 398
	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#D8E6E9").s().p("AjCAoIAphPIFcAAIgjBPg");
	this.shape_233.setTransform(430,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_233).wait(1));

	// Layer 381
	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#D8E6E9").s().p("AkEBuICAjbIGJAAIhxDbg");
	this.shape_234.setTransform(329.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_234).wait(1));

	// Layer 382
	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#D8E6E9").s().p("AkBB4ICMjvIF3AAIh7Dvg");
	this.shape_235.setTransform(343.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_235).wait(1));

	// Layer 383
	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#D8E6E9").s().p("AjOA+IBHh7IFWAAIg/B7g");
	this.shape_236.setTransform(373.3,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_236).wait(1));

	// Layer 384
	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#D8E6E9").s().p("AjiBNIBaiZIFrAAIhPCZg");
	this.shape_237.setTransform(355.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_237).wait(1));

	// Layer 385
	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#D8E6E9").s().p("AjaBIIBViQIFgAAIhLCQg");
	this.shape_238.setTransform(364.8,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_238).wait(1));

	// Layer 386
	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#D8E6E9").s().p("Ai8AtIA0hZIFFAAIguBZg");
	this.shape_239.setTransform(388.4,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_239).wait(1));

	// Layer 387
	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#D8E6E9").s().p("AjLBBIBLiBIFMAAIhCCBg");
	this.shape_240.setTransform(381.3,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_240).wait(1));

	// Layer 388
	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#D8E6E9").s().p("Ai2AoIAvhPIE+AAIgpBPg");
	this.shape_241.setTransform(394.2,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_241).wait(1));

	// Layer 389
	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#D8E6E9").s().p("AiqAYIAbguIE6gBIgZAvg");
	this.shape_242.setTransform(398.8,5.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_242).wait(1));

	// Layer 372
	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#D8E6E9").s().p("AkkB4ICejvIGrAAIiMDvg");
	this.shape_243.setTransform(300.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_243).wait(1));

	// Layer 373
	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#D8E6E9").s().p("AknBuICRjbIG+AAIiADbg");
	this.shape_244.setTransform(284.7,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_244).wait(1));

	// Layer 374
	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#D8E6E9").s().p("AjqA+IBRh7IGEAAIhHB7g");
	this.shape_245.setTransform(333.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_245).wait(1));

	// Layer 375
	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#D8E6E9").s().p("AjnBBIBWiBIF5AAIhMCBg");
	this.shape_246.setTransform(343,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_246).wait(1));

	// Layer 376
	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#D8E6E9").s().p("AkBBNIBmiZIGcAAIhZCZg");
	this.shape_247.setTransform(313.8,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_247).wait(1));

	// Layer 377
	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#D8E6E9").s().p("Aj3BIIBfiQIGQAAIhUCQg");
	this.shape_248.setTransform(324.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_248).wait(1));

	// Layer 378
	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#D8E6E9").s().p("AjBAYIAegtIFlgCIgcAvg");
	this.shape_249.setTransform(362.9,5.3);

	this.timeline.addTween(cjs.Tween.get(this.shape_249).wait(1));

	// Layer 379
	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#D8E6E9").s().p("AjOAoIA1hPIFoAAIguBPg");
	this.shape_250.setTransform(357.6,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_250).wait(1));

	// Layer 380
	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#D8E6E9").s().p("AjVAtIA7hZIFwAAIg0BZg");
	this.shape_251.setTransform(351.1,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_251).wait(1));

	// Layer 363
	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#D8E6E9").s().p("AjsBuICdjbIE8AAIiRDbg");
	this.shape_252.setTransform(243.4,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_252).wait(1));

	// Layer 364
	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#D8E6E9").s().p("AjsB4ICsjvIEtAAIieDvg");
	this.shape_253.setTransform(260.6,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_253).wait(1));

	// Layer 365
	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#D8E6E9").s().p("AjIBNIBuiZIEjAAIhlCZg");
	this.shape_254.setTransform(275.6,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_254).wait(1));

	// Layer 366
	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#D8E6E9").s().p("AjBBIIBoiQIEaAAIhfCQg");
	this.shape_255.setTransform(287.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_255).wait(1));

	// Layer 367
	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#D8E6E9").s().p("Ai1A+IBYh7IETAAIhRB7g");
	this.shape_256.setTransform(297.9,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_256).wait(1));

	// Layer 368
	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#D8E6E9").s().p("AizBBIBdiBIEKAAIhWCBg");
	this.shape_257.setTransform(308,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_257).wait(1));

	// Layer 369
	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#D8E6E9").s().p("AiNAXIAggsID7gBIgeAtg");
	this.shape_258.setTransform(329.9,5.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_258).wait(1));

	// Layer 370
	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#D8E6E9").s().p("AibAoIA5hPID+AAIg0BPg");
	this.shape_259.setTransform(324.2,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_259).wait(1));

	// Layer 371
	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#D8E6E9").s().p("AihAtIBAhZIEDAAIg7BZg");
	this.shape_260.setTransform(316.9,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_260).wait(1));

	// Layer 354
	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#D8E6E9").s().p("AlHB4IDAjvIHPAAIisDvg");
	this.shape_261.setTransform(218.8,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_261).wait(1));

	// Layer 355
	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#D8E6E9").s().p("AlKBuICwjbIHlAAIidDbg");
	this.shape_262.setTransform(199.9,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_262).wait(1));

	// Layer 356
	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#D8E6E9").s().p("AkEA+IBjh7IGmAAIhYB7g");
	this.shape_263.setTransform(260,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_263).wait(1));

	// Layer 357
	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#D8E6E9").s().p("AkeBNIB8iZIHBAAIhvCZg");
	this.shape_264.setTransform(235.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_264).wait(1));

	// Layer 358
	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#D8E6E9").s().p("AkTBIIB0iQIGzAAIhoCQg");
	this.shape_265.setTransform(248.3,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_265).wait(1));

	// Layer 359
	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#D8E6E9").s().p("AjTAXIAjgrIGEgBIggAsg");
	this.shape_266.setTransform(295.2,5.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_266).wait(1));

	// Layer 360
	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#D8E6E9").s().p("AjjAoIBAhPIGIAAIg6BPg");
	this.shape_267.setTransform(288.9,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_267).wait(1));

	// Layer 361
	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#D8E6E9").s().p("AkABBIBoiBIGZAAIhdCBg");
	this.shape_268.setTransform(271.1,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_268).wait(1));

	// Layer 362
	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#D8E6E9").s().p("AjrAtIBHhZIGQAAIhABZg");
	this.shape_269.setTransform(281,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_269).wait(1));

	// Layer 345
	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#D8E6E9").s().p("AknBuIDAjbIGPAAIiwDbg");
	this.shape_270.setTransform(152.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_270).wait(1));

	// Layer 346
	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#D8E6E9").s().p("AkmB4IDQjvIF9AAIjADvg");
	this.shape_271.setTransform(173.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_271).wait(1));

	// Layer 347
	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#D8E6E9").s().p("Aj7BNICGiZIFxAAIh7CZg");
	this.shape_272.setTransform(191.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_272).wait(1));

	// Layer 348
	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#D8E6E9").s().p("AjxBIIB+iQIFlAAIh0CQg");
	this.shape_273.setTransform(205.6,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_273).wait(1));

	// Layer 349
	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#D8E6E9").s().p("AjiA+IBrh7IFaAAIhiB7g");
	this.shape_274.setTransform(218.5,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_274).wait(1));

	// Layer 350
	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#D8E6E9").s().p("AjgBBIBxiBIFQAAIhoCBg");
	this.shape_275.setTransform(230.7,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_275).wait(1));

	// Layer 351
	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#D8E6E9").s().p("AjDAoIBFhPIFCAAIhABPg");
	this.shape_276.setTransform(250.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_276).wait(1));

	// Layer 352
	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#D8E6E9").s().p("AixAWIAlgpIE+gCIgjArg");
	this.shape_277.setTransform(257.2,5.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_277).wait(1));

	// Layer 353
	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#D8E6E9").s().p("AjLAtIBOhZIFJAAIhIBZg");
	this.shape_278.setTransform(241.6,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_278).wait(1));

	// Layer 336
	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#D8E6E9").s().p("AlSBuIDSjbIHTAAIjADbg");
	this.shape_279.setTransform(105.3,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_279).wait(1));

	// Layer 337
	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#D8E6E9").s().p("AlQB4IDkjvIG+AAIjRDvg");
	this.shape_280.setTransform(128.1,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_280).wait(1));

	// Layer 338
	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#D8E6E9").s().p("AkFA+IB1h7IGWAAIhrB7g");
	this.shape_281.setTransform(177.6,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_281).wait(1));

	// Layer 339
	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#D8E6E9").s().p("AkgBNICSiZIGwAAIiHCZg");
	this.shape_282.setTransform(148,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_282).wait(1));

	// Layer 340
	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#D8E6E9").s().p("AkWBIICLiQIGhAAIh+CQg");
	this.shape_283.setTransform(163.5,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_283).wait(1));

	// Layer 341
	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#D8E6E9").s().p("AjiAoIBMhPIF5AAIhFBPg");
	this.shape_284.setTransform(212.4,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_284).wait(1));

	// Layer 342
	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#D8E6E9").s().p("AkCBBIB7iBIGKAAIhxCBg");
	this.shape_285.setTransform(190.9,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_285).wait(1));

	// Layer 343
	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#D8E6E9").s().p("AjOAVIAngoIF2gBIglApg");
	this.shape_286.setTransform(219.9,5.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_286).wait(1));

	// Layer 344
	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#D8E6E9").s().p("AjrAtIBVhZIGCAAIhOBZg");
	this.shape_287.setTransform(202.8,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_287).wait(1));

	// Layer 327
	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#D8E6E9").s().p("AkcBuIDfjbIFaAAIjSDbg");
	this.shape_288.setTransform(61.2,130.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_288).wait(1));

	// Layer 328
	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#D8E6E9").s().p("AkeB4ID0jvIFJAAIjlDvg");
	this.shape_289.setTransform(85.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_289).wait(1));

	// Layer 329
	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#D8E6E9").s().p("AjjBIICTiQIE0AAIiKCQg");
	this.shape_290.setTransform(123.9,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_290).wait(1));

	// Layer 330
	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#D8E6E9").s().p("AjtBNICdiZIE+AAIiTCZg");
	this.shape_291.setTransform(107.2,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_291).wait(1));

	// Layer 331
	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#D8E6E9").s().p("AjUA+IB9h7IEsAAIh2B7g");
	this.shape_292.setTransform(139.1,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_292).wait(1));

	// Layer 332
	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#D8E6E9").s().p("AjSBBICDiBIEiAAIh7CBg");
	this.shape_293.setTransform(153.5,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_293).wait(1));

	// Layer 333
	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#D8E6E9").s().p("AizAoIBRhPIEWAAIhNBPg");
	this.shape_294.setTransform(176.6,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_294).wait(1));

	// Layer 334
	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#D8E6E9").s().p("AidAUIAogmIETgBIgnAng");
	this.shape_295.setTransform(184.5,5.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_295).wait(1));

	// Layer 335
	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#D8E6E9").s().p("Ai7AtIBbhZIEcAAIhWBZg");
	this.shape_296.setTransform(166.3,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_296).wait(1));

	// Layer 318
	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#D8E6E9").s().p("AC1D3IAAgJIgIAAIAAgEIF3AAIACANgAibD3IAAgJIEeAAIAIAAIAAAJgAnjD3IABgJIErAAIAAAJgAs+D3IABgJIEjAAIgBAJgAygD3IABgJIEqAAIgBAJgA4ED3IACgJIE+AAIgBAJgA9+D3IACgHIFjAAIgCAHgEgjwAD3IADgJIFIAAIgCAJgEgpnAD3IACgGIFRAAIgCAGgEgxKAD3IAEgIIHAAAIgCAIgEg4PAD3IADgGIGXAAIgDAGgEhASAD3IAGgKIHZAAIgGAKgEhFuAD3IAGgKIE+AAIgGAKgEhOMAD3IAHgKIH+AAIgHAKgEhVMAD3IAIgJIGiAAIgHAJgEhdcAD3IAIgKIHeAAIgIAKgEhjxAD3IAJgJIFtAAIgIAJgEhrwAD3IAMgJIHSAAIgJAJgEBm0ADqIgEgFIjpjZIFJAAIEgDegEBi6ADqIjmjeIDWAAIDvDegEBbUADqIjUjeIG3AAIDmDegEBUzADqIjGjeIF2AAIDVDegEBNDADqIi0jeIHDAAIDGDegEgpXADfIBVjdIFNAAIhHDdgEg4BADeIByjcIGRAAIhjDcgAiygFIFEAEIgEDdIlFACgAoaDbIAZjcIE6gBIgGDggA96DeIA6jdIFfAAIg1DdgEBF2ADcIikjdIGvAAIC0DdgEgw+ADcIBhjcIG6AAIhODcgAs4gBIEeAAIgYDcIkqAAgAyeDbIAkjcIEnAAIgkDcgA34DbIAujcIE6AAIgpDcgEgjlADbIBHjcIFEAAIg4DcgAClDbIgBjfIE0ADIAODcgEhVSADbICxjcIGdAAIifDcgEhj9ADaIDSjbIFoAAIjADcgEg/7ADaICBjbIHSAAIh5DbgEhFaADaICIjbIE6AAIh/DbgEhOGADaICfjbIH2AAIiSDbgEhdcADaIDAjbIHYAAIiyDbgEhsvADaIEPjbIHNAAIjhDbgEA3fADZIiDjdIGcAAICTDdgEAv6ADVIhxjdIG8AAICDDdgEA+iADVIiSjdIGeAAICjDdgEApyADVIhkjdIFjAAIByDdgEAigADVIhUjdIGsAAIBkDdgEhnQgAaIENjcIFnAAIjgDcg");
	this.shape_297.setTransform(650.4,144.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_297).wait(1));

	// Layer 320
	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#D8E6E9").s().p("AkqB4IEljvIEwAAIjzDvg");
	this.shape_298.setTransform(48.7,105.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_298).wait(1));

	// Layer 319
	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#D8E6E9").s().p("AjjBNIC8iZIELAAIicCZg");
	this.shape_299.setTransform(73.4,84.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_299).wait(1));

	// Layer 321
	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#D8E6E9").s().p("AiwA+ICWh7IDLAAIh9B7g");
	this.shape_300.setTransform(109.8,51.8);

	this.timeline.addTween(cjs.Tween.get(this.shape_300).wait(1));

	// Layer 322
	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#D8E6E9").s().p("AjNBIICyiQIDpAAIiUCQg");
	this.shape_301.setTransform(92.4,67.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_301).wait(1));

	// Layer 323
	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#D8E6E9").s().p("AiBAtIBuhZICVAAIhbBZg");
	this.shape_302.setTransform(140.8,24.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_302).wait(1));

	// Layer 324
	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#D8E6E9").s().p("AhwAoIBhhPICAAAIhRBPg");
	this.shape_303.setTransform(152.6,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_303).wait(1));

	// Layer 325
	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#D8E6E9").s().p("AilBBICfiBICsAAIiECBg");
	this.shape_304.setTransform(126.1,37.2);

	this.timeline.addTween(cjs.Tween.get(this.shape_304).wait(1));

	// Layer 326
	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#D8E6E9").s().p("AhRAUIAvgmIB0gBIgoAng");
	this.shape_305.setTransform(161.7,5.7);

	this.timeline.addTween(cjs.Tween.get(this.shape_305).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroombfloor, new cjs.Rectangle(-45.6,0,1420.8,169.3), null);


(lib.BarofSoapShadow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FDB4FE").s().p("AhjCnQgdgigDg6QgCgcAChJIABhOQABgzASgZQAHgLARgJQAPgIBUAEQBWADAPANQAQANgBAUIAFEBQAABBgbAPQgUALgjAHQgfAGgZAAQg9AAghgngAhKi8QgPADgJASQgGAMgHAbQgDANABATIABAgQAABXABArQAEB4BsAAQAuAAAXgIQAtgQAAgvIgHkIQAAgRgGgHQgLgMghgCQgxgEghAAQggAAgSADg");
	this.shape.setTransform(13.3,20.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BarofSoapShadow, new cjs.Rectangle(0,0,26.6,41.3), null);


(lib.bathroombackgroundrubberduck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.RubberDuckieBeak();
	this.instance.parent = this;
	this.instance.setTransform(52,35.5,1,1,0,0,0,18.2,10.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("AiFAgIgDgPQAAgiAegJIAJgCQAVAAAAAkQAAAKgDAIIgCAFQgIAQgSAAQgTAAgHgPgABqAWIgLgIQgWgXAMgaIAEgHQAMgNAXAZQAGAGADAIIAAAAIACAGQADAIgCAHQgCAFgEAFQgIAJgIAAQgEAAgEgCg");
	this.shape.setTransform(50.2,18.8);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AiRAwIgCgTQABhAAogIQALgCAKAGIgJABQgeAJAAAjIADAPQAGAPAUAAQASAAAIgQIACgFQgCAPgHAMQgOAYgeAAQgSAAgHgSgABMgCQgOgXAAgLQAAgRAOgHQAMgHARAEQAgAIAIAbQgDgHgGgHQgXgYgMANIgEAHQgMAaAWAWIALAIQANAGAKgMQAFgEACgGIgBATQgEAPgVAAQgcAAgSgeg");
	this.shape_1.setTransform(49.1,19.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape},{t:this.instance}]}).wait(1));

	// Layer 3
	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#F2AA04").s().p("AhyA9QhBg7gEguQAAgHABgDIACgIIAAABQAKgTAUgBQAPAAAFAEIAAgDQAAg5AzAXQANAGALAJQABglAbALQAbALAGASIACAFQgMgWgUgEQgZgFAGAdQAQAVgBAPIgBALQAAgGgDgJQgFgPgKgKQgZgYgSADQgLACgFADQgIAFgBAMQgBAFACAJQAQAMAIARQgBACgQgMQgTgOgRgBQgOgBgIALQgEAFAAAJIADALQAGAZAlAoQANATA5AcQBAAhAtAAQBAAAAegXQAQgLAEgPQADgJgBgZQgBgTAKgLQAEADgDAQIACAkQgBAVgHAOQgWAkhfADIgIAAQhaAAhLhEg");
	this.shape_2.setTransform(24.9,71.6);

	this.timeline.addTween(cjs.Tween.get(this.shape_2).wait(1));

	// Layer 1
	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FDD93A").s().p("AljExQgwgzgXg/QgQgrAAgiQAAg+AGggQALhMAmAAQARAAAWAOIApAhQA7AtA6AAIA3gBIAOgKQAKgIACgEQAJgVgQgIIgegOQg3gZgHhNQgFgzAMgiQAVhWAvg/QBDhaBZAFQA1ACAlAUQAnAVAYAoQAyBUAdAkQAVAaAJAWQAOAhgGAhQgFAWgTAVQgPAQgcATIBDAwQArAfAPARQA/BEARAtQALAfAABGQAABIhIA3QheBIi1AAQk2AAiMiUg");
	this.shape_3.setTransform(44.3,45.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_3).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroombackgroundrubberduck, new cjs.Rectangle(0,0.3,88.5,90.6), null);


(lib.soapdishtogether = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.SoapDish();
	this.instance.parent = this;
	this.instance.setTransform(32.8,8.8,1,1,0,0,0,32.8,8.8);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",-2,0,10);

	this.instance_1 = new lib.SoapDish();
	this.instance_1.parent = this;
	this.instance_1.setTransform(33.1,16.2,0.893,0.893,0,0,0,32.5,8.8);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",-2,0,10);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.soapdishtogether, new cjs.Rectangle(-13,-11,91,50.4), null);


(lib.RoundBrushHandle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.RoundBrushHandleDetail();
	this.instance.parent = this;
	this.instance.setTransform(29.9,6.8,1,1,0,0,0,28.5,7.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,10);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#996600").s().p("AkNA7QgRgRgGgVQgDgJAAgKQAAg5BRgeQBFgZByAAQBSgGBSAKQClAVgCBQQgCBDhBAXQhNAcjjAAQiNAAg1g2g");
	this.shape.setTransform(29.6,11.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.RoundBrushHandle, new cjs.Rectangle(-10.6,-11.4,82,39), null);


(lib.RoundBrush = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.RoundBrushBristlesTop();
	this.instance.parent = this;
	this.instance.setTransform(33.4,-9.3,1,0.804,0,0,0,25.8,8.9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 2
	this.instance_1 = new lib.RoundBrushBristles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(33.2,-2.1,1,1,0,0,0,26.8,12.9);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,10);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Layer 1
	this.instance_2 = new lib.RoundBrushHandle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(29.6,10.7,1,1,0,0,0,29.6,11.3);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,10);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

}).prototype = getMCSymbolPrototype(lib.RoundBrush, new cjs.Rectangle(-22.6,-26,107,68), null);


(lib.Drain = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.DrainMiddle();
	this.instance.parent = this;
	this.instance.setTransform(32.3,8.4,1,1,0,0,0,32.3,9.1);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,1);

	this.instance_1 = new lib.DrainRim();
	this.instance_1.parent = this;
	this.instance_1.setTransform(32.3,9,1.123,1.123,0,0,0,36.6,10.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.Drain, new cjs.Rectangle(-8.8,-2.7,82.4,25), null);


(lib.Bucket = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.BrushHandle();
	this.instance.parent = this;
	this.instance.setTransform(30.4,-8.9,1,1,0,0,180,27.2,27.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 3
	this.instance_1 = new lib.BucketScrew();
	this.instance_1.parent = this;
	this.instance_1.setTransform(78.8,27,1,1,0,0,0,2,2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.instance_2 = new lib.BucketHandle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(108.4,42.1,1,1,0,0,0,33.5,19.4);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2},{t:this.instance_1}]}).wait(1));

	// Layer 2
	this.instance_3 = new lib.BucketInside();
	this.instance_3.parent = this;
	this.instance_3.setTransform(66.3,11.5,1,1,0,0,0,36.9,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// Layer 4
	this.instance_4 = new lib.BucketShine();
	this.instance_4.parent = this;
	this.instance_4.setTransform(67.1,12.6,1,1,0,0,0,43.2,13.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// Layer 1
	this.instance_5 = new lib.BucketBody();
	this.instance_5.parent = this;
	this.instance_5.setTransform(67.5,39.5,1,1,0,0,0,43.1,39.5);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

}).prototype = getMCSymbolPrototype(lib.Bucket, new cjs.Rectangle(-1.9,-40.1,150.9,127.1), null);


(lib.bathroomsign = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.bathroomsignwords();
	this.instance.parent = this;
	this.instance.setTransform(57.2,48.4,1,1,0,0,0,48.8,20.5);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#EED8B3").s().p("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");
	this.shape.setTransform(58.4,47.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFDDBE").s().p("ApJFQIAAqgQgYiFCYAFIOUAAQCUAAgUCAIAAKgQALCGiLgGIuUAAIgXABQh6AAARiBg");
	this.shape_1.setTransform(58.6,46.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomsign, new cjs.Rectangle(-0.3,0,117.8,93), null);


(lib.bathroomshelf = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.bathroomshelftop();
	this.instance.parent = this;
	this.instance.setTransform(83.5,3.7,0.832,1,0,0,0,83.5,4.7);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#987C68").s().p("AmFBMQACgCAAgFQAAgLgQgbQgNgUgJgKQgNgRgLgRQgCgDgDgNQgBgCgGgCQgGgDgDAAIgHAEIgFADQgOAAgDAGIgFgLQAAgRAWgBQARgBA8AMQAjADAFgJQAFgJgBBCQAABLgcAMgAGJAGIgvg6QAAgbBQADQAgADAWAHQAZAJAAAMQAAAVgLAkQgIAfgMANIAAgBQAAgCgYgZIgkgjQgGgGgGgJIgLgQQgMgRgLACQgJACAAAKQAAABARAXIAYAcQAmA0AXAAIAGAAQgGADgGAAQgMAAgyg8g");
	this.shape.setTransform(85.4,11.2);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#B6957C").s().p("AmKA+QgNgDgWghIgLgRIgVgZQgggtADAAQACgBAGAJQADgGAOgBIAFgDIAIgDQADAAAFADQAGABABACQAEAOACADQAKARAOASQAIAJANAUQARAbAAALQAAAFgCACIAAABIgXgFgAGhAAIgXgbQgSgXAAgCQAAgKAKgBQALgCALARIALAQQAGAJAHAGIAkAiQAYAaAAABIAAACIgEAFIgDACIgHAAQgXAAgmg1g");
	this.shape_1.setTransform(83.7,12.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomshelf, new cjs.Rectangle(9.1,-6.3,155,25.2), null);


(lib.bathroomdoorwall = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.bathroomdoor_wallpart();
	this.instance.parent = this;
	this.instance.setTransform(354.9,136.7,1,1,0,0,0,354.9,136.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 2
	this.instance_1 = new lib.bathroomdoorshadow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(187.6,159.4,1,1,0,0,0,7.5,114.7);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomdoorwall, new cjs.Rectangle(0,0,709.7,283.7), null);


(lib.BarofSoap2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Shadow
	this.instance = new lib.BarofSoapShadow();
	this.instance.parent = this;
	this.instance.setTransform(17.2,25.8,1,1,0,0,0,13.3,20.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 3
	this.instance_1 = new lib.SoapName();
	this.instance_1.parent = this;
	this.instance_1.setTransform(17.4,24.5,0.861,0.861,0,0,0,6,16.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Bar
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFCCFF").s().p("AgLD8Qh+gDgYhlQgJgqgBhfIABhZQAAheAqgiQAqghBFgKQBFgJA8AkQA8AlAACqQAACqgdAxQgbAwh1AAIgKAAg");
	this.shape.setTransform(17.2,25.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.BarofSoap2, new cjs.Rectangle(0,0,34.5,50.4), null);


(lib.bathroomb = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1));

	// Puddle 4
	this.instance = new lib.Puddle4();
	this.instance.parent = this;
	this.instance.setTransform(329.6,393.8,0.543,0.543,0,0,0,70.5,17.5);
	this.instance.alpha = 0.641;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 30
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#99F5FF").s().p("ABSAvQgFgFAAgFQAAgQASgBQARgBAAASQABAEgDAFQgFAIgKAAQgJAAgEgHgABbAcQgGAAgBAFQAAAGAHAAQAHAAAAgHQAAgEgGAAIgBAAgAhsAnQgDgFgBgGQAAgRASAAQARAAAAARQAAAEgCAFQgFAJgKAAQgKAAgEgHgAhrAZQAAAGAIAAQAFAAABgDIABgCQAAgJgHAAQgIAAAAAIgAAYAdQgDgEAAgKQAAgKACgDQAHgIAWAAQAUAAAHAFQAFADAAALQAAAIgDAFQgJALgcAAQgPAAgFgIgAAtgBQgKAAAAAJQAAAEABACQABABAGAAQAHAAADgEQAAAAABgBQAAAAAAAAQAAgBAAAAQABgBAAAAQgBgJgJAAIAAAAgAhLAVQgDgFAAgFQgBgNALgDIAAgFQAAgVAVAAQAVAAAAAVIAAABQAEgDAHAAQARAAAAAQQgBAEgCAFQgEAIgKAAQgJAAgFgHQgDgFAAgFQgFADgHABIABADQgBAEgDAFQgEAIgKAAQgJAAgFgHgAhGgBQgFABgBAFQAAAAABABQAAAAAAABQAAAAAAAAQABABAAAAIAEACQADAAACgEIAAgDQAAgEgDAAIgCAAgAgYAAQgBAFAGAAQABAAADgEIACgCQAAgFgFAAQgHAAABAGgAg0gbQgJABAAAIQAAAGAHAAQAFAAADgFIADgHQgBgEgEAAIgEABgAADgIQgDgFAAgGIAAAAIgCAAQgJAAgEgIQgEgFgBgEQABgQARgBQAQgBAAASIAAABIADgBQARgBAAASQAAAFgDAFQgFAHgJAAQgJAAgFgGgAAHgeQAAAGAFAAQAEAAACgDIAAgDQAAgEgGAAQgFAAAAAEgAgDgxQgJACAAAEQABAFAFAAQAGAAACgDQADgDAAgBQAAgFgFAAIgDABgAAsgWQgEgFAAgFQAAgTASABQARABAAARQAAAFgCAEQgFAIgKAAQgIAAgGgHgAA1guQgGABAAAGQAAAIAGAAQAEAAABgEIABgEQABgHgGAAIgBAAg");
	this.shape.setTransform(1461.4,206);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("ABZAnQAAgFAHAAQAHgBAAAFQAAAHgIAAQgGAAAAgGgAhmAfQAAgIAHAAQAIAAAAAJIgBACQgBADgGAAQgHAAAAgGgAApAUQgCgCAAgEQAAgKAKAAQAKAAAAAKQAAAAAAABQAAAAAAABQAAAAAAABQgBAAAAAAQgEAEgGAAQgGAAgBgBgAhFAOQAAAAgBgBQAAAAAAAAQAAgBAAAAQgBgBAAAAQAAgFAGgCQAFgBAAAGIAAADQgCAEgEAAIgDgCgAgUAFQAAgFAGAAQAGAAAAAEIgCADQgDAEgBAAQgGAAAAgGgAg4gMQAAgIAIgBQAJgCAAAFIgCAHQgDAFgFAAQgHAAAAgGgAAMgYQAAgEAFAAQAGAAAAAEIAAADQgCADgEAAQgFAAAAgGgAA0ghQAAgGAGgBQAGAAAAAHIgBAEQgBAEgEAAQgGAAAAgIgAgHglQAAgEAIgCQAJgDAAAHQAAABgDADQgDADgFAAQgGAAAAgFg");
	this.shape_1.setTransform(1460.9,205.4);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#99F5FF").s().p("AAFAnQgEgFAAgEQAAgFABgDIgCAAQgIAAgGgHQgEgFAAgEQAAgPASgBQAQgCAAARIgCAJIgDAAQgGACAAAFQAAAHAEAAQAFAAACgEIABgFQAAgFgDAAIAFgBIAEAAQgCgEAAgDQAAgPARgBQASgCAAARIgCAGQAEgCAGAAQARABAAARQAAADgDAGQgFAIgJAAQgKAAgFgHQgDgFAAgEIABgHQgEABgFAAIgDAAIABAHIgDAJQgEAIgKAAQgIAAgGgHgAA3AOQgFACAAAGQAAAHAEAAQADAAACgFIACgFQAAgGgEAAIgCABgAAggGQgHACAAAGIAAAFQAAABABAAQAAABAAAAQABAAABAAQAAABABAAQABAAAKgMQAAgFgGAAIgCABgAgCgEQgGABAAAEIABAEIADACQAEAAABgEIABgDQAAgFgCAAIgCABgAhMAEQgEgEAAgEQAAgQARgBQASgCAAASQAAAEgDAEQgFAIgKAAQgJAAgEgHgAhEgTQgGACAAAFQAAAFAFAAQAEAAADgEIABgDQAAgFgEAAIgDAAgAAxgRQgDgEAAgGQAAgSASAAQARABAAARQAAADgDAGQgFAIgJAAQgKAAgFgHgAA4gqQgGACAAAJIAAAFQABACAFAAQAGAAABgDIAAgEQAAgLgFAAIgCAAg");
	this.shape_2.setTransform(1461,193.1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("AA4AdQAAgGAFgCQAGgCAAAHIgCAFQgCAFgDAAQgEAAAAgHgAALAcQAAgFAGgCIADAAQADAAAAAFIgBAFQgCAEgFAAQgEAAAAgHgAAfAOIAAgFQAAgHAHgCQAIAAAAAEQgKANgBAAQgBAAAAAAQgBgBgBAAQAAAAAAgBQgBAAAAgBgAgBAMIgBgEQAAgFAFgBQAFgCAAAGIgBAEQgCAEgEAAIgCgCgAhEgFQAAgFAGgCQAHgCAAAHIgBADQgDAEgEAAQgFAAAAgFgAA4gTIAAgFQAAgJAGgCQAHgCAAANIAAAEQgBADgGAAQgFAAgBgCg");
	this.shape_3.setTransform(1460.4,192.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

	// Suds
	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AAcAmQAAgGAGgBQAHgCAAAHIgBADQgBAEgFAAQgHAAABgFgABXANQAAgGAHgBQAHgBAAAHIAAACQgCAEgFAAQgHAAAAgFgAgbAKQgBgHAHgBQAGgCAAAGIAAAFQgDAGgEAAQgGAAABgHgAhvADQAAgFAHgBQAIAAgBAFQAAAGgIAAQgGAAAAgFgAhKgFQAAgGAIAAQAIAAAAAGIgBADQgCACgHAAQgGAAAAgFgAAMgIQAAAAAAAAQgBgBAAAAQAAgBAAgBQAAAAAAgBQAAgHALgDQAMgCABAGQAAACgEAEQgFAGgHAAQgGAAgBgCgAgggSQAAgHAHAAQAHgBABAFIgCAEQgDAEgDAAQgHAAAAgFgAA1gdQAAgEAEAAQAHgBAAAFIgBADQgCACgEAAQgEAAAAgFgABggcQAAAAAAAAQgBgBAAAAQAAgBAAgBQAAAAAAgBQAAgIAIgCQAJgBgBALIAAADQgCAEgHAAQgFAAgBgDg");
	this.shape_4.setTransform(1429.1,220.2);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#99F5FF").s().p("AAOAsQgEgFAAgEQAAgQARgBQASgBAAASQAAAEgDAFQgEAHgLABQgIAAgFgIgAAbAXQgGABAAAGQAAAFAGAAQAFAAACgDIABgEQAAgFgFAAIgDAAgAghAUQgEgFAAgFQAAgPANgCQgJAAgFgHQgEgFAAgFQAAgSARAAQASABAAARIgBAEQAIgNAYgDIAHAAQAEgIAMAAQASABAAARQAAAEgDAEQAMAEgBANIgBAIQgFAKgLAAQgIAAgFgGQgJAEgPAAQgOAAgHgEQgBAFgCADQgFAJgJgBQgJABgFgIgAgbgFQgHACAAAFQAAAHAGAAQAEAAACgGIABgDQAAgFgEAAIgCAAgAgWgHIADAAQAEABAEACIAAgDQAAgFACgDIgBAAQgFAHgHABgAAQgdQgMACABAHQAAABAAABQAAAAAAABQAAAAAAABQAAAAABAAQABACAGAAQAHAAAFgFQADgFAAgCQAAgEgGAAIgGABgAgfghQgHAAAAAHQAAAGAGAAQAEAAACgFIACgDQAAgFgGAAIgBAAgAAzgpQgFABAAAEQAAAEAFAAQAEAAABgCIABgCQAAgFgFAAIgBAAgABOASQgFgGAAgEQAAgSASACQARAAAAAQQAAAEgCAFQgFAJgKAAQgIgBgFgHgABYAAQgIAAABAFQgBAFAIAAQAFAAACgDIAAgDQAAgFgGAAIgBABgAhaAJIgBAAQgFAHgKABQgHgBgGgHQgEgFAAgEQAAgPARgCQAJAAAFAEQAFgKAPAAQAVABAAAVIgBAJQgFAJgPAAQgNgBgFgHgAhugKQgHABAAAFQAAAEAFAAQAJAAAAgFQAAgGgGAAIgBABgAhQgNQAAAGAGAAQAHAAACgCIABgEQAAgGgIAAQgIAAAAAGgABSgeQAAgVAVAAQAVABAAATIgDAKQgEAKgOAAQgVAAAAgTgABhgyQgIACAAAIQAAABAAABQAAAAAAABQAAAAAAABQAAAAABAAQAAADAGAAQAHABACgFIAAgDQAAgKgGAAIgCAAg");
	this.shape_5.setTransform(1429.7,221);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_5},{t:this.shape_4}]}).wait(1));

	// Suds
	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#FFFFFF").s().p("AhmAmQAAgFAHABQAHAAAAAFQAAAGgGAAQgIAAAAgHgABZAiIgBgCQAAgJAIAAQAHAAAAAIQAAAGgHAAQgGAAgBgDgAg5ARQAAAAgBAAQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgKAKAAQAKAAAAAKQAAAEgCACQgBABgGAAQgGAAgEgEgAA9AMIAAgDQAAgGAFABQAGACAAAFQAAAAgBABQAAAAAAABQAAAAAAAAQgBABAAAAIgDACQgEAAgCgEgAALAHIgCgDQAAgEAGAAQAGAAAAAFQAAAGgGAAQgBAAgDgEgAAqgLIgCgHQAAgFAJACQAIABAAAIQAAAGgHAAQgFAAgDgFgAgWgVIAAgDQAAgEAGAAQAFAAAAAEQAAAGgFAAQgEAAgCgDgAg+gdIgBgEQAAgHAGAAQAGABAAAGQAAAIgGAAQgEAAgBgEgAgGgjQgDgDAAgBQAAgHAJADQAIACAAAEQAAAFgGAAQgFAAgDgDg");
	this.shape_6.setTransform(266.4,331.7);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#99F5FF").s().p("AhtAuQgCgFgBgEQABgSARABQASABAAAQQAAAFgFAFQgEAHgJAAQgKAAgFgIgAhhAgQAAAHAHAAQAHAAgBgGQAAgFgGAAIgBAAQgGAAAAAEgABQAlQgDgFAAgEQAAgRASAAQARAAAAARQAAAGgDAFQgFAHgJAAQgKAAgFgJgABdAaIABACQABADAGAAQAHAAAAgGQAAgIgHAAQgIAAAAAJgAhQAaQgDgFgBgIQABgLAFgDQAHgFAUAAQAWAAAHAIQACADAAAKQAAAKgDAEQgFAIgPAAQgcAAgJgLgAg2AIQAAAAABABQAAAAAAABQAAAAAAAAQABABAAAAQADAEAHAAQAFAAACgBQACgCAAgEQgBgJgJAAIgBAAQgKAAAAAJgAAwAUQgEgFAAgEIABgDQgHgBgFgDQABAFgEAFQgFAHgJAAQgKAAgEgIQgDgFAAgEQAAgQARAAQAHAAAFADIgBgBQAAgVAVAAQAVAAAAAVIgBAFQALADAAANQABAFgEAFQgFAHgJAAQgKAAgEgIgABCADIAAADQACAEADAAIAEgCQAAAAABgBQAAAAAAAAQAAgBAAAAQABgBAAAAQgBgFgFgBIgCAAQgEAAABAEgAAOgBIACACQACAEACAAQAGAAgBgFQAAgGgFAAQgGAAAAAFgAAsgYIADAHQADAFAFAAQAHAAAAgGQAAgIgJgBIgEgBQgFAAAAAEgAgegJQgDgFAAgFQAAgSASABIACABIAAgBQAAgSAQABQASABAAAQQAAAEgFAFQgEAIgJAAIgCAAIAAAAQAAAGgDAFQgFAGgIAAQgLAAgEgHgAgRgeIAAADQACADADAAQAGAAAAgGQAAgEgFAAQgGAAAAAEgAgEgtQAAABADADQACADAFAAQAHAAAAgFQAAgEgJgCIgEgBQgEAAAAAFgAhIgXQgDgEAAgFQAAgRASgBQASgBgBATQAAAFgDAFQgGAHgIAAQgKAAgFgIgAg6gnIABAEQABAEAEAAQAGAAAAgIQAAgGgGgBIgBAAQgFAAAAAHg");
	this.shape_7.setTransform(266,332.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_7},{t:this.shape_6}]}).wait(1));

	// Layer 26
	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#FFFFFF").s().p("AhbA/QAAgGAGgBQAGgBAAAJIAAAEQgBAEgEAAQgHAAAAgJgAgiA7QAAgLAHgBQAHgCAAAKIgBAGQgBAFgGAAQgGAAAAgHgAAnA7IgBgFQAAgKAHACQAHACAAAHQAAAHgHAAQgFAAgBgDgADNAkQAAgEAEAAQAFgBAAAFIgBADQAAABAAAAQgBAAAAABQgBAAAAAAQgBAAgBAAQgEAAAAgFgABTAhQAAgHAIgCQAJgBAAAGQAAADgCADQgDAFgFAAQgHAAAAgHgAhkAfIAAgHQAAgIAGAAQAGAAAAAJIAAAEQgBAEgGAAQgEAAgBgCgACmAaQAAgGAHgBQAIAAAAAFIgCAEQgCAEgEAAQgHAAAAgGgAjFAVQAAgJAHgCQAHgCAAALIAAAFQgBAFgHAAQgGAAAAgIgAkaARQAAgIAGAAQAFAAAAAFIACAJIgBADQgBACgFAAQgGAAAAgLgAjqAVQAAgFAFAAQAFAAAAAFIgBADQgBADgDAAQgFAAAAgGgAB6ATQAAgGAHAAQAIgBAAAFIgBAEQgCAEgFAAQgHAAAAgGgADjAQQAAgFAIgCQAIgBAAAGQAAACgCADQgDADgGAAQgEAAgBgGgAEMAHQAAgFAHgCQAIgBAAAFIgDAFQgDAEgDAAQgGAAAAgGgAgkAEQgBAAAAgBQAAAAgBgBQAAAAAAgBQAAAAAAgBQAAgEAHgBQAIgCAAAHIgBACQgCAFgDAAQgFAAgCgDgAj/gHQAAgEAGgCQAGgCAAAHIgBADQgCAEgEAAQgFgCAAgEgAiegMIABgEQABgCADAAQAMgCADADIABAGIAAAEQgDAFgIAAQgKAAAAgKgAjLgMQAAgIAGADQAGACAAAEQAAAFgHAAQgFAAAAgGgAB+gPQAAgJAMgEQAMgEAAAIQgPAQgCAAQgHAAAAgHgAAZgJQgFAAAAgGQAAgKALgCQALgCAAAHQAAADgIAKgAhEgTQAAgKAIgDQAJgCAAALIgCAGQgCAGgGAAQgHAAAAgIgADagSQAAgIAJgCQAJgCAAAGIgEAGQgFAGgDAAQgGAAAAgGgABHgbQAAgGAHAAQAIAAAAAGIgBADQgBADgGAAQgHAAAAgGgAi6gkQAAgIAIAAQAHAAAAAHIgCAEQgDADgEAAQgGAAAAgGgAjvgjIAAgEQAAgMAIACQAIABAAAHIgBAEQgCAFgHAAQgFAAgBgDgACvgmIAAgFQAAgKAHgCQAHgBAAAKIAAAGQgBAGgHAAQgFAAgBgEgAh0gqQAAgKAIgBQAIgCAAAJIAAAGQgBAFgIAAQgHAAAAgHgAgcgxQAAgGAJgCQAKgBAAAFIgEAHQgFAFgDAAQgHAAAAgIgAiQg5IgBgFQAAgHAHgCQAHgBAAAFIgDAHQgDAFgCAAQgBAAgBAAQgBAAAAAAQgBAAAAgBQgBAAAAgBg");
	this.shape_8.setTransform(806.4,236.8);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#99F5FF").s().p("AheBMQgFgFAAgHQAAgQAOgCIgBgBIgDgEIgFAAQgTAAAAgQQgIAIgKADIgBACQgFAHgKAAQgJAAgFgHIgCgEQgLAHgRAAQgSAAAAgVQAAgKAHgGQgJAAgFgGQgEgFABgFQAAgPARgCIAAgBQAAggAiAOQATAIAJAIIAAAAIAGAAIAAAAQAAgKADgGQgDACgGAAQgIAAgGgHQgEgFAAgEQAAgPASgCQASgCAAASIgCAHQAFgEAIgBQAOgBAGAKIABAAQASAAAAARQAGgFAKgBQAFgWAdgDQAggCACAfQAGgCAHAAQAXgBAIAPQADgVAUAFQAZAFAAAWIgCAGQAHABAFADIAAAAQgDgGAAgEQAAgOAPgDQAFgEAIAAQALgBAEAHQAEgCAEgBQgDgGAAgGQAAgTAYAAQAQAAAFAHQADAEAAAKQAAAIgCADQgCAGgIACIAAAEQAEgCAGAAQACgOAPABQASAAAAARQAAAFgCAFQgEAHgKAAIgBACIAGgBQASgBAAARQAAAFgCAFQgFAHgJAAIAAADQAAAFgCAEQgFAIgLAAQgJAAgFgFQgDgDgBgEIAAABQgGAJgTAAQgSAAgFgIIgBgBIgFAAQgMAAgFgIIgDAIQgJAQgVAAQgJAAgHgEIgEAGQgIANgNAAQgNAAgEgHQgDgFAAgKIABgJQgFACgFAAIgFAAIAAADQAAAEgCAFQgEAHgIACIAAADQgFAKgSAAQgZAAAAgUQAAgKACgEQAFgIAQAAQgDgFAAgDIABgJQgJAIgOAAIgIgBQABAEAAAEQAAAEgCAFQgEAFgFACQAFAEAAAJQAAAEgDAFQgFAIgLAAQgIAAgGgFgAhZA1QgFABAAAGQAAAJAHAAQAEAAABgEIAAgEQAAgIgFAAIgCAAgAgeAsQgIABAAALQAAAHAHAAQAFAAACgFIABgGQAAgIgFAAIgCAAgAAjAzIAAAFQACADAFAAQAHAAAAgHQAAgHgHgCIgCAAQgFAAAAAIgADOAdQgFAAABAEQgBAFAFAAQABAAAAAAQABAAAAgBQABAAAAAAQABgBAAAAIABgDQAAgEgEAAIgBAAgABYAVQgJACAAAHQAAAHAHAAQAGAAADgFQACgDAAgDQAAgFgHAAIgCAAgAAlAfIAAADQAFgEALAAIAEAAIgBgGQAAgGACgEQgHANgOAEgAhnAVIAAAHQABACAEAAQAFAAABgEIAAgEQABgJgHAAQgFAAAAAIgACqAQQgIABAAAGQABAGAGAAQAFAAACgEIACgEQAAgFgHAAIgBAAgAC5ABIgJAJQASAAABARQAEgIANAAIAAgBIABgGIgHABQgIAAgFgFQgFgFgBgFIgCADgAjBAHQgIACAAAJQABAIAGAAQAHAAABgFIAAgFQAAgKgFAAIgCABgAB+AKQgHAAAAAGQAAAGAGAAQAGAAABgEIABgEQAAgFgFAAIgCABgADoAGQgIACAAAFQABAGAEAAQAGAAADgDQACgDAAgCQAAgFgGAAIgCAAgAgOABQgBAFgEAGIAAABQAEgDAGABIADAAIgDgLIgFABgAA6AMQABgHAGgFIgFgDgAhsgNQADAHAAAIIgBAGQAEgCAGAAIAAgBQAAgQANgBIABgHQgDACgFAAIgEgBQgFAEgJABgAB7AHIAEgFQgFAAgDgCQADADABAEgAgigIQgIABABAFQAAABAAAAQAAABAAAAQAAAAABAAQAAABABAAQACADAFAAQADAAABgEIACgDQAAgGgFAAIgDABgAi7gEIAGgCIgEgBIgCADgAicgVQgDAAgCACIAAAEQAAAKAJAAQAJAAADgFIAAgEIgBgGQgCgCgGAAIgHABgAjOgPQAAAGAFAAQAHAAAAgFQAAgEgGgCIgDgBQgDAAAAAGgACGgfQgLAEAAAJQAAAHAHAAQACAAAPgQQAAgGgFAAIgIACgAAbgeQgKACgBAKQAAAGAGAAIAJAAQAIgKAAgDQAAgFgHAAIgFAAgAhAgjQgHADgBAKQAAAIAIAAQAFAAADgGIABgGQAAgJgFAAIgEAAgADggfQgJACAAAIQAAAGAGAAQADAAAFgGIAEgGQAAgFgFAAIgEABgABEgeQAAAGAHAAQAGAAABgDIABgDQAAgGgIAAQgHAAAAAGgAi9gnQAAAGAGAAQADAAAEgDIACgEQAAgHgIAAQgHAAAAAIgACyg6QgGACgBAKIABAFQABAEAFAAQAGAAABgGIABgGQAAgJgGAAIgCAAgAhvg4QgIABAAAKQAAAHAHAAQAIAAABgFIAAgGQAAgIgGAAIgCABgAgWg8QgJACAAAGQAAAIAHAAQADAAAEgFIAFgHQAAgEgHAAIgDAAgAiNhKQgHACAAAHIABAFQAAABABAAQAAAAABABQAAAAABAAQABAAAAAAQADAAACgFIADgHQAAgEgEAAIgCAAgAj2AbQgEgFgBgEIAAgBIgDAAQgBADgCAEQgEAIgMAAQgIAAgGgFQgEgEAAgHQAAgSASABIAFAAQAAgTARACQASABAAARIAAAAQARAAAAARQAAAFgCAFQgFAHgKAAQgJAAgEgHgAkYAGQgFAAAAAIQAAALAGAAQAFAAABgCIAAgDIgBgJQAAgFgFAAIgBAAgAjtASQAAAGAEAAQAEAAABgDIABgDQAAgFgGAAQgEAAAAAFgAj9gQQgFACAAAEQAAAEAFACQAEAAACgEIABgDQAAgGgFAAIgCABgAEFARQgEgGABgEQAAgOARgCQASgCAAARQAAAFgCAFQgFAIgLAAQgIAAgGgHgAEQgCQgHACAAAEQAAAGAGAAQADAAADgEIACgFQAAgEgEAAIgDABgAj2gcQgEgGgBgEQABgTARABQARAAAAARQAAAEgCAFQgFAJgKAAQgJAAgEgHgAjzgqIABAEQABADAFAAQAGAAACgFIABgEQABgHgJgBIgBgBQgHAAAAALg");
	this.shape_9.setTransform(806.8,237.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_9},{t:this.shape_8}]}).wait(1));

	// Puddle 4
	this.instance_1 = new lib.Puddle4();
	this.instance_1.parent = this;
	this.instance_1.setTransform(857.2,244.2,1,1,0,0,0,70.5,17.5);
	this.instance_1.alpha = 0.641;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	// Drain
	this.instance_2 = new lib.Drain();
	this.instance_2.parent = this;
	this.instance_2.setTransform(366.8,232.4,0.496,0.496,0,0,0,32.3,9.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,0,4);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// Soap Dish
	this.instance_3 = new lib.Bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(416.6,86.6,0.383,0.383,0,0,0,46.4,14.5);
	this.instance_3.alpha = 0.641;
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.instance_4 = new lib.soapdishtogether();
	this.instance_4.parent = this;
	this.instance_4.setTransform(418.8,96.3,0.805,0.805,0,0,0,32.8,12.1);

	this.instance_5 = new lib.BarofSoap2();
	this.instance_5.parent = this;
	this.instance_5.setTransform(418.7,81.4,0.614,0.688,-97.2,0,0,17.4,24.9);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3}]}).wait(1));

	// Layer 28
	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("ABQBEIAAgEQAAgJAGABQAGABAAAGQAAAJgHAAQgEAAgBgEgAAWA9IgBgGQAAgKAHACQAHABAAALQAAAHgGAAQgGAAgBgFgAgzA3QAAgHAHgCQAHgCAAAKIgBAFQgBADgFAAQgHAAAAgHgAjUAnIgBgDQAAgFAFABQAEAAAAAEQAAAFgEAAQgBAAgBAAQAAAAgBAAQAAgBgBAAQAAAAAAgBgAhhAjQgCgDAAgDQAAgGAJABQAIACAAAHQAAAHgHAAQgFAAgDgFgABZAdIAAgEQAAgJAGAAQAGAAAAAIIAAAHQgBACgEAAQgGAAgBgEgAiyAcIgCgEQAAgFAIAAQAHABAAAGQAAAGgHAAQgEAAgCgEgAC4AYIAAgFQAAgLAHACQAHACAAAJQAAAIgGAAQgHAAgBgFgAEPAaIgBgDIACgJQAAgFAFAAQAGAAAAAIQAAALgGAAQgFAAgBgCgADiAYIgBgDQAAgFAFAAQAFAAAAAFQAAAGgFAAQgDAAgBgDgAiHAVIgBgEQAAgFAIABQAHAAAAAGQAAAGgHAAQgFAAgCgEgAjwATQgCgDAAgCQAAgGAIABQAIACAAAFQgBAGgEAAQgGAAgDgDgAkXAJIgDgFQAAgFAIABQAHACAAAFQAAAGgGAAQgDAAgDgEgAAZACIgBgCQAAgHAIACQAHABAAAEQAAABAAAAQAAABAAAAQAAABgBAAQAAABgBAAQgCADgFAAQgDAAgCgFgAD1gFIgBgDQAAgHAGACQAGACAAAEQAAAEgFACQgEAAgCgEgACKgHIAAgEIABgGQADgDAMACQADAAABACIABAEQAAAKgKAAQgIAAgDgFgADAgLQAAgEAGgCQAGgDAAAIQAAAGgFAAQgHAAAAgFgAiVgYQAAgIAMAEQAMAEAAAJQAAAHgHAAQgCAAgPgQgAghgJQgIgKAAgDQAAgHALACQALACAAAKQAAAGgFAAgAA2gRIgCgGQAAgLAJACQAIADAAAKQAAAIgHAAQgGAAgCgGgAjngSIgEgGQAAgGAJACQAJACAAAIQAAAGgGAAQgDAAgFgGgAhUgYIgBgDQAAgGAIAAQAHAAAAAGQAAAGgHAAQgGAAgBgDgACughIgCgEQAAgHAHAAQAIAAAAAIQAAAGgGAAQgEAAgDgDgADhglIgBgEQAAgHAIgBQAIgCAAAMIAAAEQgBADgFAAQgHAAgCgFgAi8goIAAgGQAAgKAHABQAHACAAAKIAAAFQgBAEgFAAQgHAAgBgGgABlgoIAAgGQAAgJAIACQAIABAAAKQAAAHgHAAQgIAAgBgFgAAOguIgEgHQAAgFAKABQAJACAAAGQAAAIgHAAQgDAAgFgFgACHg8IgDgHQAAgFAHABQAHACAAAHIgBAFQAAABgBAAQAAABgBAAQAAAAgBAAQgBAAgBAAQgCAAgDgFg");
	this.shape_10.setTransform(474.7,220.7);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#99F5FF").s().p("ABBBJQgDgFAAgEQAAgJAEgEQgEgCgDgFQgEgFAAgEQABgEABgEIgIABQgOAAgJgIIABAJQAAADgCAFQAPAAAEAIQADAEAAAKQAAAUgZAAQgSAAgEgKIgBgDQgIgCgDgHQgEgFAAgEIABgDIgFAAQgFAAgEgCIABAJQAAAKgEAFQgEAHgNAAQgMAAgKgNIgCgGQgIAEgJAAQgUAAgKgQIgEgIQgEAIgMAAIgFAAIAAABQgHAIgRAAQgTAAgGgJIAAgBQAAAEgEADQgFAFgJAAQgLAAgEgIQgDgEAAgFIAAgDQgKAAgDgHQgCgFAAgFQAAgRARABIAFABIAAgCQgKAAgEgHQgCgFAAgFQAAgRARAAQAPgBACAOQAHAAADACIAAgEQgHgCgDgGQgBgDAAgIQAAgKADgEQAFgHAQAAQAYAAAAATQAAAGgDAGQAEABAEACQAEgHALABQAIAAAFAEQAQADAAAOQAAAEgFAGIAAAAQAGgDAHgBIgCgGQAAgWAYgFQAWgFACAVQAIgPAWABQAIAAAGACQACgfAgACQAdADAFAWQAKABAGAFQAAgRARAAIACAAQAFgKAOABQAJABAFAEIgBgHQgBgSATACQARACAAAPQAAAEgEAFQgGAHgIAAQgGAAgDgCQACAGAAAKIAAAAIAHAAIABAAQAHgIAVgIQAhgOAAAgIAAABQARACABAPQAAAFgEAFQgFAGgIAAQAFAGAAAKQAAAVgRAAQgRAAgLgHIgDAEQgEAHgKAAQgJAAgFgHIgBgCQgLgDgGgIQAAAQgUAAIgGAAIgCAEIAAABQANACgBAQQAAAHgEAFQgGAFgIAAQgLAAgFgIgABTA9IAAAEQACAEAEAAQAGAAAAgJQAAgGgGgBIgBAAQgFAAAAAIgAAZA0IAAAGQABAFAHAAQAFAAAAgHQAAgLgGgBIgDAAQgEAAAAAIgAgpArQgHACAAAHQAAAHAHAAQAFAAABgDIABgFQAAgIgFAAIgCAAgAjSAhIABADQAAAAABABQAAAAAAAAQABABABAAQAAAAABAAQAFAAAAgFQAAgEgFAAIgBAAQgEAAAAAEgAhgAaQAAADACADQADAFAFAAQAIAAgBgHQAAgHgIgCIgCAAQgHAAAAAFgAg3AYIAAAGIACAAQAMAAAFAEIAAgDQgOgEgGgNIABAKgABcAWIAAAEQABAEAGAAQAEAAABgCIABgHQgBgIgGAAQgFAAgBAJgAixAVIACAEQACAEAEAAQAIAAAAgGQgBgGgHgBIgBAAQgHAAAAAFgAjSASIAAABQALAAAEAIQACgRATAAIgJgJIgEgDQAAAFgEAFQgGAFgIAAIgHgBIACAGgAC7AQIAAAFQACAFAGAAQAHAAgBgIQAAgJgGgCIgDgBQgFAAAAAKgAiFAOIABAEQACAEAFAAQAHAAAAgGQAAgGgHAAIgCgBQgGAAAAAFgAjvALQAAACACADQADADAGAAQAEAAABgGQAAgFgIgCIgCAAQgGAAAAAFgAAUANIgBgBQgDgGgBgFIgGgBIgCALIACAAIACAAQAGAAADACgAg/AAQAFAFACAHIgDgPIgEADgABTgMQAOABAAAQIAAABQAGAAAEACIgBgGQAAgIACgHQgIgBgFgEIgFABQgEAAgEgCIABAHgAh+ACIADAFQACgEADgDQgDACgFAAgAAbgDIABADQADAEADAAQAEAAADgDQAAAAAAgBQABAAAAAAQAAAAAAgBQABAAAAgBQAAgFgIgBIgDgBQgFAAAAAGgAC2gGIAGACIgBgDIgFABgACOgUIgBAGIABAEQACAFAJAAQAJAAAAgKIgBgEQgBgCgDAAIgHgBQgGAAgCACgADJgUQgGACAAAEQAAAFAHAAQAFAAAAgGQAAgGgDAAIgDABgAiRgbQAOAQADAAQAGAAAAgHQAAgJgMgEIgHgCQgEAAAAAGgAgmgZQAAADAJAKIAIAAQAGAAgBgGQABgKgLgCIgFAAQgHAAAAAFgAA3gaIACAGQACAGAGAAQAHAAAAgIQABgKgJgDIgDAAQgFAAgBAJgAjogbIAEAGQAFAGADAAQAGAAAAgGQAAgIgJgCIgEgBQgFAAAAAFgAhRgeIAAADQACADAFAAQAHAAAAgGQAAgGgHAAQgHAAAAAGgACvgoIADAEQACADAFAAQAFAAAAgGQAAgIgIAAQgHAAAAAHgAi5gxIAAAGQACAGAGAAQAFAAABgEIAAgFQABgKgIgCIgBAAQgGAAAAAJgABogxIAAAGQACAFAHAAQAHAAAAgHQAAgKgIgBIgCgBQgGAAAAAIgAAOg4IAEAHQAEAFAEAAQAGAAAAgIQAAgGgJgCIgDAAQgGAAAAAEgACHhGIADAHQAEAFABAAQABAAABAAQABAAAAAAQABgBAAAAQABAAAAgBIABgFQAAgHgGgCIgDAAQgFAAAAAEgADbAbQgCgFgBgFQAAgRASAAIAAAAQAAgRARgBQARgCABATIAFAAQASgBABASQgBAHgEAEQgFAFgJAAQgLAAgFgIQgDgEAAgDIgEAAIAAABQAAAEgDAFQgGAHgIAAQgLAAgEgHgAETALIgCAJIABADQABACAFAAQAGAAAAgLQAAgIgGAAIAAAAQgFAAAAAFgADkASIABADQACADACAAQAFAAAAgGQAAgFgFAAQgFAAAAAFgAD4gLIABADQABAEAEAAQAFgCAAgEQAAgEgGgCIgBgBQgEAAAAAGgAkhAQQgCgFAAgFQAAgRARACQARACAAAOQAAAEgEAGQgFAHgIAAQgLAAgEgIgAkXABIADAFQADAEADAAQAGAAAAgGQAAgEgHgCIgDgBQgEAAgBAEgADbgeQgCgFgBgEQAAgRASAAQASgBgBATQAAAEgDAGQgGAHgIAAQgLAAgEgJgADrg0QgHABgBAHIABAEQADAFAGAAQAFAAABgDIAAgEQABgLgHAAIgCABg");
	this.shape_11.setTransform(474.4,221);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_11},{t:this.shape_10}]}).wait(1));

	// Puddle 1
	this.instance_6 = new lib.Puddle1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(496,234.1,1,1,0,0,0,69.2,15);
	this.instance_6.alpha = 0.641;

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(1));

	// drain bubbles
	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AgnAnIgBgDQAAgHAHACQAHABgBAGQAAAFgFAAQgGAAgBgEgAhkAOIgBgCQAAgHAIABQAHABAAAGQAAAFgHAAQgGAAgBgEgAAQALIgBgFQABgGAGACQAHABAAAHQAAAHgGAAQgEAAgDgGgABhACQABgFAGAAQAIABAAAFQgBAFgFAAQgJAAAAgGgAA7gCIgBgDQAAgGAJAAQAHAAABAGQAAAFgHAAQgGAAgDgCgAgegMQgEgEABgCQAAgGAMACQALADAAAHQAAABAAAAQAAABAAABQAAAAgBABQAAAAAAAAQgBACgHAAQgGAAgFgGgAAUgRIgBgEQAAgFAGABQAIAAgBAHQABAFgHAAQgEAAgCgEgAg+gaIgBgDQABgFAFABQAFAAABAEQgBAFgFAAQgDAAgCgCgAhugdIgBgDQAAgLAIABQAJACAAAIQAAABAAAAQAAABAAABQAAAAgBABQAAAAAAAAQgBADgFAAQgHAAgCgEg");
	this.shape_12.setTransform(260.1,360);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#99F5FF").s().p("AgpAsQgDgGAAgDQAAgTARACQASABAAAQQAAAEgDAFQgGAIgJAAQgKgBgEgHgAgiAcIACADQABAEAFAAQAGAAAAgFQAAgGgHgBIgCAAQgFAAAAAFgAAGATQgDgEAAgEQgGADgPAAQgOAAgKgDQgEAFgJABQgMgBgEgJIgCgIQABgOAKgDQgCgEAAgEQAAgRARAAQAMgBAFAIIAHABQAYADAHALIgBgDQABgRARgBQASAAAAASQAAAFgDAFQgGAHgJAAQANACAAAPQAAAFgEAFQgFAIgIAAQgKAAgFgJgAAWAAIABADQADAGAEAAQAFAAAAgHQAAgFgHgCIgCAAQgEAAAAAFgAAMgHIAAADQADgCAGgBIACAAQgHgBgFgHIgBAAQACAEAAAEgAgbgZQAAABAEAFQAEAFAHAAQAGAAACgBQAAgBAAAAQAAgBAAAAQAAgBAAAAQABgBAAgBQAAgHgMgDIgGAAQgGAAAAAFgAAZgcIABADQADAFAEgBQAGABAAgGQAAgGgHgBIgBAAQgGAAAAAFgAg4gkIABACQABADAEgBQAFAAAAgEQAAgFgFAAIgBAAQgFAAAAAFgAhoARQgEgEAAgEQAAgRASAAQARgCAAATQAAAEgDAFQgGAIgIAAQgKAAgEgJgAheAEIABADQABADAGAAQAGAAAAgFQAAgFgGAAIgCgBQgGAAAAAFgABcAJIgBAAQgFAIgNAAQgPgBgFgIIgBgJQAAgVAVgBQAQAAAFAKQADgFAJACQASABAAAPQAAAEgEAFQgFAIgJAAQgJAAgFgIgABogFQAAAFAJABQAFgBAAgEQAAgGgHAAIgBgBQgGAAAAAGgABBgNIABAEQADACAGAAQAGAAAAgGQAAgGgIAAQgIAAAAAGgAh4gVIgDgKQAAgUAVAAQAVABgBATQABAUgVgBQgPABgDgKgAhogoIABADQABAEAIAAQAEAAABgCQABgBAAAAQAAgBAAAAQAAgBAAAAQAAgBAAgBQABgIgJgCIgCAAQgGAAAAAKg");
	this.shape_13.setTransform(259.5,360.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_13},{t:this.shape_12}]}).wait(1));

	// Layer 32
	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#FFFFFF").s().p("AhAAfIgCgFQAAgHAGACQAFACAAAGQAAAHgEAAQgDAAgCgFgAgVAfIgBgFQAAgFADAAIADAAQAGACAAAFQAAAHgEAAQgFAAgCgEgAgtAEQAAgEAIAAQAHACAAAHIAAAFQAAABgBAAQAAABAAAAQgBAAgBABQAAAAgBAAQgBAAgKgNgAgGAKIgBgEQAAgGAFACQAFABAAAFIgBAEIgCACQgEAAgCgEgAA5gEIgBgDQAAgHAHACQAGACAAAFQAAAFgFAAQgEAAgDgEgAhEgUIAAgEQAAgNAHACQAGACAAAJIAAAFQgBACgFAAQgGAAgBgDg");
	this.shape_14.setTransform(283.8,357.2);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#99F5FF").s().p("AggAmIgDgJIABgHIgDAAQgFAAgEgBIABAHQAAAEgDAFQgFAHgKAAQgJAAgFgIQgDgGAAgDQAAgRARgBQAGAAAEACIgCgGQAAgRASACQARABAAAPQAAADgCAEIAEAAIAFABQgDAAAAAFIABAFQACAEAFAAQAEAAAAgHQAAgFgGgCIgDAAIgCgJQAAgRAQACQASABAAAPQAAAEgEAFQgGAHgIAAIgCAAQABADAAAFQAAAEgEAFQgGAHgIAAQgKAAgEgIgAg8ATIACAFQACAFADAAQAEAAAAgHQAAgGgFgCIgCgBQgEAAAAAGgAgngCQAKAMABAAQABAAAAgBQABAAABAAQAAAAAAgBQABAAAAgBIAAgFQAAgGgHgCIgCgBQgGAAAAAFgAgBAAIABADQABAEAEAAIADgCIABgEQAAgEgGgBIgCgBQgCAAAAAFgAAxADQgDgEAAgEQAAgSASACQARABAAAQQAAAEgEAEQgEAHgJAAQgKAAgFgIgAA+gOIABADQADAEAEAAQAFAAAAgFQAAgFgGgCIgDAAQgEAAAAAFgAhNgSQgDgGAAgDQAAgRARgBQASAAAAASQAAAGgDAEQgFAHgKAAQgJAAgFgIgAg+gfIAAAEQABADAGAAQAFAAABgCIAAgFQAAgJgGgCIgCAAQgFAAAAALg");
	this.shape_15.setTransform(283.2,357.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_15},{t:this.shape_14}]}).wait(1));

	// Layer 33
	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#FFFFFF").s().p("AhmAmQAAgFAHABQAHAAAAAFQAAAGgGAAQgIAAAAgHgABZAiIgBgCQAAgJAIAAQAHAAAAAIQAAAGgHAAQgGAAgBgDgAg5ARQAAAAgBAAQAAgBAAAAQAAgBAAAAQAAgBAAAAQAAgKAKAAQAKAAAAAKQAAAEgCACQgBABgGAAQgGAAgEgEgAA9AMIAAgDQAAgGAFABQAGACAAAFQAAAAgBABQAAAAAAABQAAAAAAAAQgBABAAAAQAAAAgBABQAAAAgBAAQAAABgBAAQAAAAAAAAQgEAAgCgEgAALAHIgCgDQAAgEAGAAQAGAAAAAFQAAAGgGAAQgBAAgDgEgAAqgLIgCgHQAAgFAJACQAIABAAAIQAAAGgHAAQgFAAgDgFgAgWgVIAAgDQAAgEAGAAQAFAAAAAEQAAAGgFAAQgEAAgCgDgAg+gdIgBgEQAAgHAGAAQAGABAAAGQAAAIgGAAQgEAAgBgEgAgGgjQgDgDAAgBQAAgHAJADQAIACAAAEQAAAFgGAAQgFAAgDgDg");
	this.shape_16.setTransform(263.7,276.2);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#99F5FF").s().p("AhtAuQgCgFgBgEQAAgSASABQASABAAAQQAAAFgFAFQgEAHgJAAQgKAAgFgIgAhhAgQAAAHAHAAQAHAAgBgGQAAgFgGAAIgBAAQgGAAAAAEgABQAlQgDgFAAgEQAAgRASAAQARAAABARQgBAGgDAFQgFAHgJAAQgKAAgFgJgABdAaIABACQABADAGAAQAHAAAAgGQAAgIgHAAQgIAAAAAJgAhQAaQgDgFgBgIQABgLAFgDQAHgFAUAAQAWAAAHAIQACADAAAKQAAAKgDAEQgFAIgPAAQgcAAgJgLgAg2AIQAAAAABABQAAAAAAABQAAAAAAAAQABABAAAAQADAEAHAAQAFAAACgBQACgCAAgEQgBgJgJAAIgBAAQgKAAAAAJgAAwAUQgEgFAAgEIABgDQgHgBgFgDQABAFgEAFQgFAHgJAAQgKAAgEgIQgDgFAAgEQAAgQARAAQAHAAAFADIgBgBQAAgVAVAAQAVAAAAAVIgBAFQALADAAANQABAFgEAFQgFAHgJAAQgKAAgEgIgABCADIAAADQACAEADAAQABAAAAAAQABAAAAgBQABAAAAAAQAAgBABAAQAAAAABgBQAAAAAAAAQAAgBAAAAQAAgBAAAAQAAgFgFgBIgCAAQgEAAABAEgAAOgBIACACQACAEACAAQAGAAgBgFQAAgGgFAAQgGAAAAAFgAAsgYIADAHQADAFAFAAQAHAAAAgGQAAgIgJgBIgEgBQgFAAAAAEgAgegJQgDgFAAgFQAAgSASABIACABIAAgBQAAgSAQABQASABAAAQQAAAEgFAFQgEAIgJAAIgCAAIAAAAQAAAGgDAFQgFAGgIAAQgLAAgEgHgAgRgeIAAADQACADADAAQAGAAAAgGQAAgEgFAAQgGAAAAAEgAgEgtQAAABADADQACADAFAAQAHAAAAgFQAAgEgJgCIgEgBQgEAAAAAFgAhIgXQgDgEAAgFQAAgRASgBQARgBAAATQAAAFgDAFQgGAHgIAAQgKAAgFgIgAg6gnIAAAEQACAEAEAAQAGAAAAgIQAAgGgGgBIgBAAQgFAAAAAHg");
	this.shape_17.setTransform(263.3,276.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_17},{t:this.shape_16}]}).wait(1));

	// Tile Floor
	this.instance_7 = new lib.bathroombfloor();
	this.instance_7.parent = this;
	this.instance_7.setTransform(445.7,226.6,1.049,0.527,0,9.7,0,383.6,54.8);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.instance_8 = new lib.bathroombfloor2();
	this.instance_8.parent = this;
	this.instance_8.setTransform(358.6,296.3,1.457,0.923,0,9.7,0,383.3,54.6);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8},{t:this.instance_7}]}).wait(1));

	// Floor Grout
	this.instance_9 = new lib.FloorGroutb();
	this.instance_9.parent = this;
	this.instance_9.setTransform(435.1,269.7,1,1,0,0,0,435.1,70.9);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",4,-2,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(1));

	// Wall
	this.instance_10 = new lib.Wall();
	this.instance_10.parent = this;
	this.instance_10.setTransform(433,155.8,1,1,0,0,0,311.7,155.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomb, new cjs.Rectangle(-433.2,-254,2231.5,756.1), null);


(lib.bathroomentrance = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.BarofSoap2();
	this.instance.parent = this;
	this.instance.setTransform(-280.1,-117.6,0.443,0.495,0,-88.2,-84.1,17.3,24.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.instance_1 = new lib.bathroombackgroundrubberduck();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-304.2,-119.5,0.244,0.229,0,3.6,180,44.3,45.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,4);

	this.instance_2 = new lib.bathroomshelf();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-313.2,-104.4,0.942,1,0,0,0,75,5.5);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.instance_3 = new lib.bathroomsign();
	this.instance_3.parent = this;
	this.instance_3.setTransform(202.8,-61,0.569,0.569,0,0,0,124.5,46.4);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

	// Layer 3
	this.instance_4 = new lib.towel_background();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-268.4,-39.8,0.448,0.475,0,42.7,65.3,198.3,-2.7);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);

	this.instance_5 = new lib.towelrack_background();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-270.2,-31.2,0.711,0.832,0,0,0,65.6,6.7);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.instance_6 = new lib.towel_background();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-259.8,-35.4,0.386,0.379,0,-43.4,114,198.3,-2.8);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,-1,7);
	this.instance_6.filters = [new cjs.ColorFilter(0.32, 0.32, 0.32, 1, 133.28, 124.44, 119, 0)];
	this.instance_6.cache(179,-44,156,141);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4}]}).wait(1));

	// Layer 5
	this.instance_7 = new lib.RoundBrush();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-312.2,108.6,0.422,0.422,0,0,0,29.6,11.2);

	this.instance_8 = new lib.Bucket();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-308.3,81.9,0.565,0.565,0,0,0,43.1,39.5);

	this.instance_9 = new lib.Puddle4();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-319.3,100.9,0.543,0.375,0,0,0,70.5,17.5);
	this.instance_9.alpha = 0.641;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7}]}).wait(1));

	// Layer 2
	this.instance_10 = new lib.bathroomdoorwall();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-35.1,-44.6,1,1,0,0,0,354.9,136.7);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",3,0,13);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(1));

	// Layer 1
	this.instance_11 = new lib.blueline_bathroombackground();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-153.1,80.2,1,1,0,0,0,107.7,4);

	this.instance_12 = new lib.bathroomb();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-6.9,-1,0.509,0.509,0,0,0,673.6,135);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.bathroomentrance, new cjs.Rectangle(-571.3,-198.8,1138.8,388.4), null);


// stage content:
(lib.Intro = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// FrameGuide
	this.instance = new lib.safeguide("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(660.1,389.9,1,1,0,0,0,0.8,-0.7);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(54));

	// background
	this.instance_1 = new lib.bathroomentrance();
	this.instance_1.parent = this;
	this.instance_1.setTransform(670.5,397.7,2,2);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(54));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(191,389.8,2269.5,780.2);
// library properties:
lib.properties = {
	width: 1320,
	height: 780,
	fps: 24,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [],
	preloads: []
};




})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib, images, createjs, ss, AdobeAn;